webpackJsonp([0,2],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventDictionaryStandard__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventPayload__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__storeEvent__ = __webpack_require__(192);




var CONSOLE_LOG_EVENT_NAME = false;
var CONSOLE_LOG_EVENT_PROPS = false;

/* harmony default export */ __webpack_exports__["a"] = function (eventName, options, cb) {
  var amplitudeEventName = __WEBPACK_IMPORTED_MODULE_0__eventDictionaryStandard__["a" /* default */][eventName];
  var payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__eventPayload__["a" /* default */])(options);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__storeEvent__["a" /* default */])(amplitudeEventName, payload, cb);
  printEvent(amplitudeEventName, payload);
};

var printEvent = function printEvent(amplitudeEventName, payload) {
  if (CONSOLE_LOG_EVENT_NAME) {
    console.log('EVT --> ', amplitudeEventName);
  }

  if (CONSOLE_LOG_EVENT_PROPS) {
    for (var key in payload) {
      console.log('prop --> ' + key + ' => ' + String(payload[key]).substr(0, 50));
    }
  }
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(490),
  /* scopeId */
  "data-v-79b256cd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  "data-v-e28969e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(340)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(478),
  /* scopeId */
  "data-v-5353a330",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(489),
  /* scopeId */
  "data-v-7791db6f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./adobe.png": 122,
	"./amazon.png": 123,
	"./analytics.png": 124,
	"./cvs.png": 125,
	"./dcm.png": 126,
	"./facebook.png": 127,
	"./gmail.png": 128,
	"./google.png": 129,
	"./instacart.png": 130,
	"./instagram.png": 131,
	"./kroger.png": 132,
	"./messenger.png": 133,
	"./pinterest.png": 134,
	"./salesforce.png": 135,
	"./sephora.png": 136,
	"./snapchat.png": 137,
	"./target.png": 138,
	"./tradedesk.png": 139,
	"./twitter.png": 140,
	"./ulta.png": 141,
	"./walgreens.png": 142,
	"./walmart.png": 143,
	"./whatsapp.png": 144,
	"./youtube.png": 145,
	"./zappos.png": 146
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  social: ['facebook', 'snapchat', 'pinterest', 'twitter', 'instagram', 'messenger', 'gmail', 'whatsapp', 'google'],
  audience: ['salesforce', 'analytics', 'tradedesk', 'dcm', 'adobe', 'facebook', 'snapchat', 'pinterest', 'twitter'],
  commerce: ['amazon', 'target', 'walmart', 'kroger', 'instacart', 'ulta', 'sephora', 'walgreens', 'cvs']
};

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iphone-7-white.9fe82dbd.png";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-16.02291bb8.png";

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  scrollListener: function scrollListener(divId, topThreshold, bottomThreshold) {
    topThreshold = topThreshold || 100;
    bottomThreshold = bottomThreshold || 50;
    var scrollTop = $(window).scrollTop(),
        elementOffset = $("#" + divId).offset().top,
        height = $("#" + divId).height(),
        distance = elementOffset - scrollTop;

    if (distance < topThreshold && height + distance > bottomThreshold) {
      return true;
    } else {
      return false;
    }
  }
};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(499),
  /* scopeId */
  "data-v-d089575c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(496),
  /* scopeId */
  "data-v-8d869362",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./adlandia.png": 73,
	"./adweek.png": 74,
	"./banana-republic.png": 75,
	"./benefit-cosmetics.png": 76,
	"./bloomberg.png": 77,
	"./bose.png": 78,
	"./business-of-fashion.png": 79,
	"./campbells.png": 80,
	"./cheddar.png": 81,
	"./clorox.png": 82,
	"./digiday.png": 83,
	"./dove.png": 84,
	"./emarketer.png": 85,
	"./entrepreneur.png": 86,
	"./estee-lauder.png": 87,
	"./fast-company.png": 88,
	"./forbes.png": 89,
	"./general-mills.png": 90,
	"./gopro.png": 91,
	"./gsk.png": 92,
	"./inc.png": 93,
	"./interbrand.png": 94,
	"./internet-retailer.png": 95,
	"./lego.png": 96,
	"./levis.png": 97,
	"./loreal.png": 98,
	"./lvmh.png": 99,
	"./makeup-forever.png": 100,
	"./marieclaire.png": 101,
	"./mediapost.png": 102,
	"./mondelez.png": 103,
	"./nestle.png": 104,
	"./olay.png": 105,
	"./oreo.png": 106,
	"./pandg.png": 107,
	"./pepperidge-farm.png": 108,
	"./psfk.png": 109,
	"./revlon.png": 110,
	"./t-mobile.png": 111,
	"./techcrunch.png": 112,
	"./under-armour.png": 113,
	"./unilever.png": 114,
	"./wall-street-journal.png": 115,
	"./zappos.png": 116
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = function (eventName) {
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  landingPageEvent(eventName, obj);
};

var landingPageEvent = function landingPageEvent(eventName, obj) {
  if (window.fbq) {
    window.fbq('track', eventName, obj);
  } else {
    setTimeout(function () {
      landingPageEvent(eventName, obj);
    }, 500);
  }
};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sources = {
  home: 'https://px.ads.linkedin.com/collect/?pid=1430129&conversionId=1249281&fmt=gif',
  contact: 'https://px.ads.linkedin.com/collect/?pid=1430129&conversionId=1249297&fmt=gif',
  holiday2019: 'https://px.ads.linkedin.com/collect/?pid=1430129&conversionId=1249289&fmt=gif'
};

/* harmony default export */ __webpack_exports__["a"] = function (source) {
  var imgTag = document.createElement('img');
  imgTag.height = '1';
  imgTag.width = '1';
  imgTag.style = 'display:none;';
  imgTag.src = sources[source];

  document.body.appendChild(imgTag);
};

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inc-500.f0c4eadd.png";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-logo-black.5883ae2b.png";

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-logo-white-new.16db1e0f.png";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-amazon.279eb5ad.png";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-target.ba1e0151.png";

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-walmart.ad44142c.png";

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-audiences.88a4310c.png";

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-macbook-1.915f699c.png";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-gradient-logo-2.b9228d23.png";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/step-amazon.e3d3c0ac.png";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  "data-v-6144b7d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/adlandia.439b259f.png";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/adweek.a3c0f25c.png";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banana-republic.32b84686.png";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/benefit-cosmetics.661df19b.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bloomberg.ad04e28c.png";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bose.ca6afa9c.png";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/business-of-fashion.353a146a.png";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/campbells.66876713.png";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cheddar.5b639110.png";

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clorox.6758b237.png";

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/digiday.223c3f99.png";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dove.7b8f906e.png";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/emarketer.f1a6deb3.png";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/entrepreneur.1c894b65.png";

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/estee-lauder.a9d2f69a.png";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fast-company.752c3c01.png";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/forbes.0fb61cc8.png";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/general-mills.87c7b5d0.png";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gopro.bfbbd061.png";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gsk.b40e897d.png";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inc.821988cc.png";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/interbrand.421b1c59.png";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/internet-retailer.bbee6f84.png";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lego.7cc88b62.png";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/levis.c6c347c4.png";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loreal.0b9644d8.png";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lvmh.a702564b.png";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/makeup-forever.2b49cd1c.png";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/marieclaire.3ac7f291.png";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mediapost.eb9d8282.png";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mondelez.6a4d5acc.png";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nestle.9d622bba.png";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/olay.c4cd74c8.png";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/oreo.180bd11e.png";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pandg.23f9d9b5.png";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pepperidge-farm.8a82413d.png";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/psfk.7abafb67.png";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/revlon.14090d3b.png";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/t-mobile.9f353208.png";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/techcrunch.f2470dc6.png";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/under-armour.c150688c.png";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/unilever.4ba587d4.png";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wall-street-journal.97a5587e.png";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zappos.c264c872.png";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fb-partners.630d18b8.png";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ig-partners.9cd61833.png";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/measure-screenshot.8d743b2b.png";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-logo-new.79ff9c16.png";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/snapchat-partners.74497cfd.png";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/adobe.58daa0b4.png";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/amazon.50eaef83.png";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/analytics.40b086e9.png";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cvs.e2ddd7dc.png";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dcm.b0130017.png";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/facebook.03550f52.png";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gmail.47a895aa.png";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google.faf7b760.png";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/instacart.5cc1a471.png";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/instagram.994e1eea.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/kroger.af60e0ec.png";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/messenger.82725bef.png";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pinterest.602d4ead.png";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/salesforce.1dca0622.png";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sephora.01ee2703.png";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/snapchat.954f2db2.png";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/target.6ef4a11b.png";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tradedesk.f57b1cc5.png";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/twitter.8e2f4960.png";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ulta.4b1c6af9.png";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/walgreens.dd01f13e.png";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/walmart.1e5cfb04.png";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/whatsapp.26e5c6a9.png";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/youtube.637287e8.png";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zappos.8383a027.png";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/atc-button.9b52d2bf.png";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-cvs.0db2fdc5.png";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-levi.678728ad.png";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-loreal.1b9b48e7.png";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-macys.9cb4bb00.png";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-secret.08b4bc0d.png";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-sephora.04a88b63.png";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-tomford.eab95d77.png";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkout-ua.239bf673.png";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/feature-one.917564ff.png";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-optimize.7753955d.png";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-1.a6f2d455.png";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-10.b0ad5927.png";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-11.cb280424.png";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-12.37e4da61.png";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-13.61d6509a.png";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-14.6c581773.png";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-15.e704cd09.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-2.d0a7542f.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-3.8bdef9f5.png";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-4.3f11d6e8.png";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-5.bb209a70.png";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-6.60d1a5bb.png";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-7.67f20042.png";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-8.71ebf2a7.png";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-phone-9.e6c84068.png";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-gradient-logo-1.a7afee95.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secret-desktop-2.aa2608a7.png";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secret-desktop.b68fa86e.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/secret-mobile.8aed3121.png";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/step-verticals.9b19016f.png";

/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(494),
  /* scopeId */
  "data-v-87d9fbea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_App__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(209);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });







__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_extends___default()({
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_3__views_App___default.a));



/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./app-store.png": 366,
	"./attach-gif-demo.gif": 367,
	"./black-device.png": 368,
	"./brand-logos/adlandia.png": 73,
	"./brand-logos/adweek.png": 74,
	"./brand-logos/banana-republic.png": 75,
	"./brand-logos/benefit-cosmetics.png": 76,
	"./brand-logos/bloomberg.png": 77,
	"./brand-logos/bose.png": 78,
	"./brand-logos/business-of-fashion.png": 79,
	"./brand-logos/campbells.png": 80,
	"./brand-logos/cheddar.png": 81,
	"./brand-logos/clorox.png": 82,
	"./brand-logos/digiday.png": 83,
	"./brand-logos/dove.png": 84,
	"./brand-logos/emarketer.png": 85,
	"./brand-logos/entrepreneur.png": 86,
	"./brand-logos/estee-lauder.png": 87,
	"./brand-logos/fast-company.png": 88,
	"./brand-logos/forbes.png": 89,
	"./brand-logos/general-mills.png": 90,
	"./brand-logos/gopro.png": 91,
	"./brand-logos/gsk.png": 92,
	"./brand-logos/inc.png": 93,
	"./brand-logos/interbrand.png": 94,
	"./brand-logos/internet-retailer.png": 95,
	"./brand-logos/lego.png": 96,
	"./brand-logos/levis.png": 97,
	"./brand-logos/loreal.png": 98,
	"./brand-logos/lvmh.png": 99,
	"./brand-logos/makeup-forever.png": 100,
	"./brand-logos/marieclaire.png": 101,
	"./brand-logos/mediapost.png": 102,
	"./brand-logos/mondelez.png": 103,
	"./brand-logos/nestle.png": 104,
	"./brand-logos/olay.png": 105,
	"./brand-logos/oreo.png": 106,
	"./brand-logos/pandg.png": 107,
	"./brand-logos/pepperidge-farm.png": 108,
	"./brand-logos/psfk.png": 109,
	"./brand-logos/revlon.png": 110,
	"./brand-logos/t-mobile.png": 111,
	"./brand-logos/techcrunch.png": 112,
	"./brand-logos/under-armour.png": 113,
	"./brand-logos/unilever.png": 114,
	"./brand-logos/wall-street-journal.png": 115,
	"./brand-logos/zappos.png": 116,
	"./fb-partners.png": 117,
	"./gray-device.png": 369,
	"./holiday-2019-a.png": 370,
	"./holiday-2019-b.png": 371,
	"./ig-partners.png": 118,
	"./inc-500.png": 43,
	"./iphone-7-white.png": 19,
	"./measure-screenshot.png": 119,
	"./mikmak-circle-logo-black-transparent.png": 372,
	"./mikmak-circle-logo-black.png": 373,
	"./mikmak-circle-logo-white-transparent.png": 374,
	"./mikmak-circle-logo-white.png": 375,
	"./mikmak-logo-black.png": 44,
	"./mikmak-logo-new.png": 120,
	"./mikmak-logo-white-new.png": 45,
	"./mikmak-logo-white.png": 376,
	"./mikmak-logo.png": 377,
	"./snapchat-partners.png": 121,
	"./social-logos/adobe.png": 122,
	"./social-logos/amazon.png": 123,
	"./social-logos/analytics.png": 124,
	"./social-logos/cvs.png": 125,
	"./social-logos/dcm.png": 126,
	"./social-logos/facebook.png": 127,
	"./social-logos/gmail.png": 128,
	"./social-logos/google.png": 129,
	"./social-logos/instacart.png": 130,
	"./social-logos/instagram.png": 131,
	"./social-logos/kroger.png": 132,
	"./social-logos/messenger.png": 133,
	"./social-logos/pinterest.png": 134,
	"./social-logos/salesforce.png": 135,
	"./social-logos/sephora.png": 136,
	"./social-logos/snapchat.png": 137,
	"./social-logos/target.png": 138,
	"./social-logos/tradedesk.png": 139,
	"./social-logos/twitter.png": 140,
	"./social-logos/ulta.png": 141,
	"./social-logos/walgreens.png": 142,
	"./social-logos/walmart.png": 143,
	"./social-logos/whatsapp.png": 144,
	"./social-logos/youtube.png": 145,
	"./social-logos/zappos.png": 146,
	"./white-device.png": 378,
	"./winter-2019/atc-button.png": 147,
	"./winter-2019/checkout-amazon.png": 46,
	"./winter-2019/checkout-cvs.png": 148,
	"./winter-2019/checkout-levi.png": 149,
	"./winter-2019/checkout-loreal.png": 150,
	"./winter-2019/checkout-macys.png": 151,
	"./winter-2019/checkout-secret.png": 152,
	"./winter-2019/checkout-sephora.png": 153,
	"./winter-2019/checkout-target.png": 47,
	"./winter-2019/checkout-tomford.png": 154,
	"./winter-2019/checkout-ua.png": 155,
	"./winter-2019/checkout-walmart.png": 48,
	"./winter-2019/feature-one.png": 156,
	"./winter-2019/hero-audiences.png": 49,
	"./winter-2019/hero-macbook-1.png": 50,
	"./winter-2019/hero-optimize.png": 157,
	"./winter-2019/hero-phone-1.png": 158,
	"./winter-2019/hero-phone-10.png": 159,
	"./winter-2019/hero-phone-11.png": 160,
	"./winter-2019/hero-phone-12.png": 161,
	"./winter-2019/hero-phone-13.png": 162,
	"./winter-2019/hero-phone-14.png": 163,
	"./winter-2019/hero-phone-15.png": 164,
	"./winter-2019/hero-phone-16.png": 20,
	"./winter-2019/hero-phone-2.png": 165,
	"./winter-2019/hero-phone-3.png": 166,
	"./winter-2019/hero-phone-4.png": 167,
	"./winter-2019/hero-phone-5.png": 168,
	"./winter-2019/hero-phone-6.png": 169,
	"./winter-2019/hero-phone-7.png": 170,
	"./winter-2019/hero-phone-8.png": 171,
	"./winter-2019/hero-phone-9.png": 172,
	"./winter-2019/mikmak-gradient-logo-1.png": 173,
	"./winter-2019/mikmak-gradient-logo-2.png": 51,
	"./winter-2019/secret-desktop-2.png": 174,
	"./winter-2019/secret-desktop.png": 175,
	"./winter-2019/secret-mobile.png": 176,
	"./winter-2019/step-amazon.png": 52,
	"./winter-2019/step-verticals.png": 177
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./atc-button.png": 147,
	"./checkout-amazon.png": 46,
	"./checkout-cvs.png": 148,
	"./checkout-levi.png": 149,
	"./checkout-loreal.png": 150,
	"./checkout-macys.png": 151,
	"./checkout-secret.png": 152,
	"./checkout-sephora.png": 153,
	"./checkout-target.png": 47,
	"./checkout-tomford.png": 154,
	"./checkout-ua.png": 155,
	"./checkout-walmart.png": 48,
	"./feature-one.png": 156,
	"./hero-audiences.png": 49,
	"./hero-macbook-1.png": 50,
	"./hero-optimize.png": 157,
	"./hero-phone-1.png": 158,
	"./hero-phone-10.png": 159,
	"./hero-phone-11.png": 160,
	"./hero-phone-12.png": 161,
	"./hero-phone-13.png": 162,
	"./hero-phone-14.png": 163,
	"./hero-phone-15.png": 164,
	"./hero-phone-16.png": 20,
	"./hero-phone-2.png": 165,
	"./hero-phone-3.png": 166,
	"./hero-phone-4.png": 167,
	"./hero-phone-5.png": 168,
	"./hero-phone-6.png": 169,
	"./hero-phone-7.png": 170,
	"./hero-phone-8.png": 171,
	"./hero-phone-9.png": 172,
	"./mikmak-gradient-logo-1.png": 173,
	"./mikmak-gradient-logo-2.png": 51,
	"./secret-desktop-2.png": 174,
	"./secret-desktop.png": 175,
	"./secret-mobile.png": 176,
	"./step-amazon.png": 52,
	"./step-verticals.png": 177
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Google Doc where we document this stuff for all MikMak team members to see.
// https://docs.google.com/spreadsheets/d/1OV3xqG3cUMRw2Y70ugIBldchXTLqiyYKvwT_hK21kyY/

/* harmony default export */ __webpack_exports__["a"] = {
  'pageView': 'PAGE_VIEW',
  'attachGalleryProductToggled': 'ATTACH_GALLERY_PRODUCT_TOGGLED',
  'requestDemoClicked': 'REQUEST_DEMO_CLICKED',
  'solutionLinkClicked': 'SOLUTION_LINK_CLICKED',
  'contactFormSubmitted': 'CONTACT_FORM_SUBMITTED',
  'whitepaperFormSubmitted': 'WHITEPAPER_FORM_SUBMITTED',
  'validEmailInput': 'VALID_EMAIL_INPUT'
};

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var setOptions = function setOptions(payload, options) {
  for (var key in options) {
    var option = options[key];
    payload[key] = option;
  }
};

/* harmony default export */ __webpack_exports__["a"] = function (options) {

  var payload = {};
  setOptions(payload, options);

  payload.href = window.location.href;
  payload.referringUrl = window.document.referrer;

  return payload;
};

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = function (name, eventPayload, cb) {
  dispatchEventToAmplitude(name, eventPayload, cb);
};

// Send an event to Amplitude.
var dispatchEventToAmplitude = function dispatchEventToAmplitude(name, eventPayload, cb) {
  if (eventPayload) {
    amplitude.getInstance().logEvent(name, eventPayload, function () {
      if (cb) cb();
    });
  } else {
    amplitude.getInstance().logEvent(name);
  }
};

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Careers__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Careers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Careers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_About__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Privacy__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Privacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Security__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Security___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Security__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Holiday2019__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Holiday2019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Holiday2019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Alcohol__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Alcohol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Alcohol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_PrivacyApp__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_PrivacyApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_PrivacyApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_OpenPositions__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_OpenPositions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_OpenPositions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_AttachVertical__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_AttachVertical___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_AttachVertical__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_RetailPartners__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_RetailPartners___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_RetailPartners__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_RedirectView__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_RedirectView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_RedirectView__);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '*',
    name: 'RedirectView',
    component: __WEBPACK_IMPORTED_MODULE_13__views_RedirectView___default.a
  }]
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = [{
  name: 'CART',
  slug: 'cart',
  text: ''
}, {
  name: 'CAPTURE',
  slug: 'capture',
  text: ''
}, {
  name: 'CONVERT',
  slug: 'convert',
  text: ''
}, {
  name: 'GALLERY',
  slug: 'gallery',
  text: ''
}, {
  name: 'RATE',
  slug: 'rate',
  text: ''
}, {
  name: 'MultiCart',
  slug: 'multicart',
  text: ''
}];

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = [{
  id: 0,
  patentPending: true,
  slug: 'attach_cart',
  isBeta: false,
  name: 'ATTACH <label style="color: #00bfbd; font-weight: normal;">CART</label>',
  align: 'left',
  cta: 'Request a demo',
  clickMessage: 'Clicked request demo for Attach CART',
  description: 'MikMak Attach Cart increases add-to-carts within social media.',
  device: {
    color: 'white',
    rotation: '1deg'
  },
  images: {
    beauty: 'https://s3.amazonaws.com/attach-videos/758742_benefit-cart-demo-2-sm.m4v',
    apparel: 'https://s3.amazonaws.com/attach-videos/LmbP0f8tT2S3lVMsEQ17_Zappos%20-%20IG%20In-Feed%20Demo.mov',
    electronics: 'https://s3.amazonaws.com/attach-videos/bwLJ9EMQx2QdfE2gZRjK_Bose%20Sponsored%20Instagram%20Story.mp4'
  },
  features: ['Add-to-cart made easy', 'Integrations with Shopify, Demandware, Magento, Amazon, Ulta, Walmart and more', 'Full funnel attribution', 'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'],
  learnMore: {
    text: 'See how Attach Cart outperformed a Fortune 1000\'s owned product details pages',
    href: '/attach/beauty'
  }
}, {
  id: 1,
  patentPending: true,
  slug: 'attach_multicart',
  isBeta: false,
  name: 'ATTACH <label style="color: #00bfbd; font-weight: normal;">MultiCart</label>',
  align: 'right',
  cta: 'Request a demo',
  clickMessage: 'Clicked request demo for Attach MultiCart',
  description: 'MikMak Attach MultiCart increases add-to-carts at shoppers\' preferred retailers.',
  device: {
    color: 'white',
    rotation: '1deg'
  },
  images: {
    CPG: 'https://s3.amazonaws.com/attach-videos/CShCDKG7QBK7QwUn9Ciu_Larabar%20Instagram%20Demo%20-%205.4.18.mov',
    beauty: 'https://s3.amazonaws.com/attach-videos/ZfkxrjZQdqg47yR0i0bQ_Olay%20Cinemagraph%20-%20MultiCart%20v2.mov'
  },
  features: ['In one click, shoppers choose where they want to checkout like Amazon, Ulta, Walmart and more', 'Solves for your brand’s need for “fair and equitable distribution”', 'Control your brand expression and data at the product page level even when you don’t own the eComm cart', 'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'],
  learnMore: {
    text: 'Read how CPG brands improved shoppers\' journey with MultiCart',
    href: '/attach/food-and-beverage'
  }
}, {
  id: 2,
  patentPending: false,
  slug: 'attach_capture',
  isBeta: false,
  name: 'ATTACH <label style="color: #00bfbd; font-weight: normal;">CAPTURE</label>',
  align: 'left',
  cta: 'Request a demo',
  clickMessage: 'Clicked request demo for Attach CAPTURE',
  description: 'MikMak Attach Capture turns social engagement into an owned lead.',
  device: {
    color: 'white',
    rotation: '1deg'
  },
  images: {
    beauty: 'https://s3.amazonaws.com/attach-videos/eUOoMD5uTsOBrlvAEyvU_Make Up For Ever - Capture - 6.2.mov',
    apparel: 'https://s3.amazonaws.com/attach-videos/mNmLWLZOQ26r3f2zCzda_ua-capture-demo.mov'
  },
  features: ['Discover who your social leads are with automatic email capture upon swipe-up or click', 'Import leads into your preferred CRM database', 'Middle of funnel unit <i class="fa fa-user" aria-hidden="true"></i>'],
  learnMore: {
    text: 'Discover how apparel brands collect first party data with Capture',
    href: '/attach/apparel-and-footwear'
  }
}];

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  pageContent: ['MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.', 'Join us. Or at least come have fun with us.'],
  positions: [{
    id: 0,
    title: 'Manager / Senior Manager of Customer Success',
    slug: 'customer_success_manager',
    shortDesc: 'This position will help drive value for MikMak’s customers, and scale the Customer Success practice. You’re a proven leader, highly empathetic with an analytical bent and a passion for storytelling. This position reports to the SVP of Operations.',
    description: 'MikMak is looking for a proven Customer Success leader to manage our relationships with some of the world’s leading marketers. This position includes responsibilities for Customer Success activities including on-boarding, support, analysis and strategic consultation, as well as the key outcomes of this work - ie, renewals and upsells.<br><br>A successful candidate for this role has built collaborative client relationships from the working level up to the CMO, is excited about our vision for social video, is comfortable in a dynamic startup environment, and will bring energy and passion to everything they do. This role reports to the SVP of Operations, with significant cross-functional collaboration across the entire company.',
    sections: [{
      heading: 'RESPONSIBILITIES',
      textContent: false,
      bullets: [{
        type: 'heading',
        content: 'Define and Optimize the Customer Lifecycle'
      }, {
        type: 'bullet',
        content: 'Standardize the template for a value plan for new customers'
      }, {
        type: 'bullet',
        content: 'Own the customer post-sale journey, and team activities and deliverables needed to support our customers at each stage of the lifecycle'
      }, {
        type: 'bullet',
        content: 'Determine how to define, drive, and demonstrate value delivered: recommend and implement changes to client analytics and optimization processes, including team responsibilities and workflows as well as presentation materials'
      }, {
        type: 'bullet',
        content: 'Establish escalations process, and personally manage escalations from your direct reports'
      }, {
        type: 'bullet',
        content: 'Drive adoption of new products; initiate and close customer expansion and renewal opportunities'
      }, {
        type: 'bullet',
        content: 'Gain customer buy-in for joint case studies and references'
      }, {
        type: 'heading',
        content: 'Help build and develop the Customer Success team'
      }, {
        type: 'bullet',
        content: 'Foster collaboration within team and across customer lifecycle'
      }, {
        type: 'bullet',
        content: 'Encourage continuous learning within team, and identify opportunities to develop critical skills across the team'
      }, {
        type: 'bullet',
        content: 'Ensure that all CSMs (and the broader MikMak team) deeply understand our customers’ businesses and objectives, and are positioned to serve as trusted advisors'
      }, {
        type: 'heading',
        content: 'Inspire Customer Success Across Company'
      }, {
        type: 'bullet',
        content: 'Create a company-wide culture of Customer Success, serving as the #1 advocate for our customers within MikMak'
      }, {
        type: 'bullet',
        content: 'Inform the product roadmap based on customer input'
      }, {
        type: 'bullet',
        content: 'Design and execute on operational and financial reporting highlighting key customer success drivers'
      }, {
        type: 'heading',
        content: 'Own key Customer Success metrics'
      }, {
        type: 'bullet',
        content: 'Reduced Gross Churn, increased Net Dollar Retention'
      }, {
        type: 'bullet',
        content: 'Product adoption, customer satisfaction and NPS'
      }, {
        type: 'bullet',
        content: 'Cultivation of referenceable clients and marketable case studies'
      }, {
        type: 'bullet',
        content: 'Revenue through cross-sell and up-sell activity'
      }]
    }, {
      heading: 'Who you are',
      textContent: false,
      bullets: [{
        type: 'bullet',
        content: '3+ years building amazing customer relationships and leading CS teams in roles with progressively increasing responsibility, including significant exposure to CMOs / other senior leaders'
      }, {
        type: 'bullet',
        content: 'A proven leader, exceptional communicator, and compelling presenter with an unbreakable resolve and excellent negotiation skills'
      }, {
        type: 'bullet',
        content: 'Analytically savvy, familiar with ROAS and other metrics our clients are looking to optimize'
      }, {
        type: 'bullet',
        content: 'Well-versed in all things Social and SaaS'
      }, {
        type: 'bullet',
        content: 'Empathetic, humble and hungry'
      }, {
        type: 'bullet',
        content: 'NYC based or ready to relocate to the best city on Earth'
      }]
    }, {
      heading: 'Benefits',
      textContent: false,
      bullets: [{
        type: 'bullet',
        content: 'Cash + Equity'
      }, {
        type: 'bullet',
        content: 'Health Insurance'
      }, {
        type: 'bullet',
        content: 'Free lunch at least once a week'
      }, {
        type: 'bullet',
        content: 'Yearly stipend to take a class that enriches your life outside of work'
      }, {
        type: 'bullet',
        content: 'Brooklyn loft office vibes'
      }]
    }, {
      heading: 'Who we are',
      textContent: 'MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.<br><br>MikMak\'s Founder & CEO is Rachel Tipograph, the former Global Director of Digital & Social Media at Gap. Rachel has been recognized as a leading innovator across the globe, including Forbes\' “30 under 30 Who Are Changing The World”, Marie Claire\'s "50 Most Influential Women in America," and Fast Company\'s "Most Creative People in Business."<br><br>MikMak\'s investors include VaynerMedia, Luminari Capital, SLOW Ventures, UTA Ventures, Brave Ventures, Jeff Zucker and Christina Aguilera.',
      bullets: []
    }]
  }, {
    id: 1,
    title: 'Senior UI & UX Designer',
    slug: 'senior_designer',
    shortDesc: 'This position will lead all of Design & Research at MikMak. You have experience leading design projects large and small, and love the fast pace of a startup. This role reports to the VP of Product & Engineering.',
    description: 'MikMak is looking for an experienced, empathetic Designer to join our product team. This is an opportunity to be a foundational member of a rapidly growing company, and help define what it means to do Design and Research here.<br><br>MikMak builds commerce products that live within social platforms like Instagram, Facebook, Snapchat, and elsewhere on the web. As we expand our product portfolio and platform, we\'re looking for a Design leader to own the vision for these products.<br><br> You\'ll help establish a strong design language for our products, build out components of our growing platform, and conduct research to inform product strategy, test prototypes and measure impact.',
    sections: [{
      heading: 'You might be a good fit if you:',
      textContent: false,
      bullets: [{
        type: 'bullet',
        content: 'Have experience designing products & systems, start to finish'
      }, {
        type: 'bullet',
        content: 'Have experience collaborating with Engineering teams'
      }, {
        type: 'bullet',
        content: 'Have experience creating product briefs, and communicating to different teams'
      }, {
        type: 'bullet',
        content: 'Experience with Adobe Creative Suite and Sketch is a must. Experience with tools like Figma, Invision and other prototyping tools is a big plus. '
      }, {
        type: 'bullet',
        content: 'Have experience conducting user/usability tests'
      }, {
        type: 'bullet',
        content: 'Can prototype ideas quickly using tools like Framer, etc'
      }, {
        type: 'bullet',
        content: 'Have experience working in startups on projects large and small'
      }, {
        type: 'bullet',
        content: 'Experience in eCommerce is a big plus'
      }, {
        type: 'bullet',
        content: 'Experience with HTML/CSS/Javascript is also a plus'
      }]
    }, {
      heading: 'Benefits',
      textContent: false,
      bullets: [{
        type: 'bullet',
        content: 'Cash + Equity'
      }, {
        type: 'bullet',
        content: 'Health Insurance'
      }, {
        type: 'bullet',
        content: 'Free lunch at least once a week'
      }, {
        type: 'bullet',
        content: 'Yearly stipend to take a class that enriches your life outside of work'
      }, {
        type: 'bullet',
        content: 'Brooklyn loft office vibes'
      }]
    }, {
      heading: 'Who we are',
      textContent: 'MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.<br><br>MikMak\'s Founder & CEO is Rachel Tipograph, the former Global Director of Digital & Social Media at Gap. Rachel has been recognized as a leading innovator across the globe, including Forbes\' “30 under 30 Who Are Changing The World”, Marie Claire\'s "50 Most Influential Women in America," and Fast Company\'s "Most Creative People in Business."<br><br>MikMak\'s investors include VaynerMedia, Luminari Capital, SLOW Ventures, UTA Ventures, Brave Ventures, Jeff Zucker and Christina Aguilera.',
      bullets: []
    }]
  }, {
    id: 4,
    title: 'Business Development Undergrad Intern: Summer 2018',
    slug: 'summer_intern',
    shortDesc: 'MikMak is hiring a Business Development Intern for Summer 2018! This will be a great experience for anyone interested in hands-on Business Development experience at a fast-growth startup.',
    description: 'MikMak is hiring a Business Development Intern for Summer 2018! This will be a great experience for anyone interested in hands-on Business Development experience at a fast-growth startup.',
    sections: [{
      heading: 'RESPONSIBILITIES',
      textContent: 'Responsibilities will span a range of special projects and core business activities, and are expected to include:',
      bullets: [{
        type: 'bullet',
        content: 'Create compelling visuals to include in sales materials'
      }, {
        type: 'bullet',
        content: 'Research potential new clients and potential strategic partnerships to help identify quality leads'
      }, {
        type: 'bullet',
        content: 'Develop case studies + content marketing in the form of 1-pagers and whitepapers highlighting 2 or 3 selected customer stories, in collaboration with our Customer Success team'
      }, {
        type: 'bullet',
        content: 'Assist the team in all stages of the business development cycle, including but not limited to new business pitches, follow-up sales materials, social media, platform research and tracking of client pipeline'
      }, {
        type: 'bullet',
        content: 'Additional projects as identified'
      }]
    }, {
      heading: 'Who you are',
      textContent: false,
      bullets: [{
        type: 'bullet',
        content: 'Current Undergraduate student'
      }, {
        type: 'bullet',
        content: 'Savvy in making client-facing presentations and assets in Keynote, Indesign and Photoshop'
      }, {
        type: 'bullet',
        content: 'Obsessed with building relationships as much as we are'
      }, {
        type: 'bullet',
        content: 'Comfortable communicating in a range of situations - internal as well as client-facing'
      }, {
        type: 'bullet',
        content: 'Empathetic, humble and hungry'
      }, {
        type: 'bullet',
        content: 'NYC-based '
      }]
    }, {
      heading: 'Benefits',
      textContent: false,
      bullets: [{
        type: 'bullet',
        content: 'Free lunch at least once a week'
      }, {
        type: 'bullet',
        content: 'Brooklyn loft office vibes'
      }, {
        type: 'bullet',
        content: 'School credit + MTA monthly metrocard'
      }]
    }, {
      heading: 'Who we are',
      textContent: 'MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.<br><br>MikMak\'s Founder & CEO is Rachel Tipograph, the former Global Director of Digital & Social Media at Gap. Rachel has been recognized as a leading innovator across the globe, including Forbes\' “30 under 30 Who Are Changing The World”, Marie Claire\'s "50 Most Influential Women in America," and Fast Company\'s "Most Creative People in Business."<br><br>MikMak\'s investors include VaynerMedia, Luminari Capital, SLOW Ventures, UTA Ventures, Brave Ventures, Jeff Zucker and Christina Aguilera.',
      bullets: []
    }]
  }, {
    id: 5,
    title: 'MBA Intern: Summer 2018',
    slug: 'mba_intern',
    shortDesc: 'MikMak is hiring an MBA Intern for Summer 2018! This will be a great experience for anyone interested in hands-on operations and client experience at a fast-growth startup.',
    description: 'MikMak is hiring an MBA Intern to support our rapidly growing team across Customer Success and Business Operations. ',
    sections: [{
      heading: 'RESPONSIBILITIES',
      textContent: 'Responsibilities will span a range of special projects and core business activities, and are expected to include:',
      bullets: [{
        type: 'heading',
        content: 'CUSTOMER SUCCESS'
      }, {
        type: 'bullet',
        content: 'Customer analytics: client performance analysis/dashboards, and creation of cross-category benchmarks on a range of dimensions. Support in the creation of client-ready reports and presentations to ensure our clients are set up for success with MikMak.'
      }, {
        type: 'bullet',
        content: 'Case studies + content marketing: create 1-pagers and whitepapers highlighting 2 or 3 selected customer stories, in collaboration with our Business Development team.'
      }, {
        type: 'bullet',
        content: 'Additional projects as identified.'
      }, {
        type: 'heading',
        content: 'OPERATIONS'
      }, {
        type: 'bullet',
        content: 'Financial modeling: support in refining our financial model based on deep-dives into recent MikMak financial results as well as industry benchmarks; ad hoc analyses to support quarterly board update.'
      }, {
        type: 'bullet',
        content: 'Revenue operations: collaborate with our BD and CS teams to help create scalable processes that improve sales performance and client responsiveness.'
      }, {
        type: 'bullet',
        content: 'Additional projects as identified.'
      }]
    }, {
      heading: 'Who you are',
      textContent: false,
      bullets: [{
        type: 'bullet',
        content: 'Current MBA student'
      }, {
        type: 'bullet',
        content: 'Experienced in telling stories from data and working collaboratively within diverse teams'
      }, {
        type: 'bullet',
        content: 'Analytically savvy, able to get up to speed quickly on new datasets and analytical approaches'
      }, {
        type: 'bullet',
        content: 'Comfortable communicating in a range of situations - internal as well as client-facing'
      }, {
        type: 'bullet',
        content: 'Empathetic, humble and hungry'
      }, {
        type: 'bullet',
        content: 'NYC based or ready to relocate to spend the summer in the best city on Earth'
      }]
    }, {
      heading: 'Benefits',
      textContent: false,
      bullets: [{
        type: 'bullet',
        content: 'Free lunch at least once a week'
      }, {
        type: 'bullet',
        content: 'Brooklyn loft office vibes'
      }]
    }, {
      heading: 'Who we are',
      textContent: 'MikMak\'s mission is to create native commerce experiences for the social video generation. We believe the future of shopping is rooted in social video and we enable brands to connect to the next generation of shoppers, video shoppers.<br><br>MikMak\'s Founder & CEO is Rachel Tipograph, the former Global Director of Digital & Social Media at Gap. Rachel has been recognized as a leading innovator across the globe, including Forbes\' “30 under 30 Who Are Changing The World”, Marie Claire\'s "50 Most Influential Women in America," and Fast Company\'s "Most Creative People in Business."<br><br>MikMak\'s investors include VaynerMedia, Luminari Capital, SLOW Ventures, UTA Ventures, Brave Ventures, Jeff Zucker and Christina Aguilera.',
      bullets: []
    }]
  }]
};

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  heading: 'contact us',
  subheading: 'Fill out the form below, send a message to hola at mikmak dot tv, or give us a ring at 1-844-645-6251',
  successMessage: 'Thanks for the message. We\'ll be in touch shortly!',
  formFields: [{
    className: 'footer-bar-contact-form-text',
    type: 'text',
    name: 'name',
    placeholder: 'your name',
    required: true
  }, {
    className: 'footer-bar-contact-form-text',
    type: 'email',
    name: 'email',
    placeholder: 'your email',
    required: true
  }, {
    className: 'footer-bar-contact-form-text',
    type: 'text',
    name: 'company',
    placeholder: 'company',
    required: false
  }, {
    className: 'footer-bar-contact-form-text',
    type: 'text',
    name: 'message',
    placeholder: 'your message',
    required: false
  }]
};

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  // text: 'What does this say?',
  text: 'Commerce for social video and beyond',
  // subheaderText: 'This part should also say something meaningful about the product.',
  subheaderText: 'Mobile-first commerce experiences that shorten the path to purchase'
};

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  links: [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Products',
    href: '#products'
  }, {
    name: 'Press',
    href: '#press'
  }, {
    name: 'Contact',
    href: '#contact'
  }]
};

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  text: ['After two years of being the leading video shopping app, MikMak understands the pain points brands face in trying to create, scale and measure video commerce.', 'MikMak’s Platform is designed to connect brands to today’s video shoppers.']
};

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Images live here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview
/* harmony default export */ __webpack_exports__["a"] = {
  partnerText: {
    heading: 'our partners',
    subheading: 'We\'ve worked with over 200 partners including:'
  },
  keyPartnerList: ['bose', 'campbells', 'clorox', 'estee-lauder', 'general-mills', 'gsk', 'lego', 'levis', 'loreal', 'lvmh',
  // 'pandg',
  'unilever'],
  partnerList: [
  // 'banana-republic',
  // 'benefit-cosmetics',
  'bose', 'dollar-shave-club',
  // 'dr-brandt',
  'estee-lauder',
  // 'gopro',
  'herbal-essences', 'hp', 'lancome', 'levis', 'loreal', 'mattel',
  // 'mondelez',
  'olay', 'old-spice', 'oreo', 'pampers',
  // 'pandg',
  'pepperidge-farm',
  // 'revlon',
  'timberland', 't-mobile', 'under-armour', 'unilever', 'zappos']
};

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Images live here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview
/* harmony default export */ __webpack_exports__["a"] = {
  content: {
    heading: 'press',
    subheading: 'Read what the world is saying about MikMak',
    list: [{
      name: 'inc',
      url: 'https://www.inc.com/magazine/201810/inc-staff/morgan-debaun-and-other-problem-solvers-female-founders-100.html'
    }, {
      name: 'techcrunch',
      url: 'https://techcrunch.com/2017/04/25/mikmak-is-using-mini-infomercials-to-help-retailers-turn-their-stories-into-sales/'
    }, {
      name: 'digiday',
      url: 'https://digiday.com/marketing/brands-testing-shoppable-videos-instagram-stories-snap-ads/'
    }, {
      name: 'adweek',
      url: 'https://www.adweek.com/digital/the-company-thats-taking-shoppable-video-seriously-and-driving-results/'
    },
    // {
    //   name: 'forbes',
    //   url: 'https://www.forbes.com/sites/jenniferrooney/2015/05/13/with-mikmak-forbes-30-under-30-alum-tipograph-reinvents-the-infomercial/#296fb0a327ea'
    // },
    {
      name: 'cheddar',
      url: 'https://cheddar.com/videos/rachel-tipograph-founder-mikmak'
    },
    // {
    //   name: 'psfk',
    //   url: 'https://www.psfk.com/2017/04/mikmak-lets-brands-sell.html'
    // },
    {
      name: 'fast-company',
      url: 'https://www.fastcompany.com/3046202/this-is-how-you-make-infomericals-millenials-will-watch '
    }, {
      name: 'entrepreneur',
      url: 'https://www.entrepreneur.com/slideshow/303904/#42'
    }, {
      name: 'bloomberg',
      url: 'https://www.youtube.com/watch?v=1KqP2RIcCoc&feature=youtu.be&t=38m5s'
    }, {
      name: 'adlandia',
      url: 'https://podcasts.apple.com/us/podcast/adlandia/id1207451238?i=1000394814856&mt=2'
    },
    // {
    //   name: 'internet-retailer',
    //   url: 'https://www.instagram.com/p/BcmzM_Dgyec/'
    // },
    {
      name: 'interbrand',
      url: 'http://interbrand.com/best-brands/interbrand-breakthrough-brands/2017/articles/5-questions-mikmak/'
    }, {
      name: 'marieclaire',
      url: 'https://www.marieclaire.com/culture/g3230/the-new-guard-influential-women/'
    }, {
      name: 'wall-street-journal',
      url: 'https://www.wsj.com/articles/meet-mikmak-the-mobile-shopping-network-that-sells-via-video-1467832496'
    },
    // {
    //   name: 'mediapost',
    //   url: 'https://www.mediapost.com/publications/article/304450/burger-kings-machado-ges-comstock-among-ad-club.html'
    // },
    {
      name: 'emarketer',
      url: 'https://drive.google.com/file/d/0BzqJZaqgqjeqdFR4VHU2VFlObnhYanhvclFxcWNMQVF0eEpN/view'
    }, {
      name: 'business-of-fashion',
      url: 'https://drive.google.com/file/d/0BzqJZaqgqjeqWHV3NkNEemh4RFN4VnZyakpVX2dYZG1wVGtZ/view'
      // {
      //   name: 'ad-age',
      //   url: 'http://adage.com/article/cmo-strategy/infomercial-iphone-generation/298637/'
      // },
      // {
      //   name: 'fox-news',
      //   url: 'https://thenextweb.com/apps/2015/06/04/dothemikmak/#.tnw_5mBWv1fu'
      // },
      // {
      //   name: 'glamour',
      //   url: 'http://www.glamour.com/story/shopping-app-store-apple'
      // },
      // {
      //   name: 'the-next-web',
      //   url: 'https://thenextweb.com/apps/2015/06/04/dothemikmak/#.tnw_5mBWv1fu'
      // },
      // {
      //   name: 'vanity-fair',
      //   url: 'http://www.vanityfair.com/style/2015/09/so-heres-donald-drawbertson-robertsons-story-with-smashbox-cosmetics-and-friends-during-nyfw'
      // },
      // {
      //   name: 'wwd',
      //   url: 'http://wwd.com/business-news/marketing-promotion/mikmak-infomercials-for-millennials-10253483/'
      // }
    }]
  }
};

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  list: [{
    id: 0,
    name: 'Attach',
    patentPending: true,
    description: 'MikMak Attach turns a video view into a purchase by improving the swipe up commerce experience within Instagram and Snapchat',
    device: {
      color: 'white-device',
      rotation: '1deg',
      image: '//mikmak.s3.amazonaws.com/uploads/49ac9dc1-1ac5-417b-8d41-4225d1b5bd79/with-cart.gif'
      // image: '//mikmak.s3.amazonaws.com/uploads/49ac9dc1-1ac5-417b-8d41-4225d1b5bd79/without-cart.gif'
    },
    bullets: ['Extend the shelf life of your video content', 'Add-to-cart made easy', 'See direct sales attribution from social', 'Opportunity to re-market to customers', 'Integrates with <i class="fa fa-instagram" aria-hidden="true"></i> and <i class="fa fa-snapchat" aria-hidden="true"></i>'],
    orientation: 'left',
    boxStyles: {
      backgroundColor: 'rgba(230, 230, 230, 0.59)'
    },
    cta: 'Request a Demo'
  }, {
    id: 1,
    name: 'Studios',
    description: 'MikMak creates short form, shoppable video',
    device: {
      color: 'white-device',
      rotation: '-2deg',
      image: '//mikmak.s3.amazonaws.com/uploads/8f15e585-73df-4f10-ae03-36ffb1c3ec67/ezgif.com-video-to-gif-iloveimg-compressed.gif'
    },
    bullets: ['Our in-house team produces fun and catchy videos designed to drive engagement and purchase'],
    orientation: 'right',
    boxStyles: {
      backgroundColor: 'rgb(241, 241, 241)'
    },
    cta: 'Request a Quote'
  }, {
    id: 2,
    name: 'Measure',
    description: 'MikMak Measure is an analytics dashboard that provides data and insights about the performance of a brand\'s shoppable video',
    bullets: ['Real time funnel visualization', 'One click data filters', 'Customer journey mapping', 'Shoppable video analysis by the second'],
    orientation: 'left',
    boxStyles: {
      backgroundColor: 'rgba(230, 230, 230, 0.59)'
    },
    cta: 'Request a Demo'
  }, {
    id: 3,
    name: 'Live',
    description: 'Instantly turn Facebook Live into an engaging shopping experience <i class="fa fa-facebook-official" aria-hidden="true"></i>',
    bullets: [],
    orientation: 'left',
    boxStyles: {
      backgroundColor: 'rgb(241, 241, 241)'
    },
    cta: 'Apply for the beta'
  }]
};

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = [{
  title: 'Application Security',
  items: [{
    title: 'DDOS and Rate Limiting',
    text: ['All MikMak applications are protected against DDoS attacks that would result in downtime. We also enforce rate limiting on all of our services in order to avoid nefarious traffic that might otherwise interrupt our services.']
  }, {
    title: 'Incident reporting & Logging',
    text: ['Access history and all incidents are logged and available to the relevant MikMak team members.', 'In the rare event of downtime or any other incident with our applications, clients will be notified immediately, updated every hour during the incident, and notfied again upon resolution of the incident.']
  }, {
    title: 'Uptime',
    text: ['MikMak Applications have an uptime of 99.95% or higher.']
  }, {
    title: 'SSO & 2FA',
    text: ['All applications within our platform are secured by accounts with two factor authentication enabled. We also leverage Single Sign On in all applications, in order to reduce the number of credentials that need securing.']
  }, {
    title: 'Audits',
    text: ['MikMak is periodically audited via penetration testing for security vulnerabilities. We immediately address any issues discovered during these audits.', 'We reguarly self-audit for compliance with OWASP Top 10 security guidelines.']
  }]
}, {
  title: 'Network & Data Security',
  items: [{
    title: 'SSL',
    text: ['All applications on our network are secured via SSL. ', 'Our SSL certificates receive an A+ rating when tested on Qualys SSL Labs.']
  }, {
    title: 'Customer data',
    text: ['All data captured by or shared with MikMak is encrypted in transition and at rest.  This data is also secured behind two factor authentication, and only relevant team members are given access.']
  }, {
    title: 'GDPR compliance',
    text: ['In MikMak experiences that allow users to submit PII, we work to ensure that these versions of our applications are GDPR compliant.']
  }, {
    title: 'Backups & Physical protection',
    text: ['All MikMak code and data is backed up on cloud storage services, with several layers of redundancy to protect against unexpected incidents.', 'MikMak data is spread across several regions in order to ensure reliable backup in the event of a natural disaster in a specific region.']
  }]
}, {
  title: 'Team security',
  items: [{
    title: 'Employee and Contractor policy',
    text: ['All MikMak employees and contractors are given onboarding materials to ensure that they (and their devices) comply with our security guidelines.']
  }, {
    title: 'Devices & Encryption',
    text: ['All devices used by MikMak team members use encryption and password protection to ensure data is only available to authorized team members.']
  }, {
    title: 'Audits',
    text: ['MikMak performs monthly audits to ensure all team members and company devices are in compliance with our security guidelines.']
  }]
}];

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  solutions: [{
    link: '/attach/big-box-ecommerce',
    title: 'Big Box ecommerce'
  }, {
    link: '/attach/direct-to-consumer-brands',
    title: 'Direct to Consumer brands'
  }, {
    link: '/attach/working-with-influencers',
    title: 'Working with influencers'
  }],
  industries: [{
    link: '/attach/apparel-and-footwear',
    title: 'Apparel & Footwear'
  }, {
    link: '/attach/beauty',
    title: 'Beauty & Personal Care'
  }, {
    link: '/attach/consumer-electronics',
    title: 'Consumer Electronics'
  }, {
    link: '/attach/food-and-beverage',
    title: 'Food & Beverage'
  }]
};

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = [{
  id: 0,
  slug: 'mikmak_studios',
  name: 'MIKMAK <label style="color: #00bfbd; font-weight: normal;">STUDIOS</label>',
  align: 'left',
  cta: 'Request a quote',
  clickMessage: 'Clicked request quote for MikMak STUDIOS',
  description: '',
  device: {
    color: 'white',
    rotation: '1deg'
  },
  images: {
    default: 'https://s3.amazonaws.com/attach.mikmak.tv/videos/mikmak-sizzle.mp4'
  },
  features: ['Content strategy & Creative development', 'Social media content creation', 'Full-service video production & post', 'A/B Video Production Tests']
}];

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {

  'apparel-and-footwear': {
    title: 'Attach for Apparel & Footwear',
    subtitle: '4x lift in checkouts with MikMak compared to a regular product details page',
    logos: ['under-armour', 'banana-republic', 'levis', 'zappos'],
    demos: [{
      attachProduct: 'cart',
      brand: 'zappos',
      cta: 'Request a demo of Cart',
      orientation: 'right',
      backgroundColor: '#fbf9f9',
      headline: 'Zappos + MikMak',
      text: ['Zappos saw few add-to-carts from traffic referred to their product details page from social. With Attach Cart, they see <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">20%</span> of users add-to-cart.'],
      bullets: ['Add-to-cart made easy', 'Integrates with Amazon, Target, Shopify, Walmart, Demandware, Magento & more', 'Full funnel attribution', 'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'],
      videoSrc: 'https://s3.amazonaws.com/attach-videos/LOigegATCqqQBR5A8WyW_Zappos Attach - 7.15.17_IP7.mp4'
    }]
  },

  'beauty': {
    title: 'Attach for Beauty & Personal care',
    subtitle: '4x lift in add-to-carts with MikMak compared to a regular product details page',
    logos: [
    // 'olay',
    'benefit-cosmetics', 'revlon', 'loreal', 'estee-lauder', 'dove',
    // 'birchbox',
    // 'pandg',
    'unilever'],
    demos: [{
      attachProduct: 'multicart',
      brand: 'colgate',
      cta: 'Request a demo of MultiCart',
      orientation: 'right',
      backgroundColor: 'white',
      headline: 'GLAMGLOW + MikMak',
      text: ['Prior to MikMak, GLAMGLOW had to segment their traffic without knowing where customers preferred to shop which resulted in media inefficiencies and low conversion rates.'],
      bullets: ['GLAMGLOW launched MikMak Attach MultiCart supporting Sephora.com & GLAMGLOW.com. MultiCart allowed the brand to achieve a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">66%</span> add-to-cart rate, over <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">5.5x</span> MikMak’s beauty benchmark.', 'The brand also gained segmented shopper audiences in their ad manager to use for future Sephora and DTC prospecting and retargeting ad campaigns. MikMak audiences out perform brands’ native audiences.'],
      videoSrc: 'https://s3.amazonaws.com/attach-videos/2KIAgV6fTaOcHuSPUT4c_glamglow_sm.mov'
    }]
  },

  'food-and-beverage': {
    title: 'Attach for Food & Beverage',
    subtitle: '17% of shoppers hit add-to-cart within Attach for CPG products',
    logos: ['general-mills', 'nestle', 'mondelez', 'pepperidge-farm'],
    demos: [{
      attachProduct: 'cart',
      brand: 'pepperidge-farm',
      cta: 'Request a demo of Cart',
      orientation: 'right',
      backgroundColor: 'white',
      headline: 'Pepperidge Farm + MikMak',
      text: ['Pepperidge Farm came to MikMak to enable frictionless shopping amongst influencers supporting their back-to-school and holiday campaigns. MikMak Attach identified which influencers drove the strongest conversion amongst Amazon, Target and Walmart. Pepperidge Farm learned that there was an <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">11x</span> conversion difference amongst influencers, allowing them to reallocate spend towards the top. performing influencers in future campaigns. '],
      bullets: ['Add-to-cart made easy', 'Integrations with Shopify, Demandware, Magento, Amazon, Ulta, Walmart and more', 'Control your brand expression and data at the product page level even when you don’t own the eComm cart', 'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'],
      videoSrc: '//s3.amazonaws.com/attach-videos/sAcJJeyYQkKesoVLDS6C_@ministylehacker_Goldfish_AmazonWalmart.mov'
    }]
  },

  'consumer-electronics': {
    title: 'Attach for Consumer Electronics',
    subtitle: '4x lift in checkouts with MikMak compared to a regular product details page',
    logos: ['bose', 'gopro', 't-mobile'],
    demos: [{
      attachProduct: 'cart',
      brand: 'bose',
      cta: 'Request a demo of Cart',
      orientation: 'left',
      backgroundColor: '#fbf9f9',
      headline: 'Bose + MikMak',
      text: ['Bose came to MikMak to increase conversion from social media referral traffic. MikMak drives a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">5x</span> lift in add-to-carts compared to its own eCommerce product details page.'],
      bullets: ['Add-to-cart made easy', 'Integrates with Amazon, Target, Shopify, Walmart, Demandware, Magento & more', 'Full funnel attribution', 'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'],
      videoSrc: 'https://s3.amazonaws.com/attach-videos/N3opeHYeS96bJ7ZlNXaj_Bose%20Sponsored%20Instagram%20Story.mp4'
    }]
  },

  'big-box-ecommerce': {
    title: 'For Brands sold at Big Box eCommerce',
    subtitle: 'Drive Add-to-Carts at big box retailer sites like Amazon, Walmart and Target ',
    logos: ['estee-lauder', 'loreal', 'revlon', 'lvmh', 'unilever', 'general-mills', 'mondelez', 'pepperidge-farm'],
    demos: [{
      attachProduct: 'cart',
      brand: 'pepperidge-farm',
      cta: 'Request a demo of Cart',
      orientation: 'right',
      backgroundColor: '#fbf9f9',
      headline: 'Pepperidge Farm + MikMak',
      text: ['Pepperidge Farm came to MikMak in order to leverage their large, active community of influencers.', 'During a Holiday campaign to promote Goldfish and Milano crackers, Pepperidge Farm influencers launched Attach Cart units all over social media, giving Pepperidge Farm organic followers several ways to shop.'],
      bullets: ['Add-to-cart made easy', 'Integrates with Amazon, Target, Shopify, Walmart, Demandware, Magento & more', 'Full funnel attribution', 'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'],
      videoSrc: '//s3.amazonaws.com/attach-videos/Pg4FZ3RmG7u7ybtbKxwS_Goldfish x TargetDoesItAgain (Influencer) Instagram Story Demo.mov'
    }]
  },

  'working-with-influencers': {
    title: 'For Working with Influencers',
    subtitle: 'Discover which influencers drive add-to-carts',
    logos: ['benefit-cosmetics',
    // 'dr-brandt',
    'loreal', 'oreo', 'pepperidge-farm', 'revlon', 'unilever', 'zappos'],
    demos: [{
      attachProduct: 'multicart',
      brand: 'colgate-optic-white',
      cta: 'Request a demo of Cart',
      orientation: 'right',
      backgroundColor: '#fbf9f9',
      headline: 'Colgate + MikMak',
      text: ['Prior to MikMak, Colgate Optic White had no idea which influencers had the ability to drive purchase intent at major eRetailers.'],
      bullets: ['Optic White launched an influencer campaign with MikMak Attach MultiCart. The brand saw a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">3x</span> spread amongst influencers ability to drive add-to-carts, meaning some drove a ton of add-to-carts while others drove close to none.', 'On average influencers drove a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">20%</span> add-to-cart', 'The brand also gained segmented shopper audiences in their ad manager to use for future Amazon, Target and Walmart prospecting and retargeting ad campaigns. MikMak audiences out perform brands’ native audiences.'],
      videoSrc: 'https://s3.amazonaws.com/attach-videos/t9vuxDkSGK99jjmyIAww_optic_white_sm.mov'
    }]
  },

  'direct-to-consumer-brands': {
    title: 'For Direct-to-Consumer Brands',
    subtitle: 'Native video shopping experience that causes consumers to add to cart',
    logos: [
    // 'dollar-shave-club',
    // 'birchbox',
    'levis', 'under-armour', 'zappos', 'benefit-cosmetics'],
    demos: [{
      attachProduct: 'cart',
      brand: 'levis',
      cta: 'Request a demo of Cart',
      orientation: 'right',
      backgroundColor: '#fbf9f9',
      headline: 'Levi\'s + MikMak',
      text: ['Prior to MikMak, Levi’s was seeing high bounce rates and low conversion when traffic arrived to their website from social.'],
      bullets: ['With MikMak, Levi’s saw a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">2x</span> lift in add-to-carts and a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">1.6x</span> reduction in bounce rate.'],
      videoSrc: 'https://s3.amazonaws.com/attach-videos/LT50fN9RTiSUs7hfkdQ2_levis_mobile_sm.mov'
    }]
  }
};

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  Holiday2019: {
    whitepaperNameForEvents: 'whitepaper-template',
    fileName: 'mikmak-whitepaper.pdf',
    heading: 'MikMak’s 2019 Holiday eCommerce Guide',
    img: 'holiday-2019-b',
    subheading: 'Shoppers spent $120B online in the U.S. during the 2018 holiday season, and analysts predict that this 2019 holiday season will see continued growth. MikMak put together this guide to help brand marketers make smarter decisions across their creative, media and merchandise investments this holiday season.<br><br>You\'ll learn when in the holiday calendar MikMak sees the highest eCommerce conversion rates, which media channels yield the best results, and creative best practices by product subcategories. New for 2019, you\'ll also learn how to quickly grow - and gain more control over - your brand presence on Amazon.<br><br>Download MikMak’s 2019 Holiday eCommerce Guide by completing the form below.',
    buttonText: 'Download the Guide',
    messageForForm: 'Lead completed 2019 Holiday eCommerce Guide Form',
    link: 'https://bit.ly/mikmak-holiday-2019',
    videoLink: 'https://bit.ly/MikMak-Holiday-Webinar'
  }
};

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imports_Partners__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__imports_HeaderLinks__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imports_HeaderContent__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imports_IntroText__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imports_Products__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imports_Press__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imports_Careers__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__imports_Contact__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__imports_Security__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__imports_AttachProducts__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__imports_StudiosProducts__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__imports_SolutionsAndIndustries__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__imports_VerticalPageData__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__imports_AttachFamilyList__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__imports_Whitepaper__ = __webpack_require__(208);



















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {
  headerLinks: __WEBPACK_IMPORTED_MODULE_3__imports_HeaderLinks__["a" /* default */].links,
  introText: __WEBPACK_IMPORTED_MODULE_5__imports_IntroText__["a" /* default */].text,
  headerText: __WEBPACK_IMPORTED_MODULE_4__imports_HeaderContent__["a" /* default */].text,
  subheaderText: __WEBPACK_IMPORTED_MODULE_4__imports_HeaderContent__["a" /* default */].subheaderText,
  promoText: __WEBPACK_IMPORTED_MODULE_4__imports_HeaderContent__["a" /* default */].promoText,
  partnerText: __WEBPACK_IMPORTED_MODULE_2__imports_Partners__["a" /* default */].partnerText,
  partnerList: __WEBPACK_IMPORTED_MODULE_2__imports_Partners__["a" /* default */].partnerList,
  keyPartnerList: __WEBPACK_IMPORTED_MODULE_2__imports_Partners__["a" /* default */].keyPartnerList,
  productList: __WEBPACK_IMPORTED_MODULE_6__imports_Products__["a" /* default */].list,
  pressContent: __WEBPACK_IMPORTED_MODULE_7__imports_Press__["a" /* default */].content,
  contactContent: __WEBPACK_IMPORTED_MODULE_9__imports_Contact__["a" /* default */],
  careersContent: __WEBPACK_IMPORTED_MODULE_8__imports_Careers__["a" /* default */],
  attachProducts: __WEBPACK_IMPORTED_MODULE_11__imports_AttachProducts__["a" /* default */],
  studiosProducts: __WEBPACK_IMPORTED_MODULE_12__imports_StudiosProducts__["a" /* default */],
  solutionsAndIndustries: __WEBPACK_IMPORTED_MODULE_13__imports_SolutionsAndIndustries__["a" /* default */],
  verticalPageData: __WEBPACK_IMPORTED_MODULE_14__imports_VerticalPageData__["a" /* default */],
  attachFamilyList: __WEBPACK_IMPORTED_MODULE_15__imports_AttachFamilyList__["a" /* default */],
  security: __WEBPACK_IMPORTED_MODULE_10__imports_Security__["a" /* default */],
  Whitepaper: __WEBPACK_IMPORTED_MODULE_16__imports_Whitepaper__["a" /* default */],
  cartList: []
};

var mutations = {
  setCartList: function setCartList(state, carts) {
    state.cartList = carts;
  }
};

var actions = {};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_SubHeader__);
//
//
//
//
//
//
//
//


var pageName = 'About';


/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    SubHeader: __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default.a
  },
  methods: {},
  computed: {
    page: function page() {
      return pageName;
    }
  },
  watch: {}
};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Upload more images here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview



/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {},

  methods: {
    getImgUrl: function getImgUrl(slug) {
      return '//mikmak.s3.amazonaws.com/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/attach-' + slug + '.png';
    },
    clickedRequestDemoButton: function clickedRequestDemoButton() {
      var message = 'Clicked request button on Family of Attach area.';
      if (!window.mmProductInterests) window.mmProductInterests = [];
      window.mmProductInterests.push(message);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('requestDemoClicked', {
        sourceOfDemo: message
      });

      this.resetScroll();
    },
    resetScroll: function resetScroll() {
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    }
  },
  computed: {
    attachFamilyList: function attachFamilyList() {
      return this.$store.state.attachFamilyList;
    },
    solutions: function solutions() {
      return this.$store.state.solutionsAndIndustries.solutions;
    },
    industries: function industries() {
      return this.$store.state.solutionsAndIndustries.industries;
    }
  },
  watch: {}
};

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SingleProductComponent__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SingleProductComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SingleProductComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__productScrollHelper__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  props: ['products', 'title', 'subtitle', 'divId', 'backgroundColor', 'mobileCta', 'mobileCtaMessage'],
  data: function data() {
    return {
      shouldShowMainCta: undefined
    };
  },

  components: {
    SingleProductComponent: __WEBPACK_IMPORTED_MODULE_0__SingleProductComponent___default.a
  },
  mounted: function mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.attach-product-wrapper', { delay: 250, duration: 500 })
    this.scrollListener();
  },

  methods: {
    resetScroll: function resetScroll() {
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    },
    scrollListener: function scrollListener() {
      var self = this;
      $(window).scroll(function () {
        var shouldShowMainCta = __WEBPACK_IMPORTED_MODULE_1__productScrollHelper__["a" /* default */].scrollListener(self.divId);
        self.updateShouldShowMainCta(shouldShowMainCta);
      });
    },
    updateShouldShowMainCta: function updateShouldShowMainCta(shouldShow) {
      if (shouldShow && !this.shouldShowMainCta) this.shouldShowMainCta = true;
      if (!shouldShow && this.shouldShowMainCta) this.shouldShowMainCta = false;
    },
    logCtaClick: function logCtaClick() {
      if (!window.mmProductInterests) window.mmProductInterests = [];
      window.mmProductInterests.push(this.mobileCtaMessage);
      this.resetScroll();
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productScrollHelper__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    this.scrollListener();
  },
  data: function data() {
    return {
      shouldShowMainCta: undefined
    };
  },

  methods: {
    logCtaClick: function logCtaClick() {
      if (!window.mmProductInterests) window.mmProductInterests = [];
      window.mmProductInterests.push('Clicked Learn More about Audiences');

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__events_dispatch__["a" /* default */])('requestDemoClicked', {
        product: 'audiences'
      });

      this.resetScroll();
    },
    resetScroll: function resetScroll() {
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    },
    updateShouldShowMainCta: function updateShouldShowMainCta(shouldShow) {
      if (shouldShow && !this.shouldShowMainCta) this.shouldShowMainCta = true;
      if (!shouldShow && this.shouldShowMainCta) this.shouldShowMainCta = false;
    },
    scrollListener: function scrollListener() {
      var self = this;
      $(window).scroll(function () {
        var shouldShowMainCta = __WEBPACK_IMPORTED_MODULE_0__productScrollHelper__["a" /* default */].scrollListener('audiences');
        self.updateShouldShowMainCta(shouldShowMainCta);
      });
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['product'],
  data: function data() {
    return {
      showFeaturesMobile: false
    };
  },
  mounted: function mounted() {},

  methods: {
    resetScroll: function resetScroll() {
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    },
    toggleFeatures: function toggleFeatures() {
      this.showFeaturesMobile = !this.showFeaturesMobile;
    },
    clickProductButton: function clickProductButton(product) {
      var message = product.clickMessage;
      if (!window.mmProductInterests) window.mmProductInterests = [];
      window.mmProductInterests.push(message);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('requestDemoClicked', {
        product: product.slug
      });

      this.resetScroll();
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productScrollHelper__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  props: ['product'],
  data: function data() {
    return {
      currentImageKey: undefined,
      currentImageOptions: 0,
      videoBecameVisible: false
    };
  },
  mounted: function mounted() {
    this.scrollListener();
  },

  methods: {
    restartVideo: function restartVideo() {
      var videoElement = document.getElementById(this.videoId);
      if (videoElement) {
        videoElement.currentTime = 0;
      }
    },
    setGalleryImage: function setGalleryImage(key) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__events_dispatch__["a" /* default */])('attachGalleryProductToggled', {
        product: this.product.slug,
        gallery_view: key
      });
      this.currentImageKey = key;
    },
    scrollListener: function scrollListener() {
      var self = this;
      $(window).scroll(function () {
        var videoBecameVisible = __WEBPACK_IMPORTED_MODULE_0__productScrollHelper__["a" /* default */].scrollListener(self.divId, 500);
        self.updateVideoBecameVisible(videoBecameVisible);
      });
    },
    updateVideoBecameVisible: function updateVideoBecameVisible(shouldShow) {
      if (shouldShow && !this.videoBecameVisible) this.videoBecameVisible = true;
      if (!shouldShow && this.videoBecameVisible) this.videoBecameVisible = false;
    }
  },
  computed: {
    divId: function divId() {
      return 'product-' + this.product.slug;
    },
    videoId: function videoId() {
      return 'video-' + this.product.slug;
    },
    currentImage: function currentImage() {
      this.currentImageOptions = 0;
      var currentKey = this.currentImageKey;
      for (var key in this.product.images) {
        this.currentImageOptions++;
        if (!currentKey) currentKey = key;
      }

      this.currentImageKey = currentKey;
      return this.product.images[currentKey];
    }
  },
  watch: {
    videoBecameVisible: function videoBecameVisible() {
      if (this.videoBecameVisible) {
        this.restartVideo();
      }
    }
  }
};

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductDetailsComponent__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductDetailsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductDetailsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductImageComponent__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductImageComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProductImageComponent__);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  props: ['product'],
  components: {
    ProductDetailsComponent: __WEBPACK_IMPORTED_MODULE_0__ProductDetailsComponent___default.a,
    ProductImageComponent: __WEBPACK_IMPORTED_MODULE_1__ProductImageComponent___default.a
  },
  mounted: function mounted() {},

  computed: {},
  methods: {},
  watch: {}
};

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SingleProductComponent__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SingleProductComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SingleProductComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__productScrollHelper__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  props: ['products', 'title', 'subtitle', 'divId', 'backgroundColor', 'mobileCta', 'mobileCtaMessage'],
  data: function data() {
    return {
      shouldShowMainCta: undefined
    };
  },

  components: {
    SingleProductComponent: __WEBPACK_IMPORTED_MODULE_0__SingleProductComponent___default.a
  },
  mounted: function mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.attach-product-wrapper', { delay: 250, duration: 500 })
    this.scrollListener();
  },

  methods: {
    resetScroll: function resetScroll() {
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    },
    scrollListener: function scrollListener() {
      var self = this;
      $(window).scroll(function () {
        var shouldShowMainCta = __WEBPACK_IMPORTED_MODULE_1__productScrollHelper__["a" /* default */].scrollListener(self.divId);
        self.updateShouldShowMainCta(shouldShowMainCta);
      });
    },
    updateShouldShowMainCta: function updateShouldShowMainCta(shouldShow) {
      if (shouldShow && !this.shouldShowMainCta) this.shouldShowMainCta = true;
      if (!shouldShow && this.shouldShowMainCta) this.shouldShowMainCta = false;
    },
    logCtaClick: function logCtaClick() {
      if (!window.mmProductInterests) window.mmProductInterests = [];
      window.mmProductInterests.push(this.mobileCtaMessage);
      this.resetScroll();
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rellax__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rellax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rellax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_dispatch__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PhoneAndVideoComponent__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PhoneAndVideoComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PhoneAndVideoComponent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    PhoneAndVideoComponent: __WEBPACK_IMPORTED_MODULE_2__PhoneAndVideoComponent___default.a
  },
  mounted: function mounted() {
    var rellax = new __WEBPACK_IMPORTED_MODULE_0_rellax___default.a('.rellax');
  },

  methods: {
    clickedRequestDemoButton: function clickedRequestDemoButton(demo) {
      var message = 'Requested demo from Attach industry/solution page ' + this.vertical;

      if (!window.mmProductInterests) window.mmProductInterests = [];
      window.mmProductInterests.push(message);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__events_dispatch__["a" /* default */])('requestDemoClicked', {
        sourceOfDemo: demo.clickMessage
      });

      this.resetScroll();
    },
    resetScroll: function resetScroll() {
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    },
    getImgUrl: function getImgUrl(brand) {
      var images = __webpack_require__(28);
      return images('./' + brand + '.png');
      // return `//mikmak.s3.amazonaws.com/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/${brand}.png`
    }
  },
  computed: {
    vertical: function vertical() {
      return this.$route.params.vertical;
    },
    pageData: function pageData() {
      if (this.$store.state.verticalPageData[this.vertical]) {
        return this.$store.state.verticalPageData[this.vertical];
      }

      return this.$store.state.verticalPageData['apparel-and-footwear'];
    },
    headerText: function headerText() {
      return this.pageData && this.pageData.title;
    },
    subheaderText: function subheaderText() {
      return this.pageData && this.pageData.subtitle;
    },
    logos: function logos() {
      return this.pageData && this.pageData.logos;
    },
    partnerList: function partnerList() {
      return this.$store.state.partnerList;
    },
    partnerCount: function partnerCount() {
      return this.partnerList && this.partnerList.length;
    },
    halfPartners: function halfPartners() {
      if (this.partnerCount) return parseInt(this.partnerCount / 2);
    }
  },
  watch: {}
};

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['demo'],
  mounted: function mounted() {},

  methods: {},
  computed: {},
  watch: {}
};

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_SubHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_CareersContent__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_CareersContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__content_CareersContent__);
//
//
//
//
//
//
//


var pageName = 'Careers';


/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    SubHeader: __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default.a,
    CareersContent: __WEBPACK_IMPORTED_MODULE_1__content_CareersContent___default.a
  },
  methods: {},
  computed: {
    page: function page() {
      return pageName;
    }
  },
  watch: {}
};

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var formEmail = 'hello@mikmak.tv';

if (window.location.pathname.indexOf('customer_success_manager') != -1) formEmail = 'maorkwom';

var formUrl = 'https://formspree.io/' + formEmail;

var handleFormData = function handleFormData(event) {
  event.preventDefault();
  var formData = $('#mm-contact-form').serializeArray();
  submitForm(formData);
};

var submitForm = function submitForm(formData) {

  if (window.mmProductInterests) {
    formData.push({
      name: 'product_interests',
      value: window.mmProductInterests.join(', ')
    });
  }

  $.ajax({
    url: formUrl,
    method: "POST",
    data: formData,
    dataType: "json"
  }).done(function (data) {
    $('#mm-contact-form-success').show();
    $('#mm-contact-form').hide();
  });
};

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    $('#mm-contact-form').submit(function (e) {
      handleFormData(e);
    });
  },

  methods: {},
  computed: {
    contactContent: function contactContent() {
      return this.$store.state.contactContent;
    }
  },
  watch: {}
};

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      showCookieBanner: true,
      cookieName: 'cookieBannerAccepted'
    };
  },
  mounted: function mounted() {
    var cookieAccepted = window.localStorage.getItem(this.cookieName);
    if (cookieAccepted) this.hideCookieBanner();
  },

  methods: {
    hideCookieBanner: function hideCookieBanner() {
      this.showCookieBanner = false;
      window.localStorage.setItem(this.cookieName, true);
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {},

  methods: {},
  computed: {
    links: function links() {
      return this.$store.state.headerLinks;
    }
  },
  watch: {}
};

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var scrollListener = function scrollListener() {
  if (window.pageYOffset >= 10) {
    setHeaderClass('header-bar scrolled');
  } else {
    setHeaderClass('header-bar');
  }
};

var setHeaderClass = function setHeaderClass(className) {
  document.getElementById('header-bar').className = className;
};

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      mobileMenuVisible: false,
      showMobileSolutions: false,
      showMobileIndustries: false
    };
  },
  mounted: function mounted() {
    this.resetScroll();
    window.document.onscroll = scrollListener;
  },

  methods: {
    goHome: function goHome() {
      window.location = '/';
    },
    toggleMobileMenu: function toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible;
    },
    hideMobileMenu: function hideMobileMenu(pageName) {
      this.linkClickEvent(pageName);
      this.mobileMenuVisible = false;
      this.resetScroll();
    },
    resetScroll: function resetScroll(pageName) {
      this.linkClickEvent(pageName);
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    },
    linkClickEvent: function linkClickEvent(pageName) {
      if (!pageName) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('headerLinkClicked', {
        page: pageName
      });
    }
  },
  computed: {
    links: function links() {
      return this.$store.state.headerLinks;
    },
    solutions: function solutions() {
      return this.$store.state.solutionsAndIndustries.solutions;
    },
    industries: function industries() {
      return this.$store.state.solutionsAndIndustries.industries;
    }
  },
  watch: {}
};

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    if (!window.sr) window.sr = ScrollReveal();
    window.sr.reveal('.intro-text', { delay: 250, duration: 500 });
  },

  methods: {},
  computed: {
    introText: function introText() {
      return this.$store.state.introText;
    }
  },
  watch: {}
};

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    if (!window.sr) window.sr = ScrollReveal();
    window.sr.reveal('.marketing-partners', { delay: 250, duration: 500 });
  },

  methods: {},
  computed: {},
  watch: {}
};

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_SubHeader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    SubHeader: __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default.a
  },
  methods: {
    resetScroll: function resetScroll() {
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    }
  },
  computed: {
    currentRole: function currentRole() {
      var _this = this;

      var role = void 0;
      this.careersContent.positions.map(function (position) {
        if (position.slug == _this.roleSlug) role = position;
      });

      return role;
    },
    careersContent: function careersContent() {
      return this.$store.state.careersContent;
    },
    roleSlug: function roleSlug() {
      var slug = '';
      if (this.$route.params.slug) slug = this.$route.params.slug;

      return slug;
    }
  },
  watch: {}
};

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


// Upload more images here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    if (!window.sr) window.sr = ScrollReveal();
    window.sr.reveal('.partners', { delay: 250, duration: 500 });
  },

  methods: {
    getImgUrl: function getImgUrl(brand) {
      return '//mikmak.s3.amazonaws.com/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/' + brand + '.png';
    }
  },
  computed: {
    partnerText: function partnerText() {
      return this.$store.state.partnerText;
    },
    partnerList: function partnerList() {
      return this.$store.state.partnerList;
    }
  },
  watch: {}
};

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_SubHeader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var pageName = 'Privacy Policy';


/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    SubHeader: __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default.a
  },
  methods: {},
  computed: {
    page: function page() {
      return pageName;
    }
  },
  watch: {}
};

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_SubHeader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var pageName = 'Privacy Policy (Legacy iOS App)';


/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    SubHeader: __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default.a
  },
  methods: {},
  computed: {
    page: function page() {
      return pageName;
    }
  },
  watch: {}
};

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__products_ProductComponent__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__products_ProductComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__products_ProductComponent__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {},

  components: {
    Product: __WEBPACK_IMPORTED_MODULE_0__products_ProductComponent___default.a
  },
  methods: {},
  computed: {
    products: function products() {
      return this.$store.state.productList;
    }
  },
  watch: {}
};

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_regenerator__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_SubHeader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_SubHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_SubHeader__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res, resData, carts;
      return __WEBPACK_IMPORTED_MODULE_2__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch('https://attach-videos.s3.amazonaws.com/cartsInfo.json');

            case 2:
              res = _context.sent;
              _context.next = 5;
              return res.json();

            case 5:
              resData = _context.sent;
              carts = this.cleanCartData(resData);


              this.$store.commit('setCartList', carts);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  data: function data() {
    return {
      allLogosLoaded: false,
      loadedCount: 0,
      selectedCategory: 'All',
      pageName: 'Retail Partners',
      internationalPartners: ['Adidas France', 'Adidas Germany', 'Adidas UK', 'Amazon Canada', 'Amazon Germany', 'Amazon Spain', 'Amazon UK', 'Lancome UK', 'Nars UK', 'Walmart Canada']
    };
  },

  components: {
    SubHeader: __WEBPACK_IMPORTED_MODULE_5__common_SubHeader___default.a
  },
  methods: {
    cleanCartData: function cleanCartData(data) {
      var carts = [];

      for (var cartId in data) {
        if (data[cartId].cartLogo) carts.push(data[cartId]);
      }
      carts = this.alphabetizeCarts(carts);

      return carts || [];
    },
    incrementLoadedCount: function incrementLoadedCount() {
      var minLoadCount = this.$store.state.cartList.length - this.internationalPartners.length;
      if (this.loadedCount >= minLoadCount - 1) {
        this.allLogosLoaded = true;
        return;
      }

      this.loadedCount++;
    },
    alphabetizeCarts: function alphabetizeCarts() {
      var carts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return carts.sort(function (a, b) {
        var nameA = a.cartName.toUpperCase();
        var nameB = b.cartName.toUpperCase();

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;

        // names must be equal
        return 0;
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['cartList']), {
    cartsToShow: function cartsToShow() {
      var _this = this;

      var filteredCarts = [].concat(__WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.cartList));

      if (this.selectedCategory) {
        if (this.selectedCategory !== 'All') {
          if (this.selectedCategory === 'International') {
            filteredCarts = filteredCarts.filter(function (cart) {
              return _this.internationalPartners.indexOf(cart.cartName) !== -1;
            });
          } else {
            filteredCarts = filteredCarts.filter(function (cart) {
              return cart.cartCategory === _this.selectedCategory && _this.internationalPartners.indexOf(cart.cartName) === -1;
            });
          }
        } else {
          filteredCarts = filteredCarts.filter(function (cart) {
            return _this.internationalPartners.indexOf(cart.cartName) === -1;
          });
        }
      }

      return filteredCarts;
    },
    categoryOptions: function categoryOptions() {
      var options = [];

      this.cartList.forEach(function (_ref2) {
        var cartCategory = _ref2.cartCategory;

        if (cartCategory && options.indexOf(cartCategory) === -1) options.push(cartCategory);
      });

      options.sort();
      options.unshift('All');
      options.push('International');

      return options;
    },
    noMatchesFound: function noMatchesFound() {
      return this.cartsToShow && this.cartsToShow.length === 0;
    }
  }),
  watch: {}
};

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_SubHeader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var pageName = 'Security at MikMak';


/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    SubHeader: __WEBPACK_IMPORTED_MODULE_0__common_SubHeader___default.a
  },
  methods: {},
  computed: {
    page: function page() {
      return pageName;
    },
    securityContent: function securityContent() {
      return this.$store.state.security;
    }
  },
  watch: {}
};

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['page'],
  mounted: function mounted() {},

  methods: {},
  computed: {},
  watch: {}
};

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      openRoles: undefined
    };
  },
  mounted: function mounted() {
    var greenhouseDiv = document.getElementById('grnhse_app');
    var greenhouseIframe = document.createElement('script');
    greenhouseIframe.src = 'https://boards.greenhouse.io/embed/job_board/js?for=mikmak';
    greenhouseDiv.appendChild(greenhouseIframe);
  },

  methods: {
    makeShortDesc: function makeShortDesc(desc) {
      desc = desc.split('<div>')[1];
      desc = desc.split('<br')[0];

      return desc.trim();
    }
  },
  computed: {
    careersContent: function careersContent() {
      return this.$store.state.careersContent;
    }
  },
  watch: {}
};

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductDetails__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductDetails__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['product'],
  components: {
    ProductDetails: __WEBPACK_IMPORTED_MODULE_0__ProductDetails___default.a
  },
  mounted: function mounted() {
    if (!window.sr) window.sr = ScrollReveal();
    window.sr.reveal('.product-content-component', { delay: 250, duration: 500 });
  },

  methods: {},
  computed: {},
  watch: {}
};

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['product'],
  mounted: function mounted() {},

  methods: {
    logProductClick: function logProductClick(product) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('requestDemoClicked', {
        product: product.slug
      });
      this.addProductInterest(product);
      this.resetScroll();
    },
    resetScroll: function resetScroll() {
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    },
    addProductInterest: function addProductInterest(product) {
      if (!window.mmProductInterests) window.mmProductInterests = [];
      window.mmProductInterests.push(product.name);
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_dispatch__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_facebookEvent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_linkedInEvent__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  props: ['hideFooterPadding', 'customHeaderText'],
  data: function data() {
    return {
      formIsSubmitted: false,
      formError: false,
      name: '',
      emailAddress: '',
      companyName: '',
      website: '',
      message: '',
      submitInProgress: false
    };
  },
  mounted: function mounted() {
    this.landingPageEvent();
    window.onhashchange = this.landingPageEvent;
  },

  methods: {
    landingPageEvent: function landingPageEvent() {

      var source = '';
      if (window.location.pathname == '/' && window.location.hash == '') {
        source = 'home';
      }
      if (window.location.hash == '#contact-footer') {
        source = 'contact';
      }

      if (source) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__events_facebookEvent__["a" /* default */])('ViewContent', { source: source });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__events_linkedInEvent__["a" /* default */])(source);
      }
    },
    getLink: function getLink(link) {
      return window.location.origin + '/' + link;
    },
    userClickedSubmit: function userClickedSubmit() {
      if (this.formIsValid) {
        var formData = this.getFormData();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__events_dispatch__["a" /* default */])('contactFormSubmitted', formData);
        this.submitFormDataToCopper();
      } else {
        this.setFormError('Please complete all fields.');
      }
    },
    getFormData: function getFormData() {
      return __WEBPACK_IMPORTED_MODULE_0__Users_adamvanlente_Documents_mikmak_mikmak_site_node_modules_babel_runtime_helpers_defineProperty___default()({
        name: this.cleanString(this.name),
        email: this.emailAddress,
        companyName: this.cleanString(this.companyName),
        website: this.cleanString(this.website),
        message: this.cleanString(this.message)
      }, 'companyName', this.companyName);
    },
    cleanString: function cleanString(str) {
      str = str || '';
      return str.replace(/[^a-zA-Z ]/g, '');
    },
    setFormError: function setFormError(msg) {
      var _this = this;

      this.formError = msg;
      setTimeout(function () {
        return _this.formError = false;
      }, 3200);
    },
    submitFormDataToCopper: function submitFormDataToCopper(formData) {
      var _this2 = this;

      if (window.fbq) {
        window.fbq('track', 'Lead', {
          source: 'Standard Contact Form'
        });
      }

      this.submitInProgress = true;
      var message = this.message || 'no message';
      var params = 'name=' + this.name + '&emailAddress=' + this.emailAddress + '&companyName=' + this.companyName + '&message=' + message + '&website=' + this.website;
      var url = 'https://mikmak-microservices.appspot.com/contactFormSubmission?' + params;
      // let url = `http://localhost:5001/contactFormSubmission?${params}`

      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json'
      }).done(function (data) {
        _this2.submitInProgress = false;
        if (data.success) {
          _this2.formIsSubmitted = true;
        } else {
          _this2.setFormError('There was an issue submitting your info. Please try again.');
        }
      });
    },
    fireEmailEvent: function fireEmailEvent() {
      var isValid = this.isEmailValid();
      if (isValid) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__events_dispatch__["a" /* default */])('validEmailInput', {
          emailAddress: this.emailAddress
        });
      }
    },
    isEmailValid: function isEmailValid() {
      var regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;

      var isValid = regex.test(this.emailAddress);

      // Personal emails are not considered valid for firing email event
      if (isValid && this.isPersonalEmail()) isValid = false;

      return isValid;
    },
    isPersonalEmail: function isPersonalEmail() {
      var invalidPersonalEmails = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com', 'comcast.net', 'verizon.net', 'live.com'];

      var domain = this.emailAddress.split('@')[1];
      if (invalidPersonalEmails.includes(domain)) return true;

      return false;
    }
  },
  computed: {
    headerText: function headerText() {
      return this.customHeaderText || 'Contact Us';
    },
    formIsValid: function formIsValid() {
      return this.cleanString(this.name) && this.emailAddress && this.cleanString(this.companyName) && this.cleanString(this.website);
    },
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  },
  watch: {
    emailAddress: __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function () {
      this.fireEmailEvent();
    }, 600)
  }
};

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var scrollListener = function scrollListener() {
  if (window.pageYOffset >= 0) {
    setHeaderClass('header-element scrolled');
  } else {
    setHeaderClass('header-element');
  }
};

var setHeaderClass = function setHeaderClass(className) {
  var header = document.getElementById('header-element');
  if (header) header.className = className;
};



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      mobileMenuVisible: false,
      showGetDemo: false
    };
  },
  mounted: function mounted() {
    window.document.onscroll = scrollListener;

    if (this.$route.name == 'HomePage') this.scrollListener();
  },

  methods: {
    getDemoEvent: function getDemoEvent() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('requestDemoClicked', {
        sourceOfDemo: 'Contact Button in header bar'
      });
    },
    goHome: function goHome() {
      window.location = '/';
    },
    getLink: function getLink(link) {
      return window.location.origin + '/' + link;
    },
    scrollListener: function scrollListener() {
      var self = this;
      $(window).scroll(function () {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 1200 && scrollTop < 4500) {
          self.showGetDemo = true;
        } else {
          self.showGetDemo = false;
        }
      });
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      heroTextMain: 'Shoppable media designed by the social video generation',
      heroTextSub: 'MikMak shortens the path to purchase at your main eRetailers and direct-to-consumer websites.',
      atcButtonHeader: 'Check out on Amazon',
      atcButtonSubHeader: '$11.99 on Amazon.com',
      videoIndex: 0,
      videoSrc: 'https://s3.amazonaws.com/attach-videos/Ai9MWzdNRJCjfyS6U0rd_new_hero_sm.mov',
      allVideos: ['https://s3.amazonaws.com/attach-videos/956838_RTD14oz_1-sm.mp4', // Nesquik
      'https://s3.amazonaws.com/attach-videos/WiGElHSHRde9FxqSxbMX_FRO_NO%20GRAPHICS.mp4', // Shea
      'https://s3.amazonaws.com/attach-videos/sIP4VS5eTdKVFm3x7WNU_V8_Red_FillingSnack%20FaceBook_9x16-REV0_190228.mp4', // V8
      'https://s3.amazonaws.com/attach-videos/RqSTCtY5Ria4qrnRKlWa_EsteeLauder_022719_04b.mp4'],
      logos: ['google', 'instagram', 'facebook', 'snapchat', 'amazon', 'walmart', 'target', 'instacart', 'kroger', 'youtube', 'twitter', 'pinterest']
    };
  },
  mounted: function mounted() {
    if (window.navigator.appVersion.search('iPad') >= 0) this.isIpad = true;
    var v = document.querySelectorAll('video');
    for (var i = 0; i < v.length; i++) {
      if (window.navigator.platform !== 'MacIntel') {
        window.enableInlineVideo(v[i]);
      }
    };
    // this.alternateVideoSrc()
  },

  methods: {
    getDemoEvent: function getDemoEvent() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('requestDemoClicked', {
        sourceOfDemo: 'Main Hero Button'
      });
    },
    alternateVideoSrc: function alternateVideoSrc() {
      var _this = this;

      if (this.videoIndex >= this.allVideos.length) this.videoIndex = 0;
      var vid = this.allVideos[this.videoIndex];
      this.videoSrc = vid;

      setTimeout(function () {
        _this.videoIndex++;
        _this.alternateVideoSrc();
      }, 15000);
    },
    getSocialImageUrl: function getSocialImageUrl(name) {
      var images = __webpack_require__(12);
      return images('./' + name + '.png');
    },
    keyListener: function keyListener(e) {
      var email = e.srcElement.value;
      var emailField = document.getElementById('contact-form-email-address');
      if (emailField) emailField.value = email;
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logos__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StepUseAttachAnywhere__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StepUseAttachAnywhere___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_StepUseAttachAnywhere__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StepOwnYourAudience__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StepOwnYourAudience___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_StepOwnYourAudience__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StepAmazonValueProps__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StepAmazonValueProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StepAmazonValueProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepVerticalValueProps__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StepVerticalValueProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StepVerticalValueProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blob__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__blob__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      videoSrc: '',
      socialLogos: __WEBPACK_IMPORTED_MODULE_0__logos__["a" /* default */].social,
      commerceLogos: __WEBPACK_IMPORTED_MODULE_0__logos__["a" /* default */].commerce
    };
  },

  components: {
    Blob: __WEBPACK_IMPORTED_MODULE_5__blob___default.a,
    StepUseAttachAnywhere: __WEBPACK_IMPORTED_MODULE_1__components_StepUseAttachAnywhere___default.a,
    StepOwnYourAudience: __WEBPACK_IMPORTED_MODULE_2__components_StepOwnYourAudience___default.a,
    StepAmazonValueProps: __WEBPACK_IMPORTED_MODULE_3__components_StepAmazonValueProps___default.a,
    StepVerticalValueProps: __WEBPACK_IMPORTED_MODULE_4__components_StepVerticalValueProps___default.a
  },
  mounted: function mounted() {
    if (!window.sr) window.sr = ScrollReveal();
    window.sr.reveal('.products', { delay: 250, duration: 500 });
  },

  methods: {
    getSocialImageUrl: function getSocialImageUrl(name) {
      var images = __webpack_require__(12);
      return images('./' + name + '.png');
    },
    getWinterImage: function getWinterImage(name) {
      var images = __webpack_require__(189);
      return images('./' + name + '.png');
    },
    getVideoUrl: function getVideoUrl(name) {
      return 'https://s3.amazonaws.com/attach-videos/' + name;
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {},

  methods: {},
  computed: {},
  watch: {}
};

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['buttonMessage'],
  mounted: function mounted() {},

  methods: {
    getDemoEvent: function getDemoEvent() {
      var msg = this.buttonMessage;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('requestDemoClicked', {
        sourceOfDemo: msg
      });
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logos__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetDemoButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetDemoButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GetDemoButton__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      title: 'Grow and Protect Your Brand on Amazon',
      subtitle: 'Use MikMak Attach with Amazon to lift your natural search results, create bundled ASINS, own your Amazon audiences, and guarantee that your authorized product is added to cart every time, regardless of who wins the buy box.',
      socialLogos: __WEBPACK_IMPORTED_MODULE_0__logos__["a" /* default */].audience
    };
  },

  components: {
    DemoButton: __WEBPACK_IMPORTED_MODULE_1__GetDemoButton___default.a
  },
  mounted: function mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.step-four', { delay: 250, duration: 500 })
  },

  methods: {
    logoClass: function logoClass(index) {
      return index % 2 == 0 ? 'even-class' : 'odd-class';
    },
    getSocialImageUrl: function getSocialImageUrl(name) {
      var images = __webpack_require__(12);
      return images('./' + name + '.png');
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logos__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetDemoButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetDemoButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GetDemoButton__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      title: 'Own your shopper audiences across retailers',
      subtitle: 'Capture and convert qualified shoppers who signal they shop at eRetail or DTC. MikMak audiences become one of your top performers. MikMak can send these audiences directly to your preferred ad manager or CDP.',
      socialLogos: __WEBPACK_IMPORTED_MODULE_0__logos__["a" /* default */].audience
    };
  },

  components: {
    DemoButton: __WEBPACK_IMPORTED_MODULE_1__GetDemoButton___default.a
  },
  mounted: function mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.step-four', { delay: 250, duration: 500 })
  },

  methods: {
    logoClass: function logoClass(index) {
      return index % 2 == 0 ? 'even-class' : 'odd-class';
    },
    getSocialImageUrl: function getSocialImageUrl(name) {
      var images = __webpack_require__(12);
      return images('./' + name + '.png');
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logos__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetDemoButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetDemoButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GetDemoButton__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      title: 'Make all of your media shoppable with any eRetailer, anywhere.',
      subtitle: 'With hundreds of retailer integrations, and compatability with any platform & device, you can use Attach to make any media shoppable.',
      socialLogos: __WEBPACK_IMPORTED_MODULE_0__logos__["a" /* default */].social,
      commerceLogos: __WEBPACK_IMPORTED_MODULE_0__logos__["a" /* default */].commerce
    };
  },

  components: {
    DemoButton: __WEBPACK_IMPORTED_MODULE_1__GetDemoButton___default.a
  },
  mounted: function mounted() {},

  methods: {
    logoClass: function logoClass(index) {
      return index % 2 == 0 ? 'even-class' : 'odd-class';
    },
    getSocialImageUrl: function getSocialImageUrl(name) {
      var images = __webpack_require__(12);
      return images('./' + name + '.png');
    },
    getPlayerLink: function getPlayerLink(playerId) {
      return 'https://multicart-dev.mikmak.tv/' + playerId + '?internalVisualTest=true&cb=3251&buildView=true';
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logos__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetDemoButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetDemoButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GetDemoButton__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      title: 'Deliver customer experiences that solve your industry’s pain points',
      subtitle: 'Beauty and Personal Care: improve consumers’ ability to shade and color match online. eGrocery brands: protect your margins by increasing your average order value in one click. Apparel & Footwear: stay ahead of demand by understanding which SKUs are most popular & where.'
    };
  },

  components: {
    DemoButton: __WEBPACK_IMPORTED_MODULE_1__GetDemoButton___default.a
  },
  mounted: function mounted() {},

  methods: {
    logoClass: function logoClass(index) {
      return index % 2 == 0 ? 'even-class' : 'odd-class';
    },
    getSocialImageUrl: function getSocialImageUrl(name) {
      var images = __webpack_require__(12);
      return images('./' + name + '.png');
    },
    getPlayerLink: function getPlayerLink(playerId) {
      return 'https://multicart-dev.mikmak.tv/' + playerId + '?internalVisualTest=true&cb=3251&buildView=true';
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Upload more images here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.partners', { delay: 250, duration: 500 })
  },

  methods: {
    getSocialImageUrl: function getSocialImageUrl(brand) {
      var images = __webpack_require__(28);
      return images('./' + brand + '.png');
    }
  },
  computed: {
    partnerText: function partnerText() {
      return this.$store.state.partnerText;
    },
    partnerList: function partnerList() {
      return this.$store.state.partnerList;
    },
    keyPartnerList: function keyPartnerList() {
      return this.$store.state.keyPartnerList;
    }
  },
  watch: {}
};

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Upload more images here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      maxImages: 100
    };
  },
  mounted: function mounted() {
    if (!window.sr) window.sr = ScrollReveal();
    window.sr.reveal('.press-logos', { delay: 250, duration: 500 });
  },

  methods: {
    getPressImageLogo: function getPressImageLogo(brand) {
      var images = __webpack_require__(28);
      return images('./' + brand + '.png');
    }
  },
  computed: {
    pressContent: function pressContent() {
      return this.$store.state.pressContent;
    }
  },
  watch: {}
};

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blob__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__blob__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      List: [
      // {
      //   name: 'MikMak Studios',
      //   icon: '',
      //   iconClass: '',
      //   bullets: [
      //     'Full-service video production & post-production',
      //     'Content strategy & creative development',
      //     'Social media content creation',
      //     'Product video creation',
      //     'A/B video production tests'
      //   ],
      //   buttonText: 'Request a quote',
      //   videoUrl: 'https://s3.amazonaws.com/attach-videos/KrLJi9lkTyCIbPNT0TCQ_reel-sm-framerate.mov',
      //   text: 'Full-service production specialized in fun, short-form product videos.'
      // },
      {
        name: 'MikMak Academy',
        icon: '',
        iconClass: '',
        bullets: ['How-To and 101\'s', 'Creative best practices', 'Competitive deep dives', 'Building a social commerce & media strategy', 'C-Suite series'],
        buttonText: 'Enroll in a course',
        text: 'Immersive, custom-designed courses to upskill brands for success in the rapidly evolving world of social video commerce. Courses include:'
      }]
    };
  },

  components: {
    Blob: __WEBPACK_IMPORTED_MODULE_0__blob___default.a
  },
  mounted: function mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.services', { delay: 250, duration: 500 })
  },

  methods: {},
  computed: {},
  watch: {}
};

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {},

  methods: {},
  computed: {},
  watch: {}
};

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blob__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__blob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      List: [{
        name: 'Big Box Ecommerce ',
        icon: '🛒',
        iconClass: 'icon-5',
        link: '/attach/big-box-ecommerce'
      }, {
        name: 'Beauty & Personal Care',
        icon: '💄',
        iconClass: 'icon-2',
        link: '/attach/beauty'
      }, {
        name: 'Direct to Consumer Brands',
        icon: '📦',
        iconClass: 'icon-7',
        link: '/attach/direct-to-consumer-brands'
      }, {
        name: 'Apparel & Footwear',
        icon: '👠',
        iconClass: 'icon-1',
        link: '/attach/apparel-and-footwear'
      }, {
        name: 'Working with Influencers',
        icon: '📣',
        iconClass: 'icon-8',
        link: '/attach/working-with-influencers'
      }, {
        name: 'Food & Beverage',
        icon: '🥤',
        iconClass: 'icon-4',
        link: '/attach/food-and-beverage'
      }, {
        name: 'Consumer Electronics',
        icon: '📱',
        iconClass: 'icon-3',
        link: '/attach/consumer-electronics'
      }]
    };
  },

  components: {
    Blob: __WEBPACK_IMPORTED_MODULE_0__blob___default.a
  },
  mounted: function mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.solutions', { delay: 250, duration: 500 })
  },

  methods: {
    solutionClickEvent: function solutionClickEvent(name) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__events_dispatch__["a" /* default */])('solutionLinkClicked', {
        solutionName: name
      });
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {},

  methods: {},
  computed: {},
  watch: {}
};

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_dispatch__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_facebookEvent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_linkedInEvent__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Footer_Footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.landingPageEvent();
  },

  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_3__Footer_Footer___default.a
  },
  methods: {
    landingPageEvent: function landingPageEvent() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__events_facebookEvent__["a" /* default */])('ViewContent', {
        source: 'alcohol'
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__events_linkedInEvent__["a" /* default */])('alcohol');
    },
    clickedRequestDemoButton: function clickedRequestDemoButton(demo) {
      var message = 'Requested demo from Attach industry/solution page Alcohol Whitepaper';

      if (!window.mmProductInterests) window.mmProductInterests = [];
      window.mmProductInterests.push(message);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('requestDemoClicked', {
        sourceOfDemo: demo
      });

      this.resetScroll();
    },
    resetScroll: function resetScroll() {
      setTimeout(function () {
        window.scrollBy(0, -48);
      }, 10);
    }
  },
  computed: {},
  watch: {}
};

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_dispatch__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_facebookEvent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_linkedInEvent__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      formIsSubmitted: false,
      formError: false,
      name: '',
      emailAddress: '',
      companyName: '',
      website: '',
      submitInProgress: false
    };
  },
  mounted: function mounted() {
    this.landingPageEvent();
  },

  methods: {
    landingPageEvent: function landingPageEvent() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__events_facebookEvent__["a" /* default */])('ViewContent', {
        source: 'holiday2019'
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__events_linkedInEvent__["a" /* default */])('holiday2019');
    },
    getImgUrl: function getImgUrl(name) {
      var images = __webpack_require__(188);
      return images('./' + name + '.png');
    },
    getLink: function getLink(link) {
      return window.location.origin + '/' + link;
    },
    userClickedSubmit: function userClickedSubmit() {
      if (this.formIsValid) {
        var formData = this.getFormData();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('whitepaperFormSubmitted', formData);

        // TODO, do we want to submit these folks to Copper as if they filled
        // out the contact form?
        this.submitFormDataToCopper();
        this.formIsSubmitted = true;
      } else {
        this.setFormError('Please complete all fields.');
      }
    },
    getFormData: function getFormData() {
      return {
        name: this.cleanString(this.name),
        email: this.emailAddress,
        companyName: this.cleanString(this.companyName),
        website: this.cleanString(this.website),
        whitepaperName: this.WhitepaperContent.whitepaperNameForEvents
      };
    },
    cleanString: function cleanString(str) {
      str = str || '';
      return str.replace(/[^a-zA-Z ]/g, "");
    },
    setFormError: function setFormError(msg) {
      var _this = this;

      this.formError = msg;
      setTimeout(function () {
        return _this.formError = false;
      }, 3200);
    },
    submitFormDataToCopper: function submitFormDataToCopper(formData) {
      var _this2 = this;

      if (window.fbq) {
        window.fbq('track', 'Lead', {
          source: 'Holiday 2019 Whitepaper'
        });
      }

      this.submitInProgress = true;
      var message = this.WhitepaperContent.messageForForm;
      var params = 'name=' + this.name + '&emailAddress=' + this.emailAddress + '&companyName=' + this.companyName + '&message=' + message + '&website=' + this.website;
      var url = 'https://mikmak-microservices.appspot.com/contactFormSubmission?' + params;
      // let url = `http://localhost:5001/contactFormSubmission?${params}`

      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json'
      }).done(function (data) {
        _this2.submitInProgress = false;
        if (data.success) {
          _this2.formIsSubmitted = true;
        } else {
          _this2.setFormError('There was an issue submitting your info. Please try again.');
        }
      });
    },
    fireEmailEvent: function fireEmailEvent() {
      var isValid = this.isEmailValid();
      if (isValid) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__events_dispatch__["a" /* default */])('validEmailInput', {
          emailAddress: this.emailAddress
        });
      }
    },
    isEmailValid: function isEmailValid() {
      var regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;

      var isValid = regex.test(this.emailAddress);

      // Personal emails are not considered valid for firing email event
      if (isValid && this.isPersonalEmail()) isValid = false;

      return isValid;
    },
    isPersonalEmail: function isPersonalEmail() {
      var invalidPersonalEmails = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com', 'comcast.net', 'verizon.net', 'live.com'];

      var domain = this.emailAddress.split('@')[1];
      if (invalidPersonalEmails.includes(domain)) return true;

      return false;
    }
  },
  computed: {
    formIsValid: function formIsValid() {
      return this.cleanString(this.name) && this.emailAddress && this.cleanString(this.companyName) && this.cleanString(this.website);
    },
    WhitepaperContent: function WhitepaperContent() {
      return this.$store.state.Whitepaper.Holiday2019;
    },
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  },
  watch: {
    emailAddress: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
      this.fireEmailEvent();
    }, 600)
  }
};

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      List: [{
        name: 'MikMak Studios',
        icon: '',
        iconClass: '',
        buttonText: 'Request a quote',
        videoUrl: 'https://s3.amazonaws.com/attach.mikmak.tv/videos/mikmak-sizzle.mp4',
        text: 'Full-service production specialized in fun, short-form product videos.'
      }, {
        name: 'MikMak Academy',
        icon: '',
        iconClass: '',
        buttonText: 'Enroll in a course',
        text: 'Immersive, custom-designed courses to upskill brands for success in the rapidly evolving world of social video commerce. Courses include:'
      }]
    };
  },

  components: {},
  mounted: function mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.why-mikmak', { delay: 250, duration: 500 })
  },

  methods: {},
  computed: {},
  watch: {}
};

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_PressHero_Press__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_PressHero_Press___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_site_PressHero_Press__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_site_Footer_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_site_Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_site_Footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_About__);
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default.a,
    About: __WEBPACK_IMPORTED_MODULE_4__components_About___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_1__components_ContactUs___default.a,
    Press: __WEBPACK_IMPORTED_MODULE_2__components_site_PressHero_Press___default.a,
    FooterBar: __WEBPACK_IMPORTED_MODULE_3__components_site_Footer_Footer___default.a
  }
};

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Whitepaper_Alcohol__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Whitepaper_Alcohol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_site_Whitepaper_Alcohol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CookieBanner__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CookieBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CookieBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default.a,
    Alcohol: __WEBPACK_IMPORTED_MODULE_1__components_site_Whitepaper_Alcohol___default.a,
    CookieBanner: __WEBPACK_IMPORTED_MODULE_2__components_CookieBanner___default.a
  },
  data: function data() {
    return {
      attachTitle: 'MikMak Attach',
      attachSubtitle: 'Improving the post-click and swipe-up commerce experience across every social channel and the open web.',
      studiosTitle: 'MikMak Studios',
      studiosSubtitle: 'Full-service production specialized in fun, short-form product videos.'
    };
  },
  mounted: function mounted() {
    document.addEventListener('touchstart', function () {}, true);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__events_dispatch__["a" /* default */])('pageView');
  },

  computed: {
    attachProducts: function attachProducts() {
      return this.$store.state.attachProducts;
    },
    studiosProducts: function studiosProducts() {
      return this.$store.state.studiosProducts;
    }
  }
};

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {};

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AttachVerticalHeaderComponent_AttachVerticalHeaderComponent__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AttachVerticalHeaderComponent_AttachVerticalHeaderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AttachVerticalHeaderComponent_AttachVerticalHeaderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IntroText__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IntroText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_IntroText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AttachFamily__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AttachFamily___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AttachFamily__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Partners__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Partners___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Partners__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProductWrapper__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProductWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ProductWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_site_PressHero_Press__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_site_PressHero_Press___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_site_PressHero_Press__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_site_Footer_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_site_Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_site_Footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AttachProductComponents_AttachProductComponent__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AttachProductComponents_AttachProductComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AttachProductComponents_AttachProductComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AttachProductComponents_StudiosProductComponent__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AttachProductComponents_StudiosProductComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_AttachProductComponents_StudiosProductComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AttachProductComponents_AudiencesProductComponent__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AttachProductComponents_AudiencesProductComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AttachProductComponents_AudiencesProductComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_MarketingPartners__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_MarketingPartners___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_MarketingPartners__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//


// import HeaderBar from '../components/HeaderBar'
















/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default.a,
    HeaderComponent: __WEBPACK_IMPORTED_MODULE_1__components_AttachVerticalHeaderComponent_AttachVerticalHeaderComponent___default.a,
    IntroText: __WEBPACK_IMPORTED_MODULE_2__components_IntroText___default.a,
    AttachFamily: __WEBPACK_IMPORTED_MODULE_3__components_AttachFamily___default.a,
    Partners: __WEBPACK_IMPORTED_MODULE_4__components_Partners___default.a,
    ProductWrapper: __WEBPACK_IMPORTED_MODULE_5__components_ProductWrapper___default.a,
    Press: __WEBPACK_IMPORTED_MODULE_7__components_site_PressHero_Press___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_6__components_ContactUs___default.a,
    FooterBar: __WEBPACK_IMPORTED_MODULE_8__components_site_Footer_Footer___default.a,
    AttachProductComponent: __WEBPACK_IMPORTED_MODULE_9__components_AttachProductComponents_AttachProductComponent___default.a,
    StudiosProductComponent: __WEBPACK_IMPORTED_MODULE_10__components_AttachProductComponents_StudiosProductComponent___default.a,
    AudiencesProductComponent: __WEBPACK_IMPORTED_MODULE_11__components_AttachProductComponents_AudiencesProductComponent___default.a,
    MarketingPartners: __WEBPACK_IMPORTED_MODULE_12__components_MarketingPartners___default.a
  },
  data: function data() {
    return {
      attachTitle: 'MikMak Attach',
      // attachSubtitle: 'We should consider if we want the same language here still.',
      attachSubtitle: 'Improving the post-click and swipe-up commerce experience across every social channel and the open web.',
      studiosTitle: 'MikMak Studios',
      studiosSubtitle: 'Full-service production specialized in fun, short-form product videos.'
    };
  },
  mounted: function mounted() {
    document.addEventListener('touchstart', function () {}, true);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__events_dispatch__["a" /* default */])('pageView');
  },

  computed: {
    attachProducts: function attachProducts() {
      return this.$store.state.attachProducts;
    },
    studiosProducts: function studiosProducts() {
      return this.$store.state.studiosProducts;
    },
    focusedVertical: function focusedVertical() {
      return this.$route.params.vertical;
    }
  }
};

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_PressHero_Press__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_PressHero_Press___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_site_PressHero_Press__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_site_Footer_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_site_Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_site_Footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Careers__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Careers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Careers__);
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default.a,
    Careers: __WEBPACK_IMPORTED_MODULE_4__components_Careers___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_1__components_ContactUs___default.a,
    FooterBar: __WEBPACK_IMPORTED_MODULE_3__components_site_Footer_Footer___default.a
  }
};

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Whitepaper_Holiday2019__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Whitepaper_Holiday2019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_site_Whitepaper_Holiday2019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CookieBanner__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CookieBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CookieBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default.a,
    Holiday2019: __WEBPACK_IMPORTED_MODULE_1__components_site_Whitepaper_Holiday2019___default.a,
    CookieBanner: __WEBPACK_IMPORTED_MODULE_2__components_CookieBanner___default.a
  },
  data: function data() {
    return {
      attachTitle: 'MikMak Attach',
      attachSubtitle: 'Improving the post-click and swipe-up commerce experience across every social channel and the open web.',
      studiosTitle: 'MikMak Studios',
      studiosSubtitle: 'Full-service production specialized in fun, short-form product videos.'
    };
  },
  mounted: function mounted() {
    document.addEventListener('touchstart', function () {}, true);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__events_dispatch__["a" /* default */])('pageView');
  },

  computed: {
    attachProducts: function attachProducts() {
      return this.$store.state.attachProducts;
    },
    studiosProducts: function studiosProducts() {
      return this.$store.state.studiosProducts;
    }
  }
};

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_HeroContent_HeroContent__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_HeroContent_HeroContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_site_HeroContent_HeroContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_PartnersHero_PartnersHero__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_PartnersHero_PartnersHero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_site_PartnersHero_PartnersHero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_site_MikMakAttach_MikMakAttach__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_site_MikMakAttach_MikMakAttach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_site_MikMakAttach_MikMakAttach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_site_Solutions_Solutions__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_site_Solutions_Solutions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_site_Solutions_Solutions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_site_Services_Services__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_site_Services_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_site_Services_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_site_WhyMikMak_WhyMikMak__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_site_WhyMikMak_WhyMikMak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_site_WhyMikMak_WhyMikMak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_site_PressHero_Press__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_site_PressHero_Press___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_site_PressHero_Press__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_site_Footer_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_site_Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_site_Footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CookieBanner__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CookieBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_CookieBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__events_dispatch__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default.a,
    HeroContent: __WEBPACK_IMPORTED_MODULE_1__components_site_HeroContent_HeroContent___default.a,
    PartnersHero: __WEBPACK_IMPORTED_MODULE_2__components_site_PartnersHero_PartnersHero___default.a,
    MikMakAttach: __WEBPACK_IMPORTED_MODULE_3__components_site_MikMakAttach_MikMakAttach___default.a,
    Solutions: __WEBPACK_IMPORTED_MODULE_4__components_site_Solutions_Solutions___default.a,
    Services: __WEBPACK_IMPORTED_MODULE_5__components_site_Services_Services___default.a,
    WhyMikMak: __WEBPACK_IMPORTED_MODULE_6__components_site_WhyMikMak_WhyMikMak___default.a,
    Press: __WEBPACK_IMPORTED_MODULE_7__components_site_PressHero_Press___default.a,
    Footer: __WEBPACK_IMPORTED_MODULE_8__components_site_Footer_Footer___default.a,
    CookieBanner: __WEBPACK_IMPORTED_MODULE_9__components_CookieBanner___default.a
  },
  data: function data() {
    return {
      attachTitle: 'MikMak Attach',
      attachSubtitle: 'Improving the post-click and swipe-up commerce experience across every social channel and the open web.',
      studiosTitle: 'MikMak Studios',
      studiosSubtitle: 'Full-service production specialized in fun, short-form product videos.'
    };
  },
  mounted: function mounted() {
    document.addEventListener('touchstart', function () {}, true);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__events_dispatch__["a" /* default */])('pageView');
  },

  computed: {
    attachProducts: function attachProducts() {
      return this.$store.state.attachProducts;
    },
    studiosProducts: function studiosProducts() {
      return this.$store.state.studiosProducts;
    }
  }
};

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterBar__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_OpenPositions__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_OpenPositions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_OpenPositions__);
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default.a,
    OpenPositions: __WEBPACK_IMPORTED_MODULE_3__components_OpenPositions___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_1__components_ContactUs___default.a,
    FooterBar: __WEBPACK_IMPORTED_MODULE_2__components_FooterBar___default.a
  }
};

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContactUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Privacy__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Privacy__);
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header___default.a,
    Privacy: __WEBPACK_IMPORTED_MODULE_3__components_Privacy___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_2__components_ContactUs___default.a,
    FooterBar: __WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer___default.a
  }
};

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContactUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PrivacyApp__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PrivacyApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PrivacyApp__);
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header___default.a,
    PrivacyApp: __WEBPACK_IMPORTED_MODULE_3__components_PrivacyApp___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_2__components_ContactUs___default.a,
    FooterBar: __WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer___default.a
  }
};

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  beforeMount: function beforeMount() {
    window.location = 'https://www.mikmak.tv/home';
  }
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Footer_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_site_Footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RetailPartners__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RetailPartners___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_RetailPartners__);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_site_Header_Header___default.a,
    RetailPartners: __WEBPACK_IMPORTED_MODULE_2__components_RetailPartners___default.a,
    FooterBar: __WEBPACK_IMPORTED_MODULE_1__components_site_Footer_Footer___default.a
  }
};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContactUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Security__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Security___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Security__);
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_site_Header_Header___default.a,
    Security: __WEBPACK_IMPORTED_MODULE_3__components_Security___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_2__components_ContactUs___default.a,
    FooterBar: __WEBPACK_IMPORTED_MODULE_0__components_site_Footer_Footer___default.a
  }
};

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/app-store.19eb94c7.png";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/attach-gif-demo.0818a471.gif";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/black-device.cab69be2.png";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gray-device.f3855804.png";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/holiday-2019-a.1c8a1731.png";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/holiday-2019-b.2957b461.png";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-circle-logo-black-transparent.13a99f36.png";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-circle-logo-black.92f461ee.png";

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-circle-logo-white-transparent.40611fad.png";

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-circle-logo-white.10bed5a6.png";

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-logo-white.04e41dd0.png";

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mikmak-logo.fc3efef9.png";

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/white-device.aaf09f56.png";

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/direct-audience-left.5f9d273a.png";

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/social-audience-right.ab0b102c.png";

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(341)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(479),
  /* scopeId */
  "data-v-570c8497",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(334)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  "data-v-39503a22",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(335)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(473),
  /* scopeId */
  "data-v-4254e8f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(346)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(485),
  /* scopeId */
  "data-v-5f1d28d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  "data-v-52a37036",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(337)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  "data-v-50b375ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(323)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(458),
  /* scopeId */
  "data-v-1b2d2fc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  "data-v-8a0d35f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(345)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  "data-v-5ea0a32a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(501),
  /* scopeId */
  "data-v-d70bfd82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  "data-v-5d7bcf02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  "data-v-f70ee460",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(326)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(462),
  /* scopeId */
  "data-v-2256abc3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(456),
  /* scopeId */
  "data-v-129cce0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(362)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  "data-v-e5af926c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  "data-v-07fe6791",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(325)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(461),
  /* scopeId */
  "data-v-1fa69a92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(324)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(460),
  /* scopeId */
  "data-v-1f5929df",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  "data-v-041ca88a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(342)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  "data-v-58bb2db4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(330)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(467),
  /* scopeId */
  "data-v-2d78cfa6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(498),
  /* scopeId */
  "data-v-b7d93580",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  "data-v-0b4f0463",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(332)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(469),
  /* scopeId */
  "data-v-35b52aa8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  "data-v-eed6e226",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  "data-v-61a4c84d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(491),
  /* scopeId */
  "data-v-7d027edd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(331)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(468),
  /* scopeId */
  "data-v-3416d310",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(327)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(464),
  /* scopeId */
  "data-v-26d60cb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  "data-v-0c96e242",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(497),
  /* scopeId */
  "data-v-aba5e5ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(455),
  /* scopeId */
  "data-v-0d2d574d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  "data-v-ef440326",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(343)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(482),
  /* scopeId */
  "data-v-5a32d58c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(457),
  /* scopeId */
  "data-v-1a127b23",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(333)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(470),
  /* scopeId */
  "data-v-36397cf8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(338)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  "data-v-5261edf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(329)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(466),
  /* scopeId */
  "data-v-2c30b924",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  "data-v-06c79b62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(463),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(336)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  "data-v-4380610c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(500),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(328)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  "data-v-28d330ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(488),
  /* scopeId */
  "data-v-749dd8ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(472),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(459),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(493),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(492),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeaderBar'), _vm._v(" "), _c('PrivacyApp'), _vm._v(" "), _c('FooterBar')], 1)
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, _vm._l((_vm.products), function(product) {
    return _c('Product', {
      key: "product.id",
      attrs: {
        "id": product.name,
        "product": product
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "why-mikmak"
  }, [_c('div', {
    staticClass: "whitespace",
    attrs: {
      "id": "whitespace"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "why-mikmak-heading"
  }, [_vm._v("Why MikMak?")]), _vm._v(" "), _c('div', {
    staticClass: "why-mikmak-table"
  }, [_c('div', {
    staticClass: "table-row"
  }, [_c('span', {
    staticClass: "table-column blank"
  }), _vm._v(" "), _c('span', {
    staticClass: "table-column header blank"
  }, [_vm._v("Brands sold at retailers")]), _vm._v(" "), _c('span', {
    staticClass: "table-column header blank"
  }, [_vm._v("DTC Brands")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('span', {
    staticClass: "table-column legend"
  }, [_c('i', [_vm._v("Problem")]), _vm._v(": User clicks or swipes from media")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("No PDP data & no control over experience.")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("70-90% of users bounce from site.")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('span', {
    staticClass: "table-column legend"
  }, [_c('i', [_vm._v("Solution")]), _vm._v(": MikMak Attach")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("Connect to retailers like Amazon, Target, Walmart, Kroger, Instacart, CVS and more.")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("Connect to your own DTC Cart like Demandware, Shopify, Magento, Hybris and more.")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('span', {
    staticClass: "table-column legend"
  }, [_c('i', [_vm._v("The MikMak ROI")])]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("Custom Audiences, 15-200% lift, 25-40% higher ROAS, 1.5X lift in CPA efficiency and 2X lift in CTR.")]), _vm._v(" "), _c('span', {
    staticClass: "table-column"
  }, [_vm._v("Reduce bounce rates by 20%, 20-40% lift in add to cart rate, 1.5X lift in CPA efficiency and 2X lift in CTR.")])])])])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('div', {
    staticClass: "partners-heading block-heading-font-style"
  }, [_vm._v(_vm._s(_vm.partnerText.heading))]), _vm._v(" "), _c('div', {
    staticClass: "partners-subheading block-subheading-font-style"
  }, [_vm._v(_vm._s(_vm.partnerText.subheading))]), _vm._v(" "), _c('span', {
    staticClass: "partner-logos"
  }, _vm._l((_vm.partnerList), function(partner) {
    return _c('img', {
      attrs: {
        "src": _vm.getImgUrl(partner),
        "alt": "partner"
      }
    })
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product product-content-component",
    style: (_vm.product.boxStyles)
  }, [_c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-content-detail-left product-content-detail",
    class: [_vm.product.orientation == 'right' ? 'hidden-element' : '']
  }, [_c('ProductDetails', {
    attrs: {
      "product": _vm.product
    }
  })], 1), _vm._v(" "), (_vm.product.device) ? _c('div', {
    staticClass: "product-content-device",
    class: [_vm.product.device.color == 'white-device' ? 'white-device' : '', _vm.product.device.color == 'gray-device' ? 'gray-device' : '', _vm.product.device.color == 'black-device' ? 'black-device' : ''],
    style: ({
      transform: 'rotate(' + _vm.product.device.rotation + ')'
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.product.device.image,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product.name == 'Measure') ? _c('div', {
    staticClass: "product-content-measure"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-content-detail-right product-content-detail",
    class: [_vm.product.orientation == 'left' ? 'hidden-element' : '']
  }, [_c('ProductDetails', {
    attrs: {
      "product": _vm.product
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-block-inner step-one"
  }, [_c('span', {
    staticClass: "product-block-span step-one-top-margin"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-commerce-logos"
  }, _vm._l((_vm.commerceLogos), function(logo, index) {
    return _c('span', {
      class: ("social-logo " + logo + "-social-logo " + (_vm.logoClass(index)))
    }, [_c('img', {
      attrs: {
        "src": _vm.getSocialImageUrl(logo)
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "hero-social-logos"
  }, _vm._l((_vm.socialLogos), function(logo, index) {
    return _c('span', {
      class: ("social-logo " + logo + "-social-logo " + (_vm.logoClass(index)))
    }, [_c('img', {
      attrs: {
        "src": _vm.getSocialImageUrl(logo)
      }
    })])
  }), 0), _vm._v(" "), _c('DemoButton', {
    attrs: {
      "buttonMessage": 'Software, Use Attach'
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "product-block-span step-one-images animated"
  }, [_c('img', {
    staticClass: "phone-image player-attach-content",
    attrs: {
      "src": __webpack_require__(20)
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "phone-image-inner",
    attrs: {
      "src": "https://s3.amazonaws.com/attach-videos/XMpqlCjT82Cgip0hnQF1_attach_anywhere_sm.mov",
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "macbook-image player-attach-content",
    attrs: {
      "src": __webpack_require__(50)
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "macbook-image-inner",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/eWkquuN0R1K6Y5BYB2JA_attach_anywhere_desktopV3.mp4",
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  })
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('h1', {
    staticClass: "partner-heading"
  }, [_vm._v("The world's best choose us")]), _vm._v(" "), _c('span', {
    staticClass: "partner-logos"
  }, _vm._l((_vm.keyPartnerList), function(partner) {
    return _c('img', {
      attrs: {
        "src": _vm.getSocialImageUrl(partner),
        "alt": "partner"
      }
    })
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marketing-partners"
  }, [_c('div', {
    staticClass: "partners-heading block-heading-font-style"
  }, [_vm._v("Vetted for Excellence")]), _vm._v(" "), _c('div', {
    staticClass: "partners-subheading block-subheading-font-style"
  }, [_vm._v("MikMak is proud to announce that we have been named as a Marketing Partner by Facebook, Snapchat and Instagram.")]), _vm._v(" "), _c('span', {
    staticClass: "partner-logos"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/business/solutions-explorer/community_management/278913029298091/MikMak",
      "target": "new"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": __webpack_require__(117)
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "partner-logo snap-logo",
    attrs: {
      "src": __webpack_require__(121)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/business/solutions-explorer/community_management/278913029298091/MikMak",
      "target": "new"
    }
  }, [_c('img', {
    staticClass: "partner-logo",
    attrs: {
      "src": __webpack_require__(118)
    }
  })])])])
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solutions"
  }, [_c('div', {
    staticClass: "our-solutions",
    attrs: {
      "id": "our-solutions"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "solution-heading"
  }, [_vm._v("Explore Solutions")]), _vm._v(" "), _c('div', {
    staticClass: "-wrapper"
  }, _vm._l((_vm.List), function(solution) {
    return _c('a', {
      staticClass: "-item",
      attrs: {
        "href": solution.link
      },
      on: {
        "click": function($event) {
          return _vm.solutionClickEvent(solution.name)
        }
      }
    }, [_c('i', {
      class: ("icon " + (solution.iconClass)),
      domProps: {
        "innerHTML": _vm._s(solution.icon)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "solution-name"
    }, [_vm._v(_vm._s(solution.name))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach-product-wrapper",
    style: (("background-color: " + _vm.backgroundColor)),
    attrs: {
      "id": _vm.divId
    }
  }, [_c('div', {
    staticClass: "block-heading-font-style"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "block-subheading-font-style"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "product-item"
    }, [_c('SingleProductComponent', {
      attrs: {
        "product": product
      }
    })], 1)
  }), _vm._v(" "), _c('a', {
    staticClass: "mobile-cta-button",
    class: [_vm.shouldShowMainCta ? 'mobile-cta-button-visible' : 'mobile-cta-button-hidden'],
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.logCtaClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.mobileCta) + "\n  ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeaderBar'), _vm._v(" "), _c('Privacy'), _vm._v(" "), _c('FooterBar')], 1)
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('SubHeader', {
    attrs: {
      "page": _vm.page
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-content block-el"
  }, [_c('p', [_c('strong', [_vm._v("Last Revised: December 15, 2014")])]), _vm._v(" "), _c('p', [_vm._v("TIPO Entertainment, Inc. dba MikMak (\""), _c('strong', [_vm._v("MikMak")]), _vm._v("\") is committed to protecting your privacy. We have prepared this Privacy Policy to describe to you our practices regarding the Personal Data (as defined below) we collect from users of our website, located at "), _c('a', {
    attrs: {
      "href": "http://www.mikmak.tv"
    }
  }, [_vm._v("www.mikmak.tv")]), _vm._v(", and our mobile application ( "), _c('strong', [_vm._v("\"Application\"")]), _vm._v(" )(collectively, the \""), _c('strong', [_vm._v("Site")]), _vm._v("\") and online services ( "), _c('strong', [_vm._v("\"Services\"")]), _vm._v(" ).")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("1. Questions; Contacting MikMak; Reporting Violations.")]), _vm._v(" If you have any questions or concerns or complaints about our Privacy Policy or our data collection or processing practices, or if you want to report any security violations to us, please contact us at the following address, phone number, or e-mail address:")]), _vm._v(" "), _c('p', [_vm._v("MikMak,")]), _vm._v(" "), _c('p', [_vm._v("105 Rivington, Floor 2\n      New York, NY 10002,\n      Attn: Legal Affairs")]), _vm._v(" "), _c('p', [_vm._v("1-844-645-6251")]), _vm._v(" "), _c('p', [_vm._v("support@mikmak.tv")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2. User Consent.")]), _vm._v(" By submitting Personal Data through our Site or Services, you agree to the terms of this Privacy Policy and you expressly consent to the collection, use and disclosure of your Personal Data in accordance with this Privacy Policy. ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("3. A Note to Users Outside of the United States. If you are a non U.S. user of the Site, by visiting the Site and providing us with data, you acknowledge and agree that your Personal Data may be processed for the purposes identified in the Privacy Policy. In addition, your Personal Data may be processed in the country in which it was collected and in other countries, including the United States, where laws regarding processing of Personal Data may be less stringent than the laws in your country. By providing your data, you consent to such transfer.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4. Types of Data We Collect.")]), _vm._v(" \"Personal Data\" means data that allows someone to identify or contact you, including, for example, your name, address, telephone number, e-mail address, as well as any other non-public information about you that is associated with or linked to any of the foregoing data. \"Anonymous Data\" means data that is not associated with or linked to your Personal Data; Anonymous Data does not, by itself, permit the identification of individual persons. We collect Personal Data and Anonymous Data, as described below.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(a) Information You Provide to Us.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("We may collect Personal Data from you, such as your first name, last name, e-mail address, and password when you create an account to log in to our network (\"Account\"). ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("If you use our Services on your mobile device, including through our Application, we may collect your phone number and the unique device id number.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("If you tell us where you are (e.g., by allowing your mobile device to send us your location), we may store and use that information to provide you with location-based information and advertising. ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("When connecting to our Services via a service provider that uniquely identifies your mobile device, we may receive this identification and use it to offer extended services and/or functionality.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("When you order products on our Site, we will collect all information necessary to complete the transaction, including your name, credit card information, billing information and shipping information.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("If you provide us feedback or contact us via e-mail, we will collect your name and e-mail address, as well as any other content included in the e-mail, in order to send you a reply. This information may be shared with third parties who help process and fulfill your purchases. ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("When you participate in one of our surveys, we may collect additional profile information.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("We may also collect Personal Data at other points in our Site that state that Personal Data is being collected.")])])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(b) Information You Provide to Facebook.")]), _vm._v(" Our Site allows you to create an Account by logging into your Facebook account. If you login through your Facebook account, we may also collect other Personal Data about you from Facebook, such as your age, ethnicity, gender, marital status, interest, hobbies, and location. If you are already logged into Facebook, you will be prompted to share your profile information. If you are not logged into Facebook, when you click on the Facebook link, you will be prompted to enter your Facebook credentials or to \"Sign Up\" for a Facebook account. By proceeding, you are agreeing to Facebook's terms of use and allowing us to access information you provide to Facebook.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(c) Information Collected via Technology.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("Information Collected by Our Servers. To make our Site and Services more useful to you, our servers (which may be hosted by a third party service provider) collect information from you, including your browser type, operating system, Internet Protocol (\"IP\") address (a number that is automatically assigned to your computer when you use the Internet, which may vary from session to session), domain name, and/or a date/time stamp for your visit. ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Log Files. As is true of most websites, we gather certain information automatically and store it in log files. This information includes IP addresses, browser type, Internet service provider (\"ISP\"), referring/exit pages, operating system, date/time stamp, and clickstream data. We use this information to analyze trends, administer the Site, track users' movements around the Site, gather demographic information about our user base as a whole, and better tailor our Services to our users' needs. For example, some of the information may be collected so that when you visit the Site or the Services again, it will recognize you and the information could then be used to serve advertisements and other information appropriate to your interests. Except as noted in this Privacy Policy, we do not link this automatically-collected data to Personal Data.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Like many online services, we use cookies to collect information. \"Cookies\" are small pieces of information that a website sends to your computer's hard drive while you are viewing the website. We may use both session Cookies (which expire once you close your web browser) and persistent Cookies (which stay on your computer until you delete them) to provide you with a more personal and interactive experience on our Site. This type of information is collected to make the Site more useful to you and to tailor the experience with us to meet your special interests and needs. ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Collection of Data by Advertisers. We may also use third parties to serve ads on the Site. Certain third parties may automatically collect information about your visits to this and other websites, your IP address, your ISP, the browser you use to visit our Site (but not your name, address, e-mail address or telephone number). They do this by using Cookies or other technologies. Information collected may be used, among other things, to deliver advertising targeted to your interests and to better understand the usage and visitation of our Site and the other sites tracked by these third parties. This policy does not apply to, and we are not responsible for, Cookies or pixel tags in third party ads, and we encourage you to check the privacy policies of advertisers and/or ad services to learn about their use of Cookies and other technologies. If you would like more information about this practice and to know your choices about not having this information used by these companies, click "), _c('a', {
    attrs: {
      "href": "http://www.aboutads.info/choices"
    }
  }, [_vm._v("here")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "http://www.networkadvertising.org"
    }
  }, [_vm._v("here")]), _vm._v(". We do not currently respond to \"do not track\" signals from web browsers.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Flash LSOs. When we post videos, third parties may use local shared objects, known as \"Flash Cookies,\" to store your preferences for volume control or to personalize certain video features. Flash Cookies are different from browser Cookies because of the amount and type of data and how the data is stored. Cookie management tools provided by your browser will not remove Flash Cookies. To learn how to manage privacy and storage settings for Flash Cookies, click "), _c('a', {
    attrs: {
      "href": "http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html."
    }
  }, [_vm._v("here")]), _vm._v(". ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Mobile Services. We may also collect non-personal information from your mobile device if you have downloaded our Application. This information is generally used to help us deliver the most relevant information to you. Examples of information that may be collected and used include your geographic location, how you use the Application, and information about the type of device you use. In addition, in the event our Application crash on your mobile device, we will receive information about your mobile device model software version and device carrier, which allows us to identify and fix bugs and otherwise improve the performance of our Application. This information is sent to us as aggregated information and is not traceable to any individual and cannot be used to identify an individual. ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Google Analytics. We use Google Analytics to help analyze how users use the Site. Google Analytics uses Cookies to keep (i) records of users' login names, passwords, and shopping carts and (ii) collect information such as how often users visit the Site, what pages they visit, and what other sites they used prior to coming to the Site. We use the information we get from Google Analytics to improve our Site and Services and to personalize the Site to your interests. Google Analytics collects only the IP address assigned to you on the date you visit the Site, rather than your name or other personally identifying information. We do not combine the information generated through the use of Google Analytics with your Personal Data. Although Google Analytics plants a persistent Cookie on your web browser to identify you as a unique user the next time you visit the Site, the Cookie cannot be used by anyone but Google. Google's ability to use and share information collected by Google Analytics about your visits to the Site is restricted by the Google Analytics Terms of Use and the Google Privacy Policy. ")])])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(d) Information Collected from You About Others.")]), _vm._v(" If you decide to invite a third party to create an Account, we will collect your and the third party's names and e-mail addresses in order to send an e-mail and follow up with the third party. We rely upon you to obtain whatever consents from the third party that may be required by law to allow us to access and upload the third party's names and e-mail addresses as required above. You or the third party may contact us at support@mikmak.tv to request the removal of this information from our database.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("5. Use of Your Personal Data")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(a) General Use.")]), _vm._v(" In general, Personal Data you submit to us is used either to respond to requests that you make, or to aid us in serving you better. We use your Personal Data in the following ways: ")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("facilitate the creation of and secure your Account on our network; ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("identify you as a user in our system; ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("provide improved administration of our Site and Services; ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("direct to you videos and merchandise we believe will be of interest to you;")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("improve the quality of experience when you interact with our Site and Services; ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("send you a welcome e-mail to verify ownership of the e-mail address provided when your Account was created; ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("send you administrative e-mail notifications, such as security, or support and maintenance advisories;")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("respond to your inquiries related to employment opportunities or other requests; ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("make telephone calls to you, from time to time, as a part of secondary fraud protection or to solicit your feedback; and ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("send newsletters, surveys, offers, and other promotional materials related to our Services and for other marketing purposes of MikMak.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("manage your transactions on MikMak")])])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(b) User Testimonials and Feedback.")]), _vm._v(" We often receive testimonials and comments from users who have had positive experiences with our Services. We occasionally publish such content. When we publish this content, we may identify our users by their first and last name and may also indicate their home city. We obtain the user's consent prior to posting his or her name along with the testimonial.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(c) Creation of Anonymous Data.")]), _vm._v(" We may create Anonymous Data records from Personal Data by excluding information (such as your name) that makes the data personally identifiable to you. We use this Anonymous Data to analyze request and usage patterns so that we may enhance the content of our Services and improve Site navigation. We reserve the right to use Anonymous Data for any purpose and disclose Anonymous Data to third parties in our sole discretion.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("6. Disclosure of Your Personal Data.")]), _vm._v(" We disclose your Personal Data as described below and as described elsewhere in this Privacy Policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(a) Third Party Service Providers.")]), _vm._v(" We may share your Personal Data with third party service providers to: provide you with the Services that we offer you through our Site; to conduct quality assurance testing; to facilitate creation of accounts; to provide technical support; and/or to provide other services to MikMak. ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(b) Affiliates")]), _vm._v(" We may share some or all of your Personal Data with our parent company, subsidiaries, joint ventures, or other companies under a common control (\"Affiliates\"), in which case we will require our Affiliates to honor this Privacy Policy. ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(c) Corporate Restructuring.")]), _vm._v(" We may share some or all of your Personal Data in connection with or during negotiation of any merger, financing, acquisition or dissolution transaction or proceeding involving sale, transfer, divestiture, or disclosure of all or a portion of our business or assets. In the event of an insolvency, bankruptcy, or receivership, Personal Data may also be transferred as a business asset. If another company acquires our company, business, or assets, that company will possess the Personal Data collected by us and will assume the rights and obligations regarding your Personal Data as described in this Privacy Policy.\n      "), _c('strong', [_vm._v("(d) Social Networking Sites.")]), _vm._v(" Our Site and Services may enable you to post content to social networking sites (\"SNSs\") (e.g., Facebook). If you choose to do this, we will provide information to such SNSs in accordance with your elections. You acknowledge and agree that you are solely responsible for your use of those websites and that it is your responsibility to review the terms of use and privacy policy of the third party provider of such SNSs. We will not be responsible or liable for: (i) the availability or accuracy of such SNSs; (ii) the content, products or services on or availability of such SNSs; or (iii) your use of any such SNSs.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(e) Other Disclosures.")]), _vm._v(" Regardless of any choices you make regarding your Personal Data (as described below), MikMak may disclose Personal Data if it believes in good faith that such disclosure is necessary (a) in connection with any legal investigation; (b) to comply with relevant laws or to respond to subpoenas or warrants served on MikMak; (c) to protect or defend the rights or property of MikMak or users of the Site or Services; and/or (d) to investigate or assist in preventing any violation or potential violation of the law, this Privacy Policy, or our Terms of Use.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("7. Third Party Websites.")]), _vm._v(" Our Site may contain links to third party websites. When you click on a link to any other website or location, you will leave our Site and go to another site, and another entity may collect Personal Data or Anonymous Data from you. We have no control over, do not review, and cannot be responsible for, these outside websites or their content. Please be aware that the terms of this Privacy Policy do not apply to these outside websites or content, or to any collection of your Personal Data after you click on links to such outside websites. We encourage you to read the privacy policies of every website you visit. The links to third party websites or locations are for your convenience and do not signify our endorsement of such third parties or their products, content or websites.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("8. Your Choices Regarding Information.")]), _vm._v(" You have several choices regarding the use of information on our Service:")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(a)Email Communications.")]), _vm._v(" We will periodically send you free newsletters and e-mails that directly promote the use of our Site or Services. When you receive newsletters or promotional communications from us, you may indicate a preference to stop receiving further communications from us and you will have the opportunity to \"opt-out\" by following the unsubscribe instructions provided in the e-mail you receive or by contacting us directly (please see contact information above). Despite your indicated e-mail preferences, we may send you service related communications, including notices of any updates to our Terms of Use or Privacy Policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(b) Cookies.")]), _vm._v(" If you decide at any time that you no longer wish to accept Cookies from our Service for any of the purposes described above, then you can instruct your browser, by changing its settings, to stop accepting Cookies or to prompt you before accepting a Cookie from the websites you visit. Consult your browser's technical information. If you do not accept Cookies, however, you may not be able to use all portions of the Service or all functionality of the Service. If you have any questions about how to disable or modify Cookies, please let us know at the contact information provided above.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(c) De-Linking SNS.")]), _vm._v(" If you decide at any time that you no longer wish to have your SNS account (e.g., Facebook) linked to your Account, then you may de-link the SNS account in the \"preferences\" section in your account settings. You may also manage the sharing of certain Personal Data with us when you connect with us through an SNS, such as through Facebook Connect. Please refer to the privacy settings of the SNS to determine how you may adjust our permissions and manage the interactivity between the Services and your social media account or mobile device. ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(d) Changing or Deleting Your Personal Data.")]), _vm._v(" You may change any of your Personal Data in your Account by editing your profile within your Account or by sending an e-mail to us at the e-mail address set forth above. You may request deletion of your Personal Data by us, and we will use commercially reasonable efforts to honor your request, but please note that we may be required to keep such information and not delete it (or to keep this information for a certain time, in which case we will comply with your deletion request only after we have fulfilled such requirements). When we delete any information, it will be deleted from the active database, but may remain in our archives. We may also retain your information for fraud prevention or similar purposes. ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(e) Applications.")]), _vm._v(" You can stop all collection of information by the Application by uninstalling the Application. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network. To serve ads in our Application where Cookie technology is not available, the Company hashes users' device ID. Users may choose to reset or opt out of anonymous IDs at any time. If users choose to opt out, ads delivered to the Application by ad serving technology will not be served on an anonymous ID. You may at any time opt-out from further allowing us to have access to your location data by uninstalling the Application or deactivating GPS on your mobile device.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("9. Third Party Payment Processing.")]), _vm._v(" For online payments and/or Automated Clearing House (ACH) payouts, we use the payment services of "), _c('a', {
    attrs: {
      "href": "https://stripe.com"
    }
  }, [_vm._v("Stripe")]), _vm._v(". We do not process, record or maintain your credit card or bank account information. For more information on how payments are handled, or to understand the data security and privacy afforded such information, please refer "), _c('a', {
    attrs: {
      "href": "https://stripe.com/us/terms%20and%20https://stripe.com/us/privacy"
    }
  }, [_vm._v("here")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("10. Changes to This Privacy Policy.")]), _vm._v(" This Privacy Policy may be updated from time to time for any reason. We will notify you of any changes to our Privacy Policy by posting the new Privacy Policy "), _c('a', {
    attrs: {
      "href": "http://www.mikmak.tv/privacy"
    }
  }, [_vm._v("here")]), _vm._v(" and we will change the \"Last Updated\" date above. You should consult this Privacy Policy regularly for any changes.")])])
}]}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('SubHeader', {
    attrs: {
      "page": _vm.page
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-content block-el"
  }, [_c('body', {
    staticClass: "c37"
  }, [_c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c20"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c20"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c20"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c3"
  }, [_vm._v("LAST UPDATED:")]), _c('span', {
    staticClass: "c0"
  }, [_vm._v(" January 8, 2018")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c0"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("This privacy and cookie policy (“")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v("Policy")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("”) describes how TIPO Entertainment, Inc., d/b/a MikMak (“")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v("Company,")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("” “")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v("MikMak,")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("” “")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v("we,")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("” and “")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v("our")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("”) collects, uses and shares personal data when using this website MikMak.tv (the “")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v("Site")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("”)")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" and our customized Software-as-a-Service platform, including the MikMak Attach video player units which we develop and host (\"Services\"), which we license to our clients and customers (“")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Customers")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("”). ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("Please read the following information carefully to understand our views and practices regarding your personal data and how we will treat it. ")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Use of the MikMak mobile shopping application (“Application”) is governed by our legacy Privacy Policy, which can be found ")]), _c('span', {
    staticClass: "c1 c19"
  }, [_c('a', {
    staticClass: "c27",
    attrs: {
      "href": "./privacy-legacy"
    }
  }, [_vm._v("HERE")])]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c0"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Particularly Important Information")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c3"
  }, [_vm._v("Who we are:")]), _c('sup'), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" For the purpose of applicable data protection legislation, the data controller of your personal data is TIPO Entertainment. Inc., d/b/a MikMak, of 105 Rivington, Floor 2, New York, NY 10002")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(", USA.")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c3"
  }, [_vm._v("Must Read Sections:")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" We draw your attention in particular to the sections entitled “International Data Transfer” and “Your Rights.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c3"
  }, [_vm._v("Changes to this Policy:")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" We will post any modifications or changes to the Policy on our Site/Services. We reserve the right to modify the Policy at any time, so we encourage you to review it frequently. The “Last Updated” legend above indicates when this Policy was last changed. If we make any material change(s) to the Policy, we will post a notice on our Site prior to such chan")]), _c('span', [_vm._v("ges(s) taking effect.")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c0"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0 start",
    attrs: {
      "start": "1"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("PURPOSES OF PROCESSING ")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("What is personal data?")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("We collect information about you in a range of forms, including personal data. As used in this Policy, “personal data” is as defined in the UK Data Protection Act 1998 and any successor legislation, this includes any information which, either alone or in combination with other information we hold about you, identifies you as an individual, including, for example, your name, postal address, email address and telephone number. ")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Why do we need your personal data?")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We will only process your personal data in accordance with applicable data protection and privacy laws. We need certain personal data in order to provide you with access to the Site/Services. ")]), _c('span', {
    staticClass: "c1 c10 c38"
  }, [_vm._v("By using the ")]), _c('span', {
    staticClass: "c1 c10"
  }, [_vm._v("Services")]), _c('sup'), _c('span', {
    staticClass: "c1 c10"
  }, [_vm._v(", you consent to such use of your information and personal data and agree to the terms of this Privacy Policy. ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("This consent provides us with the legal basis we require under applicable law to process your data. You maintain the right to withdraw such consent at any time. If you do not agree to our use of your personal data in line with this Policy, please do not use our Site/Services.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "2"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("COLLECTING YOUR PERSONAL DATA")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("We collect information about you in the following ways:")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c3"
  }, [_vm._v("Information You Give Us.")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" This includes:")])]), _vm._v(" "), _c('ul', {
    staticClass: "c4 lst-kix_list_2-0 start"
  }, [_c('li', {
    staticClass: "c8 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("the personal data you provide when you register to use [our Site/Application(s)/Services], including your‎ ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("name, email address, telephone number, job title, company name, and other personal information;")])]), _vm._v(" "), _c('li', {
    staticClass: "c8 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("the personal data that may be contained in any video, comment or other submission you upload or post to the Site/Services;")])]), _vm._v(" "), _c('li', {
    staticClass: "c8 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("the personal data you provide when you report a problem with our ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Site/Services")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" or when we provide you with customer support; ")])]), _vm._v(" "), _c('li', {
    staticClass: "c8 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("the personal data you provide when you correspond with us by phone, email or otherwise")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("; and")])]), _vm._v(" "), _c('li', {
    staticClass: "c8 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("the personal data you provide through our Services in response to specific questions and prompts, such as product ratings or sentiments, or tapping “add to cart” for a specific product or products.")])])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c3"
  }, [_vm._v("Information Automatically Collected.")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" We automatically log information about you and your computer or mobile device when you access our Site/Services. For example, when visiting our Site/Services, we log your browser or operating system, your manner of connecting to the Internet and the name of your Internet service provider or wireless carrier; your Internet Protocol (IP) address or Advertising Identifier; information about websites you used before or after using the Sites or Services; data relating to malfunctions or problems occurring when you use our Site/Services, other information specifically related to your use of Services, location information, pages you viewed, how long you spent on a page, access times and information about your use of and actions on our Site/Services. We collect this information about you using cookies. Please refer to the sections on cookies, Flash Technology and Pixel Tags below.")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c3"
  }, [_vm._v("Automated Decision Making and Profiling")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We do not use your personal data for the purposes of automated decision-making. However, we may do so in order to fulfill obligations imposed by law, in which case we will inform you of any such processing and provide you with an opportunity to object.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "3"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("COOKIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("What are cookies?")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We may collect information using “cookies.” Cookies are small data files stored on the hard drive of your computer or mobile device by a website. We may use both session cookies (which expire once you close your web browser) and persistent cookies (which stay on your computer or mobile device until you delete them) to provide you with a more personal and interactive experience on our Site/Services.")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We use two broad categories of cookies: (1) first party cookies, served directly by us to your computer or mobile device, which are used only by us to recognize your computer or mobile device when it revisits our Site/Services; and (2) third party cookies, which are served by service providers on our Site/Services, and can be used by such service providers to recognize your computer or mobile device when it visits other websites.")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Cookies we use")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Our Site/Services use the following types of cookies for the purposes set out below:")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "t.2d56aaffa2b2bd0cba76369b74df068fba8936ff"
    }
  }), _c('a', {
    attrs: {
      "id": "t.0"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "c36"
  }, [_c('tbody', [_c('tr', {
    staticClass: "c33"
  }, [_c('td', {
    staticClass: "c29",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('p', {
    staticClass: "c8 c28"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Type of cookie")])])]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('p', {
    staticClass: "c8 c28"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Purpose ")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "c35"
  }, [_c('td', {
    staticClass: "c29",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c32 c1 c31"
  }, [_vm._v("Functionality Cookies")])])]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("These cookies allow ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("our Site/Services ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to remember choices you make when you use our ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Site/Services, ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("such as ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("products you added to your shopping cart within a MikMak Attach video player")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(". The purpose of these cookies is to provide you with a more personal experience and facilitate transitions from our Site/Services to third-party websites.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "c41"
  }, [_c('td', {
    staticClass: "c29",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c32 c1 c31"
  }, [_vm._v("Analytics and Performance Cookies")])])]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("These cookies are used to collect information about traffic to our ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Site/Services")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" and how users use our ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Site/Services")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(". The information gathered does not identify any individual visitor. The information is aggregated and anonymous. [It includes the number of visitors to our ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Site/Services")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(", the websites that referred them to our Site/Services, the pages they visited on our Site/Services, what time of day they visited ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("our Site/Services, ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("whether they have visited ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("our Site/Services ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("before, and other similar information. We use this information to help operate our Site/Services")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("more efficiently, to gather broad demographic information and to monitor the level of activity on our Site/Services.")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("We use ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("Google Analytics")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" for this purpose. Google Analytics uses its own cookies. ")]), _c('span', {
    staticClass: "c25 c1"
  }, [_vm._v("It is only used to improve how our Site/Se")]), _c('span', {
    staticClass: "c1 c42"
  }, [_vm._v("rvices")]), _c('span', {
    staticClass: "c1 c25"
  }, [_vm._v(" works. You can find out more information about Google Analytics cookies here:")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "c1 c16 c30"
  }, [_c('a', {
    staticClass: "c27",
    attrs: {
      "href": "https://www.google.com/url?q=https://developers.google.com/analytics/resources/concepts/gaConceptsCookies&sa=D&ust=1513189985386000&usg=AFQjCNGqoQVJN14eXRNeF533p7Kc-ffJ3g"
    }
  }, [_vm._v("https://developers.google.com/analytics/resources/concepts/gaConceptsCookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("You can find out more about how Google protects your data here: ")]), _c('span', {
    staticClass: "c1 c30 c16"
  }, [_c('a', {
    staticClass: "c27",
    attrs: {
      "href": "https://www.google.com/url?q=http://www.google.com/analytics/learn/privacy.html&sa=D&ust=1513189985387000&usg=AFQjCNEsO9nt6i8aV5f2wg0qZ95mshBo1Q"
    }
  }, [_vm._v("www.google.com/analytics/learn/privacy.html")])]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("You can prevent the use of Google Analytics relating to your use of our Site/Services by ")]), _c('span', {
    staticClass: "c25 c1"
  }, [_vm._v("downloading")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" and installing the browser plugin available via this link: ")]), _c('span', {
    staticClass: "c1 c30 c16"
  }, [_c('a', {
    staticClass: "c27",
    attrs: {
      "href": "https://www.google.com/url?q=http://tools.google.com/dlpage/gaoptout?hl%3Den-GB&sa=D&ust=1513189985388000&usg=AFQjCNH9Pu8BrFY5_n46m9q_pd4P17ikRw"
    }
  }, [_vm._v("http://tools.google.com/dlpage/gaoptout?hl=en-GB")])]), _c('span', {
    staticClass: "c1 c39 c30"
  }, [_vm._v("] ")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "c2"
  }, [_c('td', {
    staticClass: "c29",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c1 c31 c32"
  }, [_vm._v("Targeted and advertising cookies")])])]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("These cookies track your browsing habits to enable us to show advertising which is more likely to be of interest to you. These cookies use information about your browsing history to group you with other users who have similar interests. Based on that information, and with our permission, third party advertisers can place cookies to enable them to show advertisements which we/they think will be relevant to your interests while you are on third party websites.")])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c8"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("You can disable cookies which remember your browsing habits and target advertising at you by visiting ")]), _c('span', {
    staticClass: "c1 c16"
  }, [_c('a', {
    staticClass: "c27",
    attrs: {
      "href": "https://www.google.com/url?q=http://www.youronlinechoices.com/uk/your-ad-choices&sa=D&ust=1513189985390000&usg=AFQjCNETpcqMFyWWO-Q5qOKLE6z0NkzVtA"
    }
  }, [_vm._v("http://www.youronlinechoices.com/uk/your-ad-choices")])]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(". If you choose to remove targeted or advertising cookies, you will still see advertisements but they may not be relevant to you. Even if you do choose to remove cookies by the companies listed at the above link, not all companies that serve online behavioral advertising are included in this list, and so you may still receive some cookies and tailored advertisements from companies that are not listed.")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "c8 c17 c34"
  }, [_c('span', {
    staticClass: "c5 c1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Disabling cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("You can typically remove or reject cookies via your browser settings. In order to do this, follow the instructions provided by your browser (usually located within the “settings,” “help” “tools” or “edit” facility).  Many browsers are set to accept cookies until you change your settings.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Further information about cookies, including how to see what cookies have been set on your computer or mobile device and how to manage and delete them, visit ")]), _c('span', {
    staticClass: "c1 c16"
  }, [_c('a', {
    staticClass: "c27",
    attrs: {
      "href": "https://www.google.com/url?q=http://www.allaboutcookies.org&sa=D&ust=1513189985391000&usg=AFQjCNFvKbI6voqniXtDqa3rQO5WQWN2WQ"
    }
  }, [_vm._v("www.allaboutcookies.org")])]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" and ")]), _c('span', {
    staticClass: "c1 c16"
  }, [_c('a', {
    staticClass: "c27",
    attrs: {
      "href": "https://www.google.com/url?q=http://www.youronlinechoices.com.uk&sa=D&ust=1513189985391000&usg=AFQjCNHA83IKrrnmmTEz0b7sXcnwWbLLNA"
    }
  }, [_vm._v("www.youronlinechoices.com.uk")])]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "4"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("PIXEL TAGS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We may also use pixel tags (which are also known as web beacons and clear GIFs) on our Site/Services to track the actions of users on our Site/Services. Unlike cookies, which are stored on the hard drive of your computer or mobile device by a website, pixel tags are embedded invisibly on webpages. Pixel tags measure the success of our marketing campaigns and compile statistics about usage of the Site/Services, so that we can manage our content more effectively. ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("The information we collect using pixel tags is also linked to our users’ personal data")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(", and may be used to enable third party advertisers to show advertisements which we/they think will be relevant to your interests while you are on third party websites.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "5"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("DO NOT TRACK SIGNALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Some Internet browsers may be configured to send \"Do Not Track\" signals to the online services that you visit. We currently do not respond to do not track signals. To find out more about \"Do Not Track,\" please visit ")]), _c('span', {
    staticClass: "c1 c16"
  }, [_c('a', {
    staticClass: "c27",
    attrs: {
      "href": "https://www.google.com/url?q=http://www.allaboutdnt.com&sa=D&ust=1513189985392000&usg=AFQjCNHVA7zEPWaXx4H6muwxw7Jvdb9uow"
    }
  }, [_vm._v("http://www.allaboutdnt.com")])]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "6"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("USING YOUR PERSONAL DATA")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We may use your personal data as follows:")]), _c('sup')]), _vm._v(" "), _c('ul', {
    staticClass: "c4 lst-kix_list_2-0"
  }, [_c('li', {
    staticClass: "c6"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to operate, maintain, and improve our Site/Services;")])]), _vm._v(" "), _c('li', {
    staticClass: "c13 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to better understand your use of the Site and Services;")])]), _vm._v(" "), _c('li', {
    staticClass: "c13 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to make navigation and use of on our Site easier;")])]), _vm._v(" "), _c('li', {
    staticClass: "c6"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to manage your account, including to communicate with you regarding your account, if you have an account on our Site/Services;")])]), _vm._v(" "), _c('li', {
    staticClass: "c6"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to respond to your comments and questions and to provide customer service;")])]), _vm._v(" "), _c('li', {
    staticClass: "c13 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to help offer you other products, features, or services that may be of interest;")])]), _vm._v(" "), _c('li', {
    staticClass: "c6"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to send information including technical notices, updates, security alerts, and support and administrative messages;")])]), _vm._v(" "), _c('li', {
    staticClass: "c8 c21"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("with your consent, to send you marketing e-mails about upcoming promotions, and other news, including information about products and services offered by us and our affiliates.  You may opt-out of receiving such information at any time: such marketing emails tell you how to “opt-out.” Please note, even if you opt out of receiving marketing emails, we may still send you non-marketing emails. Non-marketing emails include emails about your account with us (if you have one) and our business dealings with you")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(";")])]), _vm._v(" "), _c('li', {
    staticClass: "c13 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to respond to a job application or inquiry and consider you for employment purposes;")])]), _vm._v(" "), _c('li', {
    staticClass: "c13 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to link or combine user information with other personal data;")])]), _vm._v(" "), _c('li', {
    staticClass: "c13 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to facilitate a shopping experience on a third-party website (e.g., by adding a product to your shopping cart via an integration with one of our customers or partners);")])]), _vm._v(" "), _c('li', {
    staticClass: "c13 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to facilitate our Customers’ efforts to market to you;")])]), _vm._v(" "), _c('li', {
    staticClass: "c8 c21"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("as we believe necessary or appropriate (a) to comply with applicable laws; (b) to comply with lawful requests and legal process, including to respond to requests from public and government authorities; (c) to enforce our Policy; and (d) to protect our rights, privacy, safety or property, and/or that of you or others; and")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("as described in the “Sharing of your Personal Data” section below.")])])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "7"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("SHARING YOUR PERSONAL DATA")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("We may share your personal data as follows:")])]), _vm._v(" "), _c('ul', {
    staticClass: "c4 lst-kix_list_2-0"
  }, [_c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Third Parties Designated by You.")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" We may share your personal data with third parties where you have provided your consent to do so.")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c3"
  }, [_vm._v("Our Customers and/or Other Third Parties.")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" When you provide us with personal data through a MikMak Attach video player licensed to one of our Customers, we may share your personal data with that Customer or another third party. Our Customers have their own privacy policies and we do not accept any responsibility or liability for their websites, features or policies.")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Our")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" ")]), _c('span', {
    staticClass: "c0"
  }, [_vm._v("Third Party Service Providers")]), _c('span', {
    staticClass: "c1 c5"
  }, [_vm._v(". We may share your personal data with our third party service providers who provide services such as data analysis,")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("information technology and related infrastructure provision, customer service, email delivery, auditing and other similar services. These third parties are only permitted to use your personal data to the extent necessary to enable them to provide their services to us. They are required to follow our express instructions and to comply with appropriate security measures to protect your personal data.")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Affiliates")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(". We may share some or all of your personal data with our affiliates, in which case we will require our affiliates to comply with this Policy. In particular, you may let us share personal data with our affiliates where you wish to receive marketing communications from them.")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Corporate Restructuring.")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" We may share personal data when we do a business deal, or negotiate a business deal, involving the sale or transfer of all or a part of our business or assets. These deals can include any merger, financing, acquisition, or bankruptcy transaction or proceeding.")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Other Disclosures.")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" We may share personal data as we believe necessary or appropriate: (a) to comply with applicable laws; (b) to comply with lawful requests and legal process, including to respond to requests from public and government authorities to meet national security or law enforcement requirements; (c) to enforce our Policy; and (d) to protect our rights, privacy, safety or property, and/or that of you or others.")])])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "8"
    }
  }, [_c('li', {
    staticClass: "c12 c15 c28"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("ANONYMOUS DATA")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12 c28"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("When we use the term “anonymous data,” we are referring to data and information that does not permit you to be identified or identifiable, either alone or when combined with any other information available to a third party.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We may create anonymous data from the personal data we receive about you and other individuals whose personal data we collect. Anonymous data might include analytics information and information collected by us using cookies.  We make personal data into anonymous data by excluding information (such as your name) that makes the data personally identifiable to you.  We use this anonymous data to analyses usage patterns in order to make improvements to our Site/Services.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "9"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("THIRD PARTY SITES ")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Our Site/Services")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" may contain links to third party websites and features, such as online shopping sites. ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("This Policy does not cover the privacy practices of such third parties.")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v(" ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("These third parties have their own privacy policies and we do not accept any responsibility or liability for their websites, features or policies.  Please read their privacy policies before you submit any data to them.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "10"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("INTERNATIONAL DATA TRANSFER ")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Your information, including personal data that we collect from you, may be transferred to, stored at and processed by us ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("and our affiliates and other third parties outside the country in which you reside, including, but not limited to the United States, where data protection and privacy regulations may not offer the same level of protection as in other parts of the world. ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("By using our Site/Services, you agree to this transfer, storing or processing. ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Policy.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "11"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("SECURITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("We seek to use reasonable organizational, technical and administrative measures to protect personal data within our organization. Unfortunately, no transmission or storage system can be guaranteed to be completely secure, and transmission of information via the internet is not completely secure. If you have reason to believe that your interaction with us is no longer secure (for example, if you feel that the security of any account you might have with us has been compromised), please immediately notify us of the problem by contacting us using the details in Section 17 below.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "12"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("RETENTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We will only retain your personal data as long reasonably required for you to use the ")]), _c('span', {
    staticClass: "c1 c31"
  }, [_vm._v("Site and/or ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("to provide you with the Services, unless a longer retention period is required or permitted by law (for example for regulatory purposes). ")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "13"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("OUR POLICY ON CHILDREN")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Our Site/Services is/are not directed to children under 16. ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("If a parent or guardian becomes aware that his or her child has provided us with information without their consent, he or she should contact us using the details in Section 17 below. We will delete such information from our files as soon as reasonably practicable.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "14"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("SENSITIVE PERSONAL DATA")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Subject to the following paragraph, we ask that you not send us, and you not disclose, any sensitive personal data (e.g., social security numbers, information related to racial or ethnic origin, political opinions, religion or other beliefs, health, biometrics or genetic characteristics, criminal background or trade union membership) on or through the Site/Services.")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("If you send or disclose any sensitive personal data to us, you consent to our processing and use of such sensitive personal data in accordance with this Policy. If you do not consent to our processing and use of such sensitive personal data, you must not submit such user generated content to our Site/Services.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "15"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Your Rights")])])]), _vm._v(" "), _c('ul', {
    staticClass: "c4 lst-kix_list_10-0 start"
  }, [_c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Opt-out. ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" You may contact us anytime to opt-out of: (i) direct marketing communications; (ii) automated decision-making and/or profiling; (iii) our collection of sensitive personal data; ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("(iv) any new processing of your personal data that we may carry out beyond the original purpose")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("; or (v) the transfer of your personal data outside the EEA. Please note that your use of some of the Site/Services may be ineffective upon opt-out. ")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Access. ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("You may access the information we hold about you at any time")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("by contacting us directly. ")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Amend. ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("You can also contact us to update or correct any inaccuracies in your personal data.")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Move. ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("Your personal data is portable – i.e. you to have the flexibility to move your data to other service providers as you wish. ")])]), _vm._v(" "), _c('li', {
    staticClass: "c11"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("Erase and forget. ")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("In certain situations, for example when the information we hold about you is no longer relevant or is incorrect, you can request that we erase your data. ")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("If you wish to exercise any of these rights, please contact us using the details in Section 17 below. In your request, please make clear: (i) ")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v("what")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" personal data is concerned; and (ii) ")]), _c('span', {
    staticClass: "c3"
  }, [_vm._v("which of the above rights")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(" you would like to enforce.  For your protection, we may only implement requests with respect to the personal data associated with the particular email address that you use to send us your request, and we may need to verify your identity before implementing your request. We will try to comply with your request as soon as reasonably practicable and in any event, within one month of your request. Please note that we may need to retain certain information for recordkeeping purposes and/or to complete any transactions that you began prior to requesting such change or deletion.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "16"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("COMPLAINTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We are committed to resolve any complaints about our collection or use of your personal data. If you would like to make a complaint regarding this Policy or our practices in relation to your personal data, please contact us at ")]), _c('span', {
    staticClass: "c1"
  }, [_vm._v("privacy@mikmak.tv")]), _c('span', {
    staticClass: "c5 c1"
  }, [_vm._v(". We will reply to your complaint as soon as we can and in any event, within 45 days. We hope to resolve any complaint brought to our attention, however if you feel that your complaint has not been adequately resolved, you reserve the right to contact your local data protection supervisory authority.")])]), _vm._v(" "), _c('ol', {
    staticClass: "c4 lst-kix_list_12-0",
    attrs: {
      "start": "17"
    }
  }, [_c('li', {
    staticClass: "c12 c15"
  }, [_c('span', {
    staticClass: "c0"
  }, [_vm._v("CONTACT INFORMATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c5 c1"
  }, [_vm._v("We welcome your comments or questions about this Policy. You may contact us in writing at privacy@mikmak.tv, or at:")])]), _vm._v(" "), _c('p', {
    staticClass: "c12"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("MikMak"), _c('br'), _vm._v("105 Rivington, Floor 2"), _c('br'), _vm._v("New York, NY 10002")])])])])
}]}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-text"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "intro-text_body"
  }, _vm._l((_vm.introText), function(block) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(block)
      }
    })
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-text_lockup "
  }, [_c('label', {
    staticClass: "block-heading-font-style"
  }, [_vm._v("our platform")])])
}]}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeaderBar'), _vm._v(" "), _c('About'), _vm._v(" "), _c('Press'), _vm._v(" "), _c('FooterBar')], 1)
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-block-inner step-four"
  }, [_c('span', {
    staticClass: "product-block-span step-four-top-margin"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-social-logos"
  }, [_vm._l((_vm.socialLogos), function(logo, index) {
    return _c('span', {
      class: ("social-logo " + logo + "-social-logo " + (_vm.logoClass(index)))
    }, [_c('img', {
      attrs: {
        "src": _vm.getSocialImageUrl(logo)
      }
    })])
  }), _vm._v(" "), _c('DemoButton', {
    attrs: {
      "buttonMessage": 'Software, Owning Audience'
    }
  })], 2)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "product-block-span step-four-images"
  }, [_c('img', {
    staticClass: "optimize-image",
    attrs: {
      "src": __webpack_require__(49)
    }
  })])
}]}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mikmak-site"
    }
  }, [_c('Header'), _vm._v(" "), _c('Holiday2019'), _vm._v(" "), _c('CookieBanner')], 1)
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form footer-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "contact-footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-padding"
  }, [_c('div', {
    staticClass: "contact-form-inputs"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.WhitepaperContent.heading))]), _vm._v(" "), (_vm.WhitepaperContent.img) ? _c('img', {
    staticClass: "whitepaper-image",
    attrs: {
      "src": _vm.getImgUrl(_vm.WhitepaperContent.img)
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formIsSubmitted),
      expression: "!formIsSubmitted"
    }],
    staticClass: "sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.WhitepaperContent.subheading)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formIsSubmitted),
      expression: "!formIsSubmitted"
    }]
  }, [_c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress),
      expression: "emailAddress"
    }],
    staticClass: "input-element",
    attrs: {
      "id": "contact-form-email-address",
      "type": "email",
      "name": "email",
      "placeholder": "Email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "company",
      "placeholder": "Company name",
      "required": ""
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.website),
      expression: "website"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "website",
      "placeholder": "Company website",
      "required": ""
    },
    domProps: {
      "value": (_vm.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.website = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formError),
      expression: "formError"
    }],
    staticClass: "contact-form-error",
    domProps: {
      "innerHTML": _vm._s(_vm.formError)
    }
  }), _vm._v(" "), (!_vm.submitInProgress) ? _c('button', {
    staticClass: "form-button",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.userClickedSubmit
    }
  }, [_vm._v(_vm._s(_vm.WhitepaperContent.buttonText))]) : _vm._e(), _vm._v(" "), (_vm.submitInProgress) ? _c('button', {
    staticClass: "form-button form-button-progress",
    attrs: {
      "type": "button",
      "name": "button"
    }
  }, [_vm._v("submitting your info "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formIsSubmitted),
      expression: "formIsSubmitted"
    }],
    staticClass: "contact-form-success"
  }, [_c('div', {
    staticClass: "contact-form-success-header"
  }, [_vm._v("\n        Thanks!\n      ")]), _vm._v(" "), _c('span', [_vm._v("\n        Click "), _c('a', {
    attrs: {
      "href": _vm.WhitepaperContent.link,
      "download": "",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(" to view and download the document.\n      ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n        Click "), _c('a', {
    attrs: {
      "href": _vm.WhitepaperContent.videoLink,
      "download": "",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(" to view the webinar video.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(44),
      "alt": "MikMak"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-links"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('#our-software')
    }
  }, [_vm._v("Software")]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getLink('careers')
    }
  }, [_vm._v("Careers")]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getLink('about')
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getLink('privacy')
    }
  }, [_vm._v("Privacy policy")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "footer-copyright"
  }, [_vm._v("© 2015-" + _vm._s(_vm.currentYear) + " TIPO Entertainment, Inc.")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "footer-social-icons"
  }, [_c('a', {
    attrs: {
      "href": "https://instagram.com/MikMakTV/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/MikMakdotTV",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/mikmaktv",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCGT0qpoynvsBolIES_xAr0w",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inc-500"
  }, [_c('a', {
    attrs: {
      "href": "https://www.inc.com/profile/mikmak",
      "target": "new"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "alt": "Inc 500"
    }
  })])])
}]}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('SubHeader', {
    attrs: {
      "page": _vm.page
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "security-content"
  }, [_vm._v("\n    At MikMak, we take every possible measure to secure our applications and data. Read below to learn more about how we approach Security within the MikMak Platform.\n  ")]), _vm._v(" "), _vm._l((_vm.securityContent), function(securityItem) {
    return _c('div', {
      staticClass: "security-block"
    }, [_c('h3', [_vm._v(_vm._s(securityItem.title))]), _vm._v(" "), _vm._l((securityItem.items), function(listItem) {
      return _c('div', {
        staticClass: "security-list-item"
      }, [_c('span', {
        staticClass: "security-list-item-span security-list-item-title"
      }, [_vm._v(_vm._s(listItem.title))]), _vm._v(" "), _c('span', {
        staticClass: "security-list-item-span security-list-item-text"
      }, _vm._l((listItem.text), function(textItem) {
        return _c('label', {
          domProps: {
            "innerHTML": _vm._s(textItem)
          }
        })
      }), 0)])
    })], 2)
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "security-content"
  }, [_vm._v("\n\n    Contact "), _c('b', [_vm._v("security@mikmak.tv")]), _vm._v(" with any inquiries not addressed in the content above.\n\n  ")])
}]}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-block-inner step-four"
  }, [_c('span', {
    staticClass: "product-block-span step-four-top-margin"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }), _vm._v(" "), _c('DemoButton', {
    attrs: {
      "buttonMessage": 'Software, Amazon value props'
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "product-block-span step-four-images"
  }, [_c('img', {
    staticClass: "optimize-image",
    attrs: {
      "src": __webpack_require__(52)
    }
  })])
}]}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-content-wrapper"
  }, [_c('div', {
    staticClass: "product-content-title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(120),
      "alt": "MikMak"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), (_vm.product.patentPending) ? _c('span', {
    staticClass: "patent-pending"
  }, [_vm._v("patent pending")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-content-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  }), _vm._v(" "), (_vm.product.bullets.length > 0) ? _c('div', {
    staticClass: "product-content-bullets"
  }, _vm._l((_vm.product.bullets), function(bullet) {
    return _c('span', {
      domProps: {
        "innerHTML": _vm._s(bullet)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "product-cta"
  }, [_c('a', {
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": function($event) {
        return _vm.logProductClick(_vm.product)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.cta))])])])
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "svg-blob-one",
    attrs: {
      "width": "600",
      "height": "600",
      "viewBox": "0 0 600 600",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(300,300)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M123.8,-153.4C143,-156.5,129,-96.9,142.2,-48.2C155.3,0.6,195.6,38.6,196.1,72C196.6,105.3,157.4,134,118.1,134.5C78.8,135.1,39.4,107.5,4.8,100.9C-29.8,94.3,-59.6,108.6,-91.1,105.6C-122.6,102.5,-156,82,-168.2,52.7C-180.4,23.4,-171.5,-14.7,-144.4,-31C-117.2,-47.4,-71.8,-41.9,-44.7,-36.2C-17.6,-30.6,-8.8,-24.8,21.7,-54.7C52.3,-84.7,104.6,-150.3,123.8,-153.4Z",
      "fill": "#F1F1F1"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('div', {
    staticClass: "partners-heading block-heading-font-style"
  }, [_vm._v("THE ENTIRE FAMILY OF ATTACH")]), _vm._v(" "), _c('div', {
    staticClass: "partners-subheading block-subheading-font-style"
  }, [_vm._v("MikMak has an Attach experience for every stage in the shopper's journey.")]), _vm._v(" "), _c('div', {
    staticClass: "all-attach-items"
  }, _vm._l((_vm.attachFamilyList), function(attachProduct) {
    return _c('span', {
      staticClass: "attach-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgUrl(attachProduct.slug)
      }
    }), _vm._v(" "), _c('span', {
      class: ("attach-item-title attach-product-badge badge-for-" + (attachProduct.slug))
    }, [_vm._v(_vm._s(attachProduct.name))])])
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "attach-item-request-demo-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": function($event) {
        return _vm.clickedRequestDemoButton()
      }
    }
  }, [_vm._v("Request a demo of all Attach")])])
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeaderBar'), _vm._v(" "), _c('OpenPositions'), _vm._v(" "), _c('FooterBar')], 1)
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach-product-wrapper",
    style: (("background-color: " + _vm.backgroundColor)),
    attrs: {
      "id": _vm.divId
    }
  }, [_c('div', {
    staticClass: "block-heading-font-style"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "block-subheading-font-style"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "product-item"
    }, [_c('SingleProductComponent', {
      attrs: {
        "product": product
      }
    })], 1)
  }), _vm._v(" "), _c('a', {
    staticClass: "mobile-cta-button",
    class: [_vm.shouldShowMainCta ? 'mobile-cta-button-visible' : 'mobile-cta-button-hidden'],
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.logCtaClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.mobileCta) + "\n  ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mikmak-site"
    }
  }, [_c('Header'), _vm._v(" "), _c('Alcohol'), _vm._v(" "), _c('CookieBanner')], 1)
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item-image",
    attrs: {
      "id": _vm.divId
    }
  }, [_c('div', {
    staticClass: "product-item-image-wrapper"
  }, [(_vm.product.isDemoVideo) ? _c('div', {
    staticClass: "cover-demo-bar"
  }) : _vm._e(), _vm._v(" "), (_vm.product.device.color == 'black') ? _c('img', {
    staticClass: "product-item-image-overlay",
    attrs: {
      "src": __webpack_require__(19)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.device.color == 'white') ? _c('img', {
    staticClass: "product-item-image-overlay",
    attrs: {
      "src": __webpack_require__(19)
    }
  }) : _vm._e(), _vm._v(" "), _c('video', {
    staticClass: "attach-video-holder",
    attrs: {
      "id": _vm.videoId,
      "src": _vm.currentImage,
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  }), _vm._v(" "), (_vm.currentImageOptions > 1) ? _c('div', {
    staticClass: "product-item-image-gallery"
  }, _vm._l((_vm.product.images), function(url, imageKey) {
    return _c('span', {
      staticClass: "product-item-gallery-item",
      class: [_vm.currentImageKey == imageKey ? 'active-class' : ''],
      on: {
        "click": function($event) {
          return _vm.setGalleryImage(imageKey)
        }
      }
    }, [_vm._v(_vm._s(imageKey))])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "contact-footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-padding"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "attach-item-request-demo-button",
    attrs: {
      "href": "#contact-footer-form"
    },
    on: {
      "click": function($event) {
        return _vm.clickedRequestDemoButton('alcohol-whitepaper')
      }
    }
  }, [_vm._v("Request a demo")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "product-demos"
  }, [_c('span', {
    staticClass: "product-demo"
  }, [_c('img', {
    staticClass: "product-item-image-overlay",
    attrs: {
      "src": __webpack_require__(19)
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "product-demo-video",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/avXmMnrRgmRnVFTceZ8K_patron_screencap.mp4",
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  })])])]), _vm._v(" "), _c('Footer', {
    attrs: {
      "id": "contact-footer-form",
      "hideFooterPadding": true,
      "customHeaderText": 'Contact MikMak for a Demo'
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form-inputs"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("MikMak launches Attach for alcohol eCommerce")]), _vm._v(" "), _c('img', {
    staticClass: "whitepaper-image",
    attrs: {
      "src": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "sub-heading"
  }, [_vm._v("By 2023, the alcohol eCommerce industry is suspected to be a $6 ­- $9B market in the US. MikMak Attach for alcohol helps beer, wine and spirits brands with: ")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-heading"
  }, [_c('b', [_vm._v(" Connecting your product inventory to digital media"), _c('br')]), _vm._v(" With MikMak, ensure your digital media only showcases retailers and marketplaces that have your SKU in stock ")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-heading"
  }, [_c('b', [_vm._v(" Optimizing your content for eCommerce"), _c('br')]), _vm._v(" Control your Product Detail Page Experiences with MikMak, ensure no competitors surface, increase CTR and time spent ")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-heading"
  }, [_c('b', [_vm._v(" Building & owning your shopper audiences"), _c('br')]), _vm._v(" With MikMak, measure from impression through to sale, access retailer specific, audience data in your CMP/Ads Manager for look alike prospecting and retargeting, implement DR targeting with niche audiences to drive bottom line results ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-amazon.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-cocktail-courier.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-drizly.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-gopuff.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-instacart.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-kroger.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-minibar.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-target.png",
      "alt": "target"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-reserve-bar.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-walmart.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-walmart-grocery.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/cartLogo-winecom.png"
    }
  })])
}]}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item-details",
    class: [_vm.product.align == 'left' ? 'align-left' : 'align-right']
  }, [_c('div', {
    staticClass: "product-item-details-header",
    domProps: {
      "innerHTML": _vm._s(_vm.product.name)
    }
  }), _vm._v(" "), (_vm.product.patentPending) ? _c('span', {
    staticClass: "patent-pending-badge"
  }, [_vm._v("PATENT PENDING")]) : _vm._e(), _vm._v(" "), (_vm.product.description) ? _c('div', {
    staticClass: "product-item-details-body"
  }, [(_vm.product.isBeta) ? _c('span', {
    staticClass: "beta-badge"
  }, [_vm._v("BETA")]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.product.description) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.showFeaturesMobile) ? _c('div', {
    staticClass: "attach-item-feature-toggle-mobile",
    on: {
      "click": _vm.toggleFeatures
    }
  }, [(!_vm.showFeaturesMobile) ? _c('span', [_vm._v("Learn more "), _c('i', {
    staticClass: "fa fa-plus-square"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "attach-item-feature-wrapper",
    class: [_vm.showFeaturesMobile ? 'mobile-show' : 'mobile-hide'],
    on: {
      "click": _vm.toggleFeatures
    }
  }, _vm._l((_vm.product.features), function(feature) {
    return _c('div', {
      staticClass: "attach-item-feature",
      domProps: {
        "innerHTML": _vm._s(feature)
      }
    })
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "attach-item-request-demo-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": function($event) {
        return _vm.clickProductButton(_vm.product)
      }
    }
  }, [_vm._v("Request a demo")]), _vm._v(" "), (_vm.product.learnMore) ? _c('div', {
    staticClass: "learn-more-link",
    class: [_vm.product.align == 'left' ? 'learn-more-left' : 'learn-more-right']
  }, [_vm._v("\n    " + _vm._s(_vm.product.learnMore.text) + "\n    "), _c('a', {
    attrs: {
      "href": _vm.product.learnMore.href
    }
  }, [_vm._v("Learn more "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bar-contact-form"
  }, [_c('div', {
    staticClass: "contact-heading block-heading-font-style"
  }, [_vm._v(_vm._s(_vm.contactContent.heading))]), _vm._v(" "), _c('div', {
    staticClass: "contact-subheading block-subheading-font-style"
  }, [_vm._v(_vm._s(_vm.contactContent.subheading))]), _vm._v(" "), _c('form', {
    staticClass: "mm-contact-form",
    attrs: {
      "id": "mm-contact-form",
      "method": "post"
    }
  }, [_vm._l((_vm.contactContent.formFields), function(input) {
    return (input.required) ? _c('input', {
      class: input.className,
      attrs: {
        "type": input.type,
        "name": input.name,
        "placeholder": ((input.placeholder) + " (required)"),
        "required": ""
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.contactContent.formFields), function(input) {
    return (!input.required) ? _c('input', {
      class: input.className,
      attrs: {
        "type": input.type,
        "name": input.name,
        "placeholder": input.placeholder
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('input', {
    staticClass: "footer-bar-contact-form-submit",
    attrs: {
      "type": "submit",
      "name": "",
      "value": "Submit"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "mm-contact-form-success",
    attrs: {
      "id": "mm-contact-form-success"
    }
  }, [_vm._v(_vm._s(_vm.contactContent.successMessage))])])
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('SubHeader', {
    attrs: {
      "page": _vm.page
    }
  }), _vm._v(" "), _c('p', [_vm._v("MikMak’s mission is to build the next generation eCommerce platform for brands that are sold everywhere. Today, MikMak allows brands to make all of their digital and social media shoppable. Whether you’re a brand that sells via major eRetailers like Amazon, Target and Walmart or a brand that cares about your owned eCommerce website, we have solutions for you. With MikMak, brands capture valuable retailer data; improved media channel, creative and influencer performance; and build qualified shopper audiences.")]), _vm._v(" "), _c('p', [_vm._v("MikMak’s Founder & CEO is Rachel Tipograph, the former Global Director of Digital & Social Media at Gap. Rachel has been recognized as a leading innovator across the globe, including Forbes’ \"30 under 30 Who Are Changing The World\", Marie Claire’s \"50 Most Influential Women in America,\" and Fast Company’s \"Most Creative People in Business.\"")])], 1)
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mikmak-site"
    }
  }, [_c('HeaderBar'), _vm._v(" "), _c('HeaderComponent'), _vm._v(" "), (_vm.focusedVertical == 'customer-acquisition') ? _c('AudiencesProductComponent') : _vm._e(), _vm._v(" "), _c('Press', {
    attrs: {
      "id": "press"
    }
  }), _vm._v(" "), _c('FooterBar')], 1)
},staticRenderFns: []}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('SubHeader', {
    attrs: {
      "page": _vm.pageName
    }
  }), _vm._v(" "), (!_vm.allLogosLoaded) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _vm._e(), _vm._v(" "), (_vm.allLogosLoaded) ? _c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "category-filter"
  }, _vm._l((_vm.categoryOptions), function(option, index) {
    return _c('span', {
      key: index,
      class: option === _vm.selectedCategory ? 'selected-class' : '',
      on: {
        "click": function($event) {
          _vm.selectedCategory = option
        }
      }
    }, [_vm._v("\n        " + _vm._s(option) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.cartsToShow && _vm.cartsToShow.length > 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allLogosLoaded),
      expression: "allLogosLoaded"
    }],
    staticClass: "retailer-cart-logos"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.cartsToShow), function(cart) {
    return _c('div', {
      key: cart.cartName,
      staticClass: "cart-info"
    }, [_c('img', {
      attrs: {
        "src": cart.cartLogo,
        "onerror": "this.style.display='none'",
        "alt": ((cart.cartName) + " Logo")
      },
      on: {
        "load": function($event) {
          return _vm.incrementLoadedCount()
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "retailer-carts-footer block-heading-font-style",
    style: (_vm.noMatchesFound ? 'display: none' : '')
  }, [_vm._v("Leverage these retailers plus hundreds more!")])], 1) : _vm._e(), _vm._v(" "), (_vm.noMatchesFound && _vm.allLogosLoaded) ? _c('span', {
    staticClass: "retailer-cart-logos",
    staticStyle: {
      "color": "red",
      "padding": "20px 0 40px 0",
      "font-size": "24px"
    }
  }, [_vm._v(" No matches were found. Please refine your search. ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "svg-blob-one",
    attrs: {
      "width": "600",
      "height": "600",
      "viewBox": "0 0 600 600",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(300,300)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M50.6,-82.6C76.4,-62.2,115.5,-66.4,129.4,-53.9C143.3,-41.3,132.1,-12,142.8,31.5C153.6,74.9,186.4,132.4,175.1,159.7C163.9,187.1,108.6,184.2,64.7,177.5C20.8,170.8,-11.6,160.2,-32.9,140.8C-54.2,121.4,-64.5,93.1,-104.2,74.9C-143.9,56.7,-213,48.7,-228.6,25C-244.2,1.4,-206.2,-37.7,-179.4,-75.9C-152.6,-114,-136.8,-151.2,-108.8,-170.6C-80.7,-190,-40.4,-191.5,-14,-169.7C12.4,-148,24.9,-103,50.6,-82.6Z",
      "fill": "#fff"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bar"
  }, [_c('div', {
    staticClass: "footer-bar-nav"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(45),
      "alt": "MikMak"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-bar-nav-links"
  }, [_c('a', {
    attrs: {
      "href": "http://mikmak.tv#attach"
    }
  }, [_vm._v("Platform")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://mikmak.tv#studios"
    }
  }, [_vm._v("Studios")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://mikmak.tv#press"
    }
  }, [_vm._v("Press")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/about'
    }
  }, [_vm._v("about")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/careers'
    }
  }, [_vm._v("careers")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/privacy'
    }
  }, [_vm._v("privacy policy")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "footer-copyright"
  }, [_vm._v("© 2015-2018 TIPO Entertainment, Inc.")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "footer-social-icons"
  }, [_c('a', {
    attrs: {
      "href": "https://instagram.com/MikMakTV/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/MikMakdotTV",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/mikmaktv",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCGT0qpoynvsBolIES_xAr0w",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach-product-feature",
    class: [_vm.demo.orientation == 'right' ? 'shift-right' : 'shift-left']
  }, [_c('img', {
    staticClass: "product-item-image-overlay",
    attrs: {
      "src": __webpack_require__(19)
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "attach-video-holder",
    attrs: {
      "src": _vm.demo.videoSrc,
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-product-wrapper",
    attrs: {
      "id": "audiences"
    }
  }, [_c('div', {
    staticClass: "block-heading-font-style"
  }, [_vm._v("MikMak Video Shopper Audiences")]), _vm._v(" "), _c('div', {
    staticClass: "block-subheading-font-style"
  }, [_vm._v("Generate and own qualified audiences from social video. Take immediate action on these audiences by leveraging our Facebook integration or directly adding them to your CRM.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "audience-product-block-desktop-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.logCtaClick
    }
  }, [_vm._v("\n    Act on your Audiences\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "mobile-cta-button",
    class: [_vm.shouldShowMainCta ? 'mobile-cta-button-visible' : 'mobile-cta-button-hidden'],
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.logCtaClick
    }
  }, [_vm._v("\n    Act on your Audiences\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-product-block"
  }, [_c('span', {
    staticClass: "audience-product-block-item"
  }, [_c('img', {
    staticClass: "audience-product-image",
    attrs: {
      "src": __webpack_require__(380)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-header"
  }, [_vm._v("\n        Social Audiences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-subheader"
  }, [_vm._v("\n        Build qualified audiences through engagement\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-body"
  }, [_vm._v("\n        MikMak Attach qualifies your leads from social video views and turns them into new custom audiences for you to take immediate action on.\n      ")])]), _vm._v(" "), _c('span', {
    staticClass: "audience-product-block-item"
  }, [_c('img', {
    staticClass: "audience-product-image",
    attrs: {
      "src": __webpack_require__(379)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-header"
  }, [_vm._v("\n        Direct Audiences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-subheader"
  }, [_vm._v("\n        Easily create & own direct audiences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-body"
  }, [_vm._v("\n        MikMak Attach converts social video views into email addresses and cell phone numbers that your brand can add to its CRM database.\n      ")])])])
}]}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCookieBanner),
      expression: "showCookieBanner"
    }],
    staticClass: "cookie-banner"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "cookie-banner-dismiss",
    on: {
      "click": _vm.hideCookieBanner
    }
  }, [_c('span', {
    staticClass: "dismiss-text"
  }, [_vm._v("dismiss")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cookie-banner-message"
  }, [_vm._v("MikMak uses cookies to enhance your experience on our site. By browsing our site, you agree to our "), _c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("privacy policy")]), _vm._v(".")])
}]}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "our-software",
    attrs: {
      "id": "our-software"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "product-heading"
  }, [_vm._v("our software")]), _vm._v(" "), _c('Blob'), _vm._v(" "), _c('div', {
    staticClass: "product-block"
  }, [_vm._m(0), _vm._v(" "), _c('StepUseAttachAnywhere'), _vm._v(" "), _c('StepVerticalValueProps'), _vm._v(" "), _c('StepAmazonValueProps'), _vm._v(" "), _c('StepOwnYourAudience')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-block-text product-block-element-left"
  }, [_c('div', {
    staticClass: "product-title"
  }, [_vm._v("MikMak Attach")]), _vm._v(" "), _c('div', {
    staticClass: "patent-badge"
  }, [_vm._v("Patent Pending")]), _vm._v(" "), _c('div', {
    staticClass: "product-subtitle"
  }, [_vm._v("Attach makes your media shoppable. It lives after \"the click\" or \"swipe up\" in digital and social channels.")])])
}]}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mikmak-site"
    }
  }, [_c('Header'), _vm._v(" "), _c('HeroContent'), _vm._v(" "), _c('PartnersHero'), _vm._v(" "), _c('MikMakAttach'), _vm._v(" "), _c('WhyMikMak'), _vm._v(" "), _c('Services'), _vm._v(" "), _c('Solutions'), _vm._v(" "), _c('Press'), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('CookieBanner')], 1)
},staticRenderFns: []}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_vm._v("\n  " + _vm._s(_vm.page) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-element",
    attrs: {
      "id": "header-element scrolled"
    }
  }, [_c('span', {
    staticClass: "header-logo"
  }, [_c('img', {
    staticClass: "header-logo-img",
    attrs: {
      "src": __webpack_require__(51),
      "alt": "mikmak.tv"
    },
    on: {
      "click": _vm.goHome
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "header-items"
  }, [_c('span', {
    staticClass: "header-links",
    class: [_vm.mobileMenuVisible ? 'mobile-menu-links-visible' : 'mobile-menu-links-hidden']
  }, [_c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('#our-software')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("Software")])]), _vm._v(" "), _c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('#our-solutions')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("Solutions")])]), _vm._v(" "), _c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('#our-services')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("Services")])]), _vm._v(" "), _c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('careers')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("Careers")])]), _vm._v(" "), _c('label', {
    staticClass: "link-label"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('about')
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = false
      }
    }
  }, [_vm._v("About")])])]), _vm._v(" "), _c('a', {
    staticClass: "header-contact",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": function($event) {
        return _vm.getDemoEvent()
      }
    }
  }, [_vm._v("\n      Contact\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "header-menu-bars",
    class: [_vm.mobileMenuVisible ? 'mobile-menu-visible' : 'mobile-menu-hidden'],
    on: {
      "click": function($event) {
        _vm.mobileMenuVisible = !_vm.mobileMenuVisible
      }
    }
  }, [_c('label', {
    staticClass: "header-menu-bar header-menu-bar-left"
  }), _vm._v(" "), _c('label', {
    staticClass: "header-menu-bar header-menu-bar-right"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "get-demo-fixed-mobile",
    class: [_vm.showGetDemo ? 'get-demo-visible' : 'get-demo-hidden'],
    attrs: {
      "href": "#contact-footer"
    }
  }, [_vm._v("\n    Get a Demo\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "svg-blob-one",
    attrs: {
      "width": "600",
      "height": "600",
      "viewBox": "0 0 600 600",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(300,300)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M86.6,-85.1C124.7,-91.6,176.5,-82.9,196.5,-55.7C216.5,-28.5,204.8,17.1,184.1,53.3C163.4,89.6,133.7,116.4,101.5,129.6C69.4,142.8,34.7,142.4,15.9,120.6C-2.9,98.7,-5.9,55.4,-49.6,46C-93.4,36.5,-177.9,60.9,-223.7,43.5C-269.5,26.2,-276.4,-33,-244.5,-63.5C-212.7,-94,-141.9,-96,-94.7,-86.4C-47.4,-76.9,-23.7,-56,0.3,-56.4C24.3,-56.8,48.6,-78.5,86.6,-85.1Z",
      "fill": "#FFFFFF"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeaderBar'), _vm._v(" "), _c('Security'), _vm._v(" "), _c('FooterBar')], 1)
},staticRenderFns: []}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeaderBar'), _vm._v(" "), _c('RetailPartners'), _vm._v(" "), _c('FooterBar')], 1)
},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item"
  }, [_c('ProductDetailsComponent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.product.align == 'left'),
      expression: "product.align == 'left'"
    }],
    staticClass: "force-mobile",
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), _c('ProductImageComponent', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), _c('ProductDetailsComponent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.product.align == 'right'),
      expression: "product.align == 'right'"
    }],
    staticClass: "hide-mobile",
    attrs: {
      "product": _vm.product
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-text rellax",
    attrs: {
      "data-rellax-speed": "1"
    }
  }, [_c('span', {
    staticClass: "main-header-headline"
  }, [_vm._v(_vm._s(_vm.headerText))]), _vm._v(" "), _c('span', {
    staticClass: "main-header-body"
  }, [_vm._v(_vm._s(_vm.subheaderText))])]), _vm._v(" "), _c('div', {
    staticClass: "header-logos"
  }, _vm._l((_vm.logos), function(brand) {
    return _c('img', {
      staticClass: "header-brand-logo",
      attrs: {
        "src": _vm.getImgUrl(brand)
      }
    })
  }), 0)]), _vm._v(" "), _vm._l((_vm.pageData.demos), function(demo) {
    return _c('div', {
      staticClass: "vertical-page-demo-block",
      style: (("background-color: " + (demo.backgroundColor)))
    }, [(demo.orientation == 'left') ? _c('span', {
      staticClass: "vertical-inline-element"
    }, [_c('PhoneAndVideoComponent', {
      attrs: {
        "demo": demo
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "vertical-inline-element desktop-element vertical-element-details"
    }, [_c('div', {
      staticClass: "vertical-attach-type-used"
    }, [_vm._v("\n        Attach "), _c('span', {
      class: ("attach-product-badge badge-for-" + (demo.attachProduct))
    }, [_vm._v(_vm._s(demo.attachProduct))])]), _vm._v(" "), _c('div', {
      staticClass: "vertical-element-headline",
      domProps: {
        "innerHTML": _vm._s(demo.headline)
      }
    }), _vm._v(" "), _vm._l((demo.text), function(textItem) {
      return _c('div', {
        staticClass: "vertical-element-text",
        domProps: {
          "innerHTML": _vm._s(textItem)
        }
      })
    }), _vm._v(" "), _c('ul', {
      staticClass: "vertical-element-text"
    }, _vm._l((demo.bullets), function(bullet) {
      return _c('li', {
        staticClass: "vertical-element-bullet",
        domProps: {
          "innerHTML": _vm._s(bullet)
        }
      })
    }), 0), _vm._v(" "), _c('a', {
      staticClass: "attach-item-request-demo-button",
      attrs: {
        "href": "#contact-footer"
      },
      on: {
        "click": function($event) {
          return _vm.clickedRequestDemoButton(demo)
        }
      }
    }, [_vm._v("Request a demo")])], 2), _vm._v(" "), (demo.orientation == 'right') ? _c('span', {
      staticClass: "vertical-inline-element"
    }, [_c('PhoneAndVideoComponent', {
      attrs: {
        "demo": demo
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "vertical-inline-element mobile-element vertical-element-details"
    }, [_c('div', {
      staticClass: "vertical-attach-type-used"
    }, [_vm._v("\n        Attach "), _c('span', {
      class: ("attach-product-badge badge-for-" + (demo.attachProduct))
    }, [_vm._v(_vm._s(demo.attachProduct))])]), _vm._v(" "), _c('div', {
      staticClass: "vertical-element-headline",
      domProps: {
        "innerHTML": _vm._s(demo.headline)
      }
    }), _vm._v(" "), _vm._l((demo.text), function(textItem) {
      return _c('div', {
        staticClass: "vertical-element-text",
        domProps: {
          "innerHTML": _vm._s(textItem)
        }
      })
    }), _vm._v(" "), _c('a', {
      staticClass: "attach-item-request-demo-button",
      attrs: {
        "href": "#contact-footer"
      },
      on: {
        "click": function($event) {
          return _vm.clickedRequestDemoButton(demo)
        }
      }
    }, [_vm._v("Request a demo")])], 2)])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-logos"
  }, [_c('div', {
    staticClass: "our-press",
    attrs: {
      "id": "our-press"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "press-heading"
  }, [_vm._v("What the world is saying")]), _vm._v(" "), _c('span', {
    staticClass: "press-logos"
  }, _vm._l((_vm.pressContent.list), function(pressCompany, index) {
    return (index < _vm.maxImages) ? _c('a', {
      attrs: {
        "href": pressCompany.url,
        "target": "new"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getPressImageLogo(pressCompany.name),
        "alt": "press"
      }
    })]) : _vm._e()
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-block-inner step-two"
  }, [_c('span', {
    staticClass: "product-block-span step-two-top-margin step-two-text"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }), _vm._v(" "), _c('DemoButton', {
    attrs: {
      "buttonMessage": 'Software, Use Attach'
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "product-block-span step-two-images animated"
  }, [_c('img', {
    staticClass: "phone-image player-attach-content",
    attrs: {
      "src": __webpack_require__(20)
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "phone-image-inner",
    attrs: {
      "src": "https://s3.amazonaws.com/attach-videos/7bhucfwTouiPY0o6lbn5_vertical-demos-480-sm.mov",
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "grnhse_app"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "demo-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.getDemoEvent
    }
  }, [_vm._v("Get a demo")])
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('SubHeader', {
    attrs: {
      "page": _vm.page
    }
  }), _vm._v(" "), _c('CareersContent')], 1)
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeaderBar'), _vm._v(" "), _c('Careers'), _vm._v(" "), _c('FooterBar')], 1)
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form footer-wrapper"
  }, [(!_vm.hideFooterPadding) ? _c('div', {
    attrs: {
      "id": "contact-footer"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer-padding"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formIsSubmitted),
      expression: "!formIsSubmitted"
    }],
    staticClass: "contact-form-inputs"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.headerText))]), _vm._v(" "), _c('h3', {
    staticClass: "sub-heading"
  }, [_vm._v("Fill out the form below, send a message to hola at mikmak dot tv, or give us a ring at 1-844-645-6251")]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress),
      expression: "emailAddress"
    }],
    staticClass: "input-element",
    attrs: {
      "id": "contact-form-email-address",
      "type": "email",
      "name": "email",
      "placeholder": "Email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "company",
      "placeholder": "Company name",
      "required": ""
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.website),
      expression: "website"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "website",
      "placeholder": "Company website",
      "required": ""
    },
    domProps: {
      "value": (_vm.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.website = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Your message",
      "required": ""
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formError),
      expression: "formError"
    }],
    staticClass: "contact-form-error",
    domProps: {
      "innerHTML": _vm._s(_vm.formError)
    }
  }), _vm._v(" "), (!_vm.submitInProgress) ? _c('button', {
    staticClass: "form-button",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.userClickedSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), (_vm.submitInProgress) ? _c('button', {
    staticClass: "form-button form-button-progress",
    attrs: {
      "type": "button",
      "name": "button"
    }
  }, [_vm._v("Submitting "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formIsSubmitted),
      expression: "formIsSubmitted"
    }],
    staticClass: "contact-form-success"
  }, [_vm._v("\n      Thanks for reaching out!"), _c('br'), _vm._v(" We'll be in touch soon.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(44),
      "alt": "MikMak"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-links"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('#our-software')
    }
  }, [_vm._v("Software")]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getLink('careers')
    }
  }, [_vm._v("Careers")]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getLink('about')
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getLink('privacy')
    }
  }, [_vm._v("Privacy policy")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "footer-copyright"
  }, [_vm._v("© 2015-" + _vm._s(_vm.currentYear) + " TIPO Entertainment, Inc.")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "footer-social-icons"
  }, [_c('a', {
    attrs: {
      "href": "https://instagram.com/MikMakTV/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/MikMakdotTV",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/mikmaktv",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCGT0qpoynvsBolIES_xAr0w",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inc-500"
  }, [_c('a', {
    attrs: {
      "href": "https://www.inc.com/profile/mikmak",
      "target": "new"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "alt": "Inc 500"
    }
  })])])
}]}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('SubHeader', {
    attrs: {
      "page": _vm.currentRole.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "open-position-content"
  }, [_c('div', {
    staticClass: "open-position-content-desc block-el"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentRole.description)
    }
  }), _vm._v(" "), _vm._l((_vm.currentRole.sections), function(section) {
    return _c('div', {
      staticClass: "open-position-content-sections"
    }, [_c('div', {
      staticClass: "open-position-content-section-heading"
    }, [_vm._v("\n          " + _vm._s(section.heading) + "\n        ")]), _vm._v(" "), (section.textContent) ? _c('div', {
      staticClass: "open-position-content-section-content",
      domProps: {
        "innerHTML": _vm._s(section.textContent)
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((section.bullets), function(bullet) {
      return _c('span', {
        staticClass: "open-position-content-section-content-bullet"
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (bullet.type == 'heading'),
          expression: "bullet.type == 'heading'"
        }],
        staticClass: "bullet-heading"
      }, [_vm._v(_vm._s(bullet.content))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (bullet.type == 'bullet'),
          expression: "bullet.type == 'bullet'"
        }],
        staticClass: "bullet-list-item"
      }, [_c('i', {
        staticClass: "fa fa-circle-thin"
      }), _vm._v(" "), _c('label', [_vm._v(_vm._s(bullet.content))])])])
    })], 2)
  }), _vm._v(" "), _c('a', {
    staticClass: "apply-now-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.resetScroll
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _c('div', {
    staticClass: "apply-now-text"
  }, [_vm._v("\n        Apply now by filling out our contact form, or send an email to hola at mikmak dot tv\n      ")])], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-wrapper"
  }, [_c('svg', {
    staticClass: "svg-blob-hero",
    attrs: {
      "width": "600",
      "height": "600",
      "viewBox": "0 0 600 600",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(300,300)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M93.5,-127C139.9,-94.9,209.3,-92.7,221.5,-68.8C233.6,-44.8,188.6,0.9,152.4,30C116.1,59.2,88.6,71.6,64.7,104.4C40.8,137.1,20.4,190,-15.8,211.8C-51.9,233.5,-103.8,223.9,-145.4,196.9C-186.9,169.9,-218,125.4,-206.7,85C-195.3,44.5,-141.4,8,-109.7,-18.9C-77.9,-45.9,-68.4,-63.4,-53.8,-105.8C-39.2,-148.3,-19.6,-215.6,2,-218.3C23.5,-221,47,-159.1,93.5,-127Z",
      "fill": "#fff"
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('div', {
    staticClass: "inc-500-banner"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hero-text"
  }, [_c('h1', {
    staticClass: "hero-text-main"
  }, [_vm._v(_vm._s(_vm.heroTextMain))]), _vm._v(" "), _c('h3', {
    staticClass: "hero-text-sub"
  }, [_vm._v(_vm._s(_vm.heroTextSub))]), _vm._v(" "), _c('div', {
    staticClass: "hero-get-demo-box"
  }, [_c('input', {
    staticClass: "hero-get-demo-input",
    attrs: {
      "type": "text",
      "placeholder": "enter your email"
    },
    on: {
      "keyup": function($event) {
        return _vm.keyListener($event)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "hero-get-demo-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.getDemoEvent
    }
  }, [_vm._v("\n        get a demo\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "phone-and-buttons"
  }, [_c('div', {
    staticClass: "hero-main-video"
  }, [(_vm.videoSrc) ? _c('video', {
    attrs: {
      "src": _vm.videoSrc,
      "playsinline": "",
      "loop": "",
      "muted": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-main-image"
  }), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "desktop-note"
  }, [_vm._v("🍾 MikMak launches Attach for alcohol eCommerce  "), _c('a', {
    attrs: {
      "href": "/alcohol"
    }
  }, [_vm._v("Learn more here. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mobile-note"
  }, [_vm._v("🍾 MikMak launches Attach for alcohol eCommerce  "), _c('a', {
    attrs: {
      "href": "/alcohol"
    }
  }, [_vm._v("Learn more here. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atc-button-image-wrapper"
  }, [_c('img', {
    staticClass: "atc-button-amazon atc-button-image",
    attrs: {
      "src": __webpack_require__(46)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "atc-button-walmart atc-button-image",
    attrs: {
      "src": __webpack_require__(48)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "atc-button-target atc-button-image",
    attrs: {
      "src": __webpack_require__(47)
    }
  })])
}]}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "our-services",
    attrs: {
      "id": "our-services"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "service-heading"
  }, [_vm._v("MikMak Services")]), _vm._v(" "), _c('Blob'), _vm._v(" "), _c('div', {
    staticClass: "service-wrapper"
  }, _vm._l((_vm.List), function(service) {
    return _c('div', {
      staticClass: "service-item-block"
    }, [_c('h1', {
      domProps: {
        "innerHTML": _vm._s(service.name)
      }
    }), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(service.text)
      }
    }), _vm._v(" "), _vm._l((service.bullets), function(bullet) {
      return _c('span', {
        staticClass: "bullet-item",
        domProps: {
          "innerHTML": _vm._s(("&middot; " + bullet))
        }
      })
    }), _vm._v(" "), (service.videoUrl) ? _c('div', {
      staticClass: "video-wrapper"
    }, [_c('img', {
      staticClass: "video-device",
      attrs: {
        "src": __webpack_require__(20)
      }
    }), _vm._v(" "), _c('video', {
      staticClass: "video-element",
      attrs: {
        "src": service.videoUrl,
        "muted": "",
        "playsinline": "",
        "autoplay": "",
        "loop": ""
      },
      domProps: {
        "muted": true
      }
    })]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#contact-footer",
        "type": "button",
        "name": "button"
      },
      domProps: {
        "innerHTML": _vm._s(service.buttonText)
      }
    })], 2)
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar",
    attrs: {
      "id": "header-bar"
    }
  }, [_c('span', {
    staticClass: "header-bar_image",
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-bar_links"
  }, [_c('button', {
    staticClass: "header-bar_link header-bar_button",
    attrs: {
      "name": "button"
    }
  }, [_vm._v("\n      Industries\n      "), _c('div', {
    staticClass: "header-bar_button-submenu"
  }, _vm._l((_vm.industries), function(industry) {
    return _c('a', {
      attrs: {
        "href": industry.link
      }
    }, [_vm._v(_vm._s(industry.title))])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "header-bar_link header-bar_button",
    attrs: {
      "name": "button"
    }
  }, [_vm._v("\n      Solutions\n      "), _c('div', {
    staticClass: "header-bar_button-submenu"
  }, _vm._l((_vm.solutions), function(solution) {
    return _c('a', {
      attrs: {
        "href": solution.link
      }
    }, [_vm._v(_vm._s(solution.title))])
  }), 0)]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link",
    attrs: {
      "href": "http://mikmak.tv#studios"
    },
    on: {
      "click": function($event) {
        return _vm.resetScroll('studios')
      }
    }
  }, [_vm._v("studios")]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link",
    attrs: {
      "href": "http://mikmak.tv#press"
    },
    on: {
      "click": function($event) {
        return _vm.resetScroll('press')
      }
    }
  }, [_vm._v("press")]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link header-bar_contact-link",
    attrs: {
      "href": "http://mikmak.tv#contact"
    },
    on: {
      "click": function($event) {
        return _vm.resetScroll('contact')
      }
    }
  }, [_vm._v("contact")])]), _vm._v(" "), _c('img', {
    staticClass: "mobile-logo",
    class: [_vm.mobileMenuVisible ? 'mobile-logo-visible' : 'mobile-logo-hidden'],
    attrs: {
      "src": __webpack_require__(45),
      "alt": "mikmak"
    },
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-toggle-mobile",
    on: {
      "click": _vm.toggleMobileMenu
    }
  }, [_c('label', {
    staticClass: "toggle-bar-top",
    class: [_vm.mobileMenuVisible ? 'top-tilt' : '']
  }), _vm._v(" "), _c('label', {
    staticClass: "toggle-bar-middle",
    class: [_vm.mobileMenuVisible ? 'middle-hidden' : '']
  }), _vm._v(" "), _c('label', {
    staticClass: "toggle-bar-bottom",
    class: [_vm.mobileMenuVisible ? 'bottom-tilt' : '']
  })]), _vm._v(" "), _c('span', {
    staticClass: "mobile-menu",
    class: [_vm.mobileMenuVisible ? 'visible' : 'hidden']
  }, [_c('button', {
    staticClass: "header-bar_link-mobile header-bar_button",
    attrs: {
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMobileIndustries = !_vm.showMobileIndustries
      }
    }
  }, [_vm._v("\n      Industries\n      "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMobileIndustries),
      expression: "showMobileIndustries"
    }],
    staticClass: "header-bar_button-mobile-submenu"
  }, _vm._l((_vm.industries), function(industry) {
    return _c('a', {
      attrs: {
        "href": industry.link
      }
    }, [_vm._v(_vm._s(industry.title))])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "header-bar_link-mobile header-bar_button",
    attrs: {
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMobileSolutions = !_vm.showMobileSolutions
      }
    }
  }, [_vm._v("\n      Solutions\n      "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMobileSolutions),
      expression: "showMobileSolutions"
    }],
    staticClass: "header-bar_button-mobile-submenu"
  }, _vm._l((_vm.solutions), function(solution) {
    return _c('a', {
      attrs: {
        "href": solution.link
      }
    }, [_vm._v(_vm._s(solution.title))])
  }), 0)]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link-mobile",
    attrs: {
      "href": "http://mikmak.tv#studios"
    },
    on: {
      "click": function($event) {
        return _vm.hideMobileMenu('studios')
      }
    }
  }, [_vm._v("studios")]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link-mobile",
    attrs: {
      "href": "http://mikmak.tv#press"
    },
    on: {
      "click": function($event) {
        return _vm.hideMobileMenu('press')
      }
    }
  }, [_vm._v("press")]), _vm._v(" "), _c('a', {
    staticClass: "header-bar_link-mobile",
    attrs: {
      "href": "http://mikmak.tv#contact"
    },
    on: {
      "click": function($event) {
        return _vm.hideMobileMenu('contact')
      }
    }
  }, [_vm._v("contact")])])])
},staticRenderFns: []}

/***/ }),
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(185);



// Enable progressive web app support (with offline-plugin)
if (true) {
  __webpack_require__(187);
}

__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ })
],[511]);


// WEBPACK FOOTER //
// client.d418462a.js